webpackJsonp([35783957827783],{

/***/ 16:
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = {
		pathPrefix: "/", //develop
		// pathPrefix: "/la-voragine", //production
		siteUrl: "https://voragine.radionacional.co",
		siteTitle: "Expedición vorágine: un recorrido sonodo por la obra de José Eustasio Rivera",
		siteTitleAlt: "Expedición vorágine",
		metaTitle: "Expedición Vorágine - Un recorrido sonoro por la obra de José Eustasio Rivera",
		metaDescription: "La vorágine es uno de los libros más emblemáticos de la literatura colombiana y, también, de los más leídos en los colegios. Sin embargo, no de los más apreciados. 'Expedición vorágine' emprende una búsqueda por reencontrar al libro con sus lectores, en un recorrido que nos llevó por 8 regiones.",
		metaKeywords: "Vorágine, libros, mapa, literatura, Huila, Neiva, Boyacá, Meta, Caquetá, Casanare, Putumayo, Guainía",
		siteLogo: "/logos/logo-1024.png",
		siteCover: "/cover.jpg",
		siteCreator: "Radnalco",
		copyright: "Copyright © 2018. RTVC Sistema de Medios Públicos",
		social: [{
			name: "Twitter",
			icon: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAFWUlEQVR4AdWbeWxU1RfHT8uvLZQfiwIuGgQFcUESUINWTVyMxiXR4JIIGlA0GBc0BqNRgzFoNMYYTIwEhbgEDVHEPwgQozGRRQXSd1+n7bSFQim01EJpbelOZ+bjm7kZSUOn85Y3rzOf5JtJmt7b+51z3733nPsqgQB5UkuRlFIsNYyzPidImP9LA2OklALJYbS5ENeI4iVLP1oKW+oXA4ZRuyj2WlonJoukigsl64mbNPlQFI1igGcp9llaLvuZLFlFGXeLYocYkBEp+i2tF4OZI210vhjssURAiojJl6KYIoFSy3hRrLUUFQMCl6JNDJ6VQKhghiiqxIARl8kGOczoTC5Kd4iiVQzIIu3JzIpu8oIYDFgi66R3hevENxTviwFZrh4p43Y/IrtEDMgJKVoTa4xrFCWW+sSAHDIdTuwijqlgqiiaxYAc1FaBfCf7bJEYKEvkrBQfOJnKb4sBOW44KiGulbSUc5kY9AY9wCsq4d0m2NoOuzv15xuNML0idZtzy9Ka3iuQly66G+0McE4Y8j0b1YPecJKU9EZh5TEoUvr3Ryt4rA5Ku2HBQVuRXjhcMjDLzvm4UEFjP3zfBgUezF4QgppebLGvCza3QVeEBHu7YJS9v1OROso6BSOd7jwASba1wxjl3Gy+pT1duKJlAGZWwlgTJpbZivIDchbxcouiy85gl9YziB2nYFKZM8PLjuCKviisPQEbW+FgH5wXsmV4y1DRXWx3sE/VD/Wt65/n2ezD6MYD2viN1ba/4NNn59CK7XYNP3yIlOzshNnh4duPN/FEZwTuOuBsRg3On6HA3nTWmmBCf5SUxGLw2yl4vG7o5/uqMK5pj8C8Klf78ib5D5ObnXawtd3+ANe3wJOHtdE8A6ZV4Jpdna53hZYzq7XJq047mFWptwindETgry5cs+UfT6eviySBYp2ThpdXwpQQLD6sp2+QfH3Sg+F40TGBwU4nDV9pgIEY/NwB4R4CZfVxT4YXJCNc56RhSQ0jxooGT0W/Z5IRbnHScJSh992RoKTGU4SXSxw3VY3njxA4vVEoVJ4i/Foywqct4TTK1l4bKDs7PefIr0sct7XmYgW/dBAYq5o8Gi7l5aThered5FlaWAfVvWQQvStMLfecfy+TOF4uxD5q1rlqZQ9EY2SMb1t9uZp5NBnhb9x2Mr86mMPH3CpfDN8kCUze9NLRFy1klO3tvhX2pp250PbQUb6lzzNk+lREJxs+mO0UGCUJmihOvoPhRffV6sTeTxbV+RbdbZJk8Hnau2aH/Znmbx3ztU69QgahWO5Hx4UKnjsCbQN4YqW/ZmNiMl0GsZ/Jzk9cWkUKbqmBj5vhxGnvtaqFdb7fQuyQITH4KV3jhw7pvfeT47DmhK5Y9kbxhV0p6mGeZbJkmLdy0q/IT9dDeQ8+ocutS5MVT/91VKBAUqL41V5Hukz61UnojrrJfPT++uDBNFc23vWiDIvieqevI40z42VTvapubtPXIPV90BHReXNjv54Rm9rgvSa4vxaKVSA3iLWJq9+0KNboRjmve8QW5ZwTn/s5fj/8nTiijHli0J2jhlXi9OgYxSOWYjkW2ebE+ymuMXgnh8z2WSrx/rK34occMBuztFh8Af4nik+z2HB34vHzHYNlyfN2FumomMyVjKG4NVm4H3Ep/pAKzpeME+JSUfw+gmYjllZLmEIJFIMnLP0dcFT/9D6FvdDAGP3vOjRk2OhuS/dK1hCfXvqgssW3hU3fiHwmIW6QrKaaSYmit2KNpUoHX0CHpV2iWCUmt+lnNBeBfDGZKGEusTRTFFdLKXOknCutzxlSxsUSYqwExL+NOU3gcOz6vgAAAABJRU5ErkJggg==",
			link: "https://twitter.com/Radnalco"
		}, {
			name: "Facebook",
			icon: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAMAAAANIilAAAACTFBMVEUAAAD///+AgICAgP9Vqv9AgL8zZswrgKokbbZJbbZAYJ85caozZrMuXaIraqonYp0kW6QzZpkwYJ8tWqUoXqEmZqYkYZ4sZKYpXKMxYp0mXqEsYZ4rXqIpY5woYJ8nXaImWp4kX6AsX6ArXKMoXqEmYJ8kW54pXZwoYJ8lWp8kXpwpXJ4oWqAnXZ0mXqElXZ4oXp0oXJ4nW6AkXZ4oXJ8nWp0nXZ4kW50nXJ8mW50nXJ0mW50kW54kWpwnXZ8lXJ4lW58kW54mXJ0mW54mXJ4mWp4mXZ4lXJ4mW50mXJ4lW50lW58lWp4lXJ8mW50lWpwlW54nXJwmXJ0kW54mXJ0lWp0kW5wmW50lW5wlW50kWpwmW50lWpwlW5wkWpwmXJ0lWp0kWp0mW5wlW5wlWp0kWpwlW50lWp0lW50lWpwlW50lWpwkW50lWp0lWp0lW50lW5wlWp0kW5wkW50kWp0lW50lWpwlW50lWp0kW50kWpwlW50lW5wkW5wlW5wkW50kWp0lW5wlW50kW50kWpwlWpwlWpwkWpwkWpwlW50lWpwlW50kW5wkWp0kW50lWpwlWp0lW5wlWpwkWp0kW5wkWp0kWpwlW5wuYaAzZaI3aKQ4aaU8bKc9bac/bqhGc6tIdaxJdq1Pe69TfbFUfrFagrRbhLVli7lpjrtqj7trj7xwk752mMF4mcJ6m8OBoMaRrM2Trs6Vr8+huNSjutW2yN63yd7B0OPC0ePJ1ubS3erY4e3a4+7f5/Du8vfy9fnz9vn4+vz+/v7///+SX5vHAAAAlnRSTlMAAQICAwQFBgcHCAkKCwwNDg8QERMUFRcZGhsdHh8gISIjIyQmKCosLTAxMjM0Njc5Ojs/QEFCRkhJTlFUVVVZWlxeX2RmZmdrbG1tbm9zdHZ3en6AgoaHiY+TlZaYm5yeoaOlp6qrrK6ytLW2u8DBwsPExcbIycrO09TV1tve4OLj5Ofo6+3u8PHz9PX29/j5+vv8/f4ZDbEiAAACSUlEQVR4AZ3S90OMcQDH8c8ZFSUZJTIkJCMZZGQoRLI3KZsMZZTISOqMok7XR7js0dl7j7h/zLmhu+f5Ps997/v6/f3bG4Ys3WJ69oqNjkCYLKn5eyob6XWxvHBuImSlbqim1vG8eEjILKFQY1EKQkgvo6GmrQkwEbfFTjMXcmEo+RRD2d4dYlOtDK0sESKLrlFG9VjoraOkK1OglUNp1mQEy2igyM3Hzqf/PGKgyjgESqqhwO1Pf1xevxhkX2d0iKqgwLN2l187g61Hh9UUuPvbZRjbx8Bv6FUKfHUZxyy3wGcnBR66zGLOgddwOwVeBcY/qXXCAo8iirzxdZ/vORyOG9SZ4Wlj6yjy1hffoVixJ86maXyLYrYEuB1Qi5kLIKJOMd4NYCL1Wtqczo+++IXT7QH1ai3Acuq1uTS+U6A/UEg9pzb+QoF0oFQm/kCBmcAZmfg9BeYDtTLxawosARqo90Qbv6TACsBGAUdr6ztfd7/V7ToFVgJWKk7CpcBZ5XghUKYczwa2KccTgFXK8SAgUzW+3AWIaVSM98OtVDFeBrc8tbh5MNzibUpxCTz2KsU58EhXiasi4HVQIV4Mn3H2sOPTUfArCDuehv/6VIUZ70CA0fVhxRUxCJTVTI3nPzy+tVCnJgnB1lBaQwY0LLsoqTkbOl03UUp9FkQW2BhaVRrEJtUylKP9YGTIIZpq2hgJE/PO09ixNJiLzj9HsSPTEVpkVrGNWtbN4yGp76yCkzb6XTq8dnIkwtKp98CUkaNGDBvQA4b+AtFacap9PUWJAAAAAElFTkSuQmCC",
			link: "https://www.facebook.com/RadioNacionalDeColombia"
		}, {
			name: "Instagram",
			icon: "data:image/png;base64,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",
			link: "https://instagram.com/radionacionalco"
		}],
		pages: [{
			name: 'capitulo',
			template: 'src/templates/chapter.js',
			pictureTemplate: 'src/templates/picture.js',
			query: '{allMarkdownRemark(filter:{frontmatter:{createPage:{ne:false}}}){edges{node{frontmatter{title,description,part,place,keywords,slug,pictureBgImage{relativePath},pictures{title,description,slug,src{relativePath}}}}}}}',
			key: 'allMarkdownRemark'
		}]
	};

/***/ }),

/***/ 291:
/***/ (function(module, exports) {

	module.exports = function(el, container, hAlign, vAlign) {
	    hAlign = (hAlign !== undefined) ? hAlign : 0.5;
	    vAlign = (vAlign !== undefined) ? vAlign : 0.5;
	
	    var elAspect, elWidth, elHeight, elPosTop, elPosLeft;
	
	    var w = container.clientWidth;
	    var h = container.clientHeight;
	    var contAspect = w / h;
	
	    if (el instanceof HTMLVideoElement) {
	      elAspect = el.videoWidth / el.videoHeight;
	    } else if (el instanceof HTMLImageElement) {
	      elAspect = (el.naturalWidth !== undefined) ? (el.naturalWidth / el.naturalHeight) : (el.width / el.height);
	    } else {
	      elAspect = el.clientWidth / el.clientHeight;
	    }
	
	    if (contAspect > elAspect) {
	      elWidth = w;
	      elHeight = w / elAspect;
	      elPosTop = -(elHeight - h) * vAlign;
	      elPosLeft = 0;
	    } else {
	      elWidth = h * elAspect;
	      elHeight = h;
	      elPosTop = 0;
	      elPosLeft = -(elWidth - w) * hAlign;
	    }
	
	    container.style.overflow = 'hidden';
	
	    el.style.position = 'absolute';
	    el.width = elWidth;
	    el.height = elHeight;
	    el.style.width = elWidth + 'px';
	    el.style.height = elHeight + 'px';
	    el.style.top = elPosTop + 'px';
	    el.style.left = elPosLeft + 'px';
	
	    return {
	      elWidth: elWidth,
	      elHeight: elHeight,
	      elPosTop: elPosTop,
	      elPosLeft: elPosLeft,
	    }
	  }

/***/ }),

/***/ 4:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2017 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg) && arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),

/***/ 34:
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(36);
	var isArguments = __webpack_require__(35);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),

/***/ 35:
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),

/***/ 36:
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),

/***/ 37:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),

/***/ 50:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(14);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(18);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(17);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _objectWithoutProperties2 = __webpack_require__(71);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(22);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Handle legacy names for image queries.
	var convertProps = function convertProps(props) {
	  var convertedProps = (0, _extends3.default)({}, props);
	  if (convertedProps.responsiveResolution) {
	    convertedProps.resolutions = convertedProps.responsiveResolution;
	    delete convertedProps.responsiveResolution;
	  }
	  if (convertedProps.responsiveSizes) {
	    convertedProps.sizes = convertedProps.responsiveSizes;
	    delete convertedProps.responsiveSizes;
	  }
	
	  return convertedProps;
	};
	
	// Cache if we've seen an image before so we don't both with
	// lazy-loading & fading in on subsequent mounts.
	var imageCache = {};
	var inImageCache = function inImageCache(props) {
	  var convertedProps = convertProps(props);
	  // Find src
	  var src = convertedProps.sizes ? convertedProps.sizes.src : convertedProps.resolutions.src;
	
	  if (imageCache[src]) {
	    return true;
	  } else {
	    imageCache[src] = true;
	    return false;
	  }
	};
	
	var io = void 0;
	var listeners = [];
	
	function getIO() {
	  if (typeof io === "undefined" && typeof window !== "undefined" && window.IntersectionObserver) {
	    io = new window.IntersectionObserver(function (entries) {
	      entries.forEach(function (entry) {
	        listeners.forEach(function (l) {
	          if (l[0] === entry.target) {
	            // Edge doesn't currently support isIntersecting, so also test for an intersectionRatio > 0
	            if (entry.isIntersecting || entry.intersectionRatio > 0) {
	              io.unobserve(l[0]);
	              l[1]();
	            }
	          }
	        });
	      });
	    }, { rootMargin: "200px" });
	  }
	
	  return io;
	}
	
	var listenToIntersections = function listenToIntersections(el, cb) {
	  getIO().observe(el);
	  listeners.push([el, cb]);
	};
	
	var isWebpSupportedCache = null;
	var isWebpSupported = function isWebpSupported() {
	  if (isWebpSupportedCache !== null) {
	    return isWebpSupportedCache;
	  }
	
	  var elem = typeof window !== "undefined" ? window.document.createElement("canvas") : {};
	  if (elem.getContext && elem.getContext("2d")) {
	    isWebpSupportedCache = elem.toDataURL("image/webp").indexOf("data:image/webp") === 0;
	  } else {
	    isWebpSupportedCache = false;
	  }
	
	  return isWebpSupportedCache;
	};
	
	var noscriptImg = function noscriptImg(props) {
	  // Check if prop exists before adding each attribute to the string output below to prevent
	  // HTML validation issues caused by empty values like width="" and height=""
	  var src = props.src ? "src=\"" + props.src + "\" " : "src=\"\" "; // required attribute
	  var srcSet = props.srcSet ? "srcset=\"" + props.srcSet + "\" " : "";
	  var sizes = props.sizes ? "sizes=\"" + props.sizes + "\" " : "";
	  var title = props.title ? "title=\"" + props.title + "\" " : "";
	  var alt = props.alt ? "alt=\"" + props.alt + "\" " : "alt=\"\" "; // required attribute
	  var width = props.width ? "width=\"" + props.width + "\" " : "";
	  var height = props.height ? "height=\"" + props.height + "\" " : "";
	  var opacity = props.opacity ? props.opacity : "1";
	  var transitionDelay = props.transitionDelay ? props.transitionDelay : "0.5s";
	
	  return "<img " + width + height + src + srcSet + alt + title + sizes + "style=\"position:absolute;top:0;left:0;transition:opacity 0.5s;transition-delay:" + transitionDelay + ";opacity:" + opacity + ";width:100%;height:100%;object-fit:cover;object-position:center\"/>";
	};
	
	var Img = function Img(props) {
	  var style = props.style,
	      onLoad = props.onLoad,
	      otherProps = (0, _objectWithoutProperties3.default)(props, ["style", "onLoad"]);
	
	  return _react2.default.createElement("img", (0, _extends3.default)({}, otherProps, {
	    onLoad: onLoad,
	    style: (0, _extends3.default)({
	      position: "absolute",
	      top: 0,
	      left: 0,
	      transition: "opacity 0.5s",
	      width: "100%",
	      height: "100%",
	      objectFit: "cover",
	      objectPosition: "center"
	    }, style)
	  }));
	};
	
	Img.propTypes = {
	  style: _propTypes2.default.object,
	  onLoad: _propTypes2.default.func
	};
	
	var Image = function (_React$Component) {
	  (0, _inherits3.default)(Image, _React$Component);
	
	  function Image(props) {
	    (0, _classCallCheck3.default)(this, Image);
	
	    // If this browser doesn't support the IntersectionObserver API
	    // we default to start downloading the image right away.
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));
	
	    var isVisible = true;
	    var imgLoaded = true;
	    var IOSupported = false;
	
	    // If this image has already been loaded before then we can assume it's
	    // already in the browser cache so it's cheap to just show directly.
	    var seenBefore = inImageCache(props);
	
	    if (!seenBefore && typeof window !== "undefined" && window.IntersectionObserver) {
	      isVisible = false;
	      imgLoaded = false;
	      IOSupported = true;
	    }
	
	    // Always don't render image while server rendering
	    if (typeof window === "undefined") {
	      isVisible = false;
	      imgLoaded = false;
	    }
	
	    _this.state = {
	      isVisible: isVisible,
	      imgLoaded: imgLoaded,
	      IOSupported: IOSupported
	    };
	
	    _this.handleRef = _this.handleRef.bind(_this);
	    return _this;
	  }
	
	  Image.prototype.handleRef = function handleRef(ref) {
	    var _this2 = this;
	
	    if (this.state.IOSupported && ref) {
	      listenToIntersections(ref, function () {
	        _this2.setState({ isVisible: true, imgLoaded: false });
	      });
	    }
	  };
	
	  Image.prototype.render = function render() {
	    var _this3 = this;
	
	    var _convertProps = convertProps(this.props),
	        title = _convertProps.title,
	        alt = _convertProps.alt,
	        className = _convertProps.className,
	        outerWrapperClassName = _convertProps.outerWrapperClassName,
	        _convertProps$style = _convertProps.style,
	        style = _convertProps$style === undefined ? {} : _convertProps$style,
	        _convertProps$imgStyl = _convertProps.imgStyle,
	        imgStyle = _convertProps$imgStyl === undefined ? {} : _convertProps$imgStyl,
	        _convertProps$placeho = _convertProps.placeholderStyle,
	        placeholderStyle = _convertProps$placeho === undefined ? {} : _convertProps$placeho,
	        sizes = _convertProps.sizes,
	        resolutions = _convertProps.resolutions,
	        backgroundColor = _convertProps.backgroundColor,
	        Tag = _convertProps.Tag;
	
	    var bgColor = void 0;
	    if (typeof backgroundColor === "boolean") {
	      bgColor = "lightgray";
	    } else {
	      bgColor = backgroundColor;
	    }
	
	    var imagePlaceholderStyle = (0, _extends3.default)({
	      opacity: this.state.imgLoaded ? 0 : 1,
	      transitionDelay: "0.25s"
	    }, imgStyle, placeholderStyle);
	
	    var imageStyle = (0, _extends3.default)({
	      opacity: this.state.imgLoaded || this.props.fadeIn === false ? 1 : 0
	    }, imgStyle);
	
	    if (sizes) {
	      var image = sizes;
	
	      // Use webp by default if browser supports it
	      if (image.srcWebp && image.srcSetWebp && isWebpSupported()) {
	        image.src = image.srcWebp;
	        image.srcSet = image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        Tag,
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          Tag,
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: (0, _extends3.default)({
	              position: "relative",
	              overflow: "hidden"
	            }, style),
	            ref: this.handleRef
	          },
	          _react2.default.createElement(Tag, {
	            style: {
	              width: "100%",
	              paddingBottom: 100 / image.aspectRatio + "%"
	            }
	          }),
	          image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.base64,
	            style: imagePlaceholderStyle
	          }),
	          image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.tracedSVG,
	            style: imagePlaceholderStyle
	          }),
	          bgColor && _react2.default.createElement(Tag, {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              position: "absolute",
	              top: 0,
	              bottom: 0,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.35s",
	              right: 0,
	              left: 0
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            srcSet: image.srcSet,
	            src: image.src,
	            sizes: image.sizes,
	            style: imageStyle,
	            onLoad: function onLoad() {
	              _this3.state.IOSupported && _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({ alt: alt, title: title }, image))
	            }
	          })
	        )
	      );
	    }
	
	    if (resolutions) {
	      var _image = resolutions;
	      var divStyle = (0, _extends3.default)({
	        position: "relative",
	        overflow: "hidden",
	        display: "inline-block",
	        width: _image.width,
	        height: _image.height
	      }, style);
	
	      if (style.display === "inherit") {
	        delete divStyle.display;
	      }
	
	      // Use webp by default if browser supports it
	      if (_image.srcWebp && _image.srcSetWebp && isWebpSupported()) {
	        _image.src = _image.srcWebp;
	        _image.srcSet = _image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        Tag,
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          Tag,
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: divStyle,
	            ref: this.handleRef
	          },
	          _image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.base64,
	            style: imagePlaceholderStyle
	          }),
	          _image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.tracedSVG,
	            style: imagePlaceholderStyle
	          }),
	          bgColor && _react2.default.createElement(Tag, {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              width: _image.width,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.25s",
	              height: _image.height
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            width: _image.width,
	            height: _image.height,
	            srcSet: _image.srcSet,
	            src: _image.src,
	            style: imageStyle,
	            onLoad: function onLoad() {
	              _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({
	                alt: alt,
	                title: title,
	                width: _image.width,
	                height: _image.height
	              }, _image))
	            }
	          })
	        )
	      );
	    }
	
	    return null;
	  };
	
	  return Image;
	}(_react2.default.Component);
	
	Image.defaultProps = {
	  fadeIn: true,
	  alt: "",
	  Tag: "div"
	};
	
	Image.propTypes = {
	  responsiveResolution: _propTypes2.default.object,
	  responsiveSizes: _propTypes2.default.object,
	  resolutions: _propTypes2.default.object,
	  sizes: _propTypes2.default.object,
	  fadeIn: _propTypes2.default.bool,
	  title: _propTypes2.default.string,
	  alt: _propTypes2.default.string,
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]), // Support Glamor's css prop.
	  outerWrapperClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  style: _propTypes2.default.object,
	  imgStyle: _propTypes2.default.object,
	  placeholderStyle: _propTypes2.default.object,
	  position: _propTypes2.default.string,
	  backgroundColor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
	  onLoad: _propTypes2.default.func,
	  Tag: _propTypes2.default.string
	};
	
	exports.default = Image;

/***/ }),

/***/ 629:
/***/ (function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(1));
		else if(typeof define === 'function' && define.amd)
			define(["react"], factory);
		else if(typeof exports === 'object')
			exports["anchor-link"] = factory(require("react"));
		else
			root["anchor-link"] = factory(root["react"]);
	})(this, function(__WEBPACK_EXTERNAL_MODULE_2__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _anchorLink = __webpack_require__(1);
	
	var _anchorLink2 = _interopRequireDefault(_anchorLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _anchorLink2.default;
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AnchorLink = function (_Component) {
	  _inherits(AnchorLink, _Component);
	
	  function AnchorLink(props) {
	    _classCallCheck(this, AnchorLink);
	
	    var _this = _possibleConstructorReturn(this, (AnchorLink.__proto__ || Object.getPrototypeOf(AnchorLink)).call(this, props));
	
	    _this.smoothScroll = _this.smoothScroll.bind(_this);
	    return _this;
	  }
	
	  _createClass(AnchorLink, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      __webpack_require__(3).polyfill();
	    }
	  }, {
	    key: 'smoothScroll',
	    value: function smoothScroll(e) {
	      var _this2 = this;
	
	      e.preventDefault();
	      var offset = function offset() {
	        return 0;
	      };
	      if (typeof this.props.offset !== 'undefined') {
	        if (!!(this.props.offset && this.props.offset.constructor && this.props.offset.apply)) {
	          offset = this.props.offset;
	        } else {
	          offset = function offset() {
	            return parseInt(_this2.props.offset);
	          };
	        }
	      }
	      var id = e.currentTarget.getAttribute('href').slice(1);
	      window.scroll({
	        top: document.getElementById(id).offsetTop - offset(),
	        behavior: 'smooth'
	      });
	      if (this.props.onClick) {
	        this.props.onClick(e);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          offset = _props.offset,
	          rest = _objectWithoutProperties(_props, ['offset']);
	
	      return _react2.default.createElement('a', _extends({}, rest, { onClick: this.smoothScroll }));
	    }
	  }]);
	
	  return AnchorLink;
	}(_react.Component);
	
	exports.default = AnchorLink;
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_2__;
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports, __webpack_require__) {
	
	/* smoothscroll v0.4.0 - 2017 - Dustan Kasten, Jeremias Menichelli - MIT License */
	(function () {
	  'use strict';
	
	  /*
	   * aliases
	   * w: window global object
	   * d: document
	   */
	  var w = window;
	  var d = document;
	
	  /**
	   * indicates if a the current browser is made by Microsoft
	   * @method isMicrosoftBrowser
	   * @param {String} userAgent
	   * @returns {Boolean}
	   */
	  function isMicrosoftBrowser(userAgent) {
	    var userAgentPatterns = ['MSIE ', 'Trident/', 'Edge/'];
	
	    return new RegExp(userAgentPatterns.join('|')).test(userAgent);
	  }
	
	   // polyfill
	  function polyfill() {
	    // return if scroll behavior is supported and polyfill is not forced
	    if ('scrollBehavior' in d.documentElement.style
	      && w.__forceSmoothScrollPolyfill__ !== true) {
	      return;
	    }
	
	    // globals
	    var Element = w.HTMLElement || w.Element;
	    var SCROLL_TIME = 468;
	
	    /*
	     * IE has rounding bug rounding down clientHeight and clientWidth and
	     * rounding up scrollHeight and scrollWidth causing false positives
	     * on hasScrollableSpace
	     */
	    var ROUNDING_TOLERANCE = isMicrosoftBrowser(w.navigator.userAgent) ? 1 : 0;
	
	    // object gathering original scroll methods
	    var original = {
	      scroll: w.scroll || w.scrollTo,
	      scrollBy: w.scrollBy,
	      elementScroll: Element.prototype.scroll || scrollElement,
	      scrollIntoView: Element.prototype.scrollIntoView
	    };
	
	    // define timing method
	    var now = w.performance && w.performance.now
	      ? w.performance.now.bind(w.performance)
	      : Date.now;
	
	    /**
	     * changes scroll position inside an element
	     * @method scrollElement
	     * @param {Number} x
	     * @param {Number} y
	     * @returns {undefined}
	     */
	    function scrollElement(x, y) {
	      this.scrollLeft = x;
	      this.scrollTop = y;
	    }
	
	    /**
	     * returns result of applying ease math function to a number
	     * @method ease
	     * @param {Number} k
	     * @returns {Number}
	     */
	    function ease(k) {
	      return 0.5 * (1 - Math.cos(Math.PI * k));
	    }
	
	    /**
	     * indicates if a smooth behavior should be applied
	     * @method shouldBailOut
	     * @param {Number|Object} firstArg
	     * @returns {Boolean}
	     */
	    function shouldBailOut(firstArg) {
	      if (firstArg === null
	        || typeof firstArg !== 'object'
	        || firstArg.behavior === undefined
	        || firstArg.behavior === 'auto'
	        || firstArg.behavior === 'instant') {
	        // first argument is not an object/null
	        // or behavior is auto, instant or undefined
	        return true;
	      }
	
	      if (typeof firstArg === 'object' && firstArg.behavior === 'smooth') {
	        // first argument is an object and behavior is smooth
	        return false;
	      }
	
	      // throw error when behavior is not supported
	      throw new TypeError(
	        'behavior member of ScrollOptions '
	        + firstArg.behavior
	        + ' is not a valid value for enumeration ScrollBehavior.'
	      );
	    }
	
	    /**
	     * indicates if an element has scrollable space in the provided axis
	     * @method hasScrollableSpace
	     * @param {Node} el
	     * @param {String} axis
	     * @returns {Boolean}
	     */
	    function hasScrollableSpace(el, axis) {
	      if (axis === 'Y') {
	        return (el.clientHeight + ROUNDING_TOLERANCE) < el.scrollHeight;
	      }
	
	      if (axis === 'X') {
	        return (el.clientWidth + ROUNDING_TOLERANCE) < el.scrollWidth;
	      }
	    }
	
	    /**
	     * indicates if an element has a scrollable overflow property in the axis
	     * @method canOverflow
	     * @param {Node} el
	     * @param {String} axis
	     * @returns {Boolean}
	     */
	    function canOverflow(el, axis) {
	      var overflowValue = w.getComputedStyle(el, null)['overflow' + axis];
	
	      return overflowValue === 'auto' || overflowValue === 'scroll';
	    }
	
	    /**
	     * indicates if an element can be scrolled in either axis
	     * @method isScrollable
	     * @param {Node} el
	     * @param {String} axis
	     * @returns {Boolean}
	     */
	    function isScrollable(el) {
	      var isScrollableY = hasScrollableSpace(el, 'Y') && canOverflow(el, 'Y');
	      var isScrollableX = hasScrollableSpace(el, 'X') && canOverflow(el, 'X');
	
	      return isScrollableY || isScrollableX;
	    }
	
	    /**
	     * finds scrollable parent of an element
	     * @method findScrollableParent
	     * @param {Node} el
	     * @returns {Node} el
	     */
	    function findScrollableParent(el) {
	      var isBody;
	
	      do {
	        el = el.parentNode;
	
	        isBody = el === d.body;
	      } while (isBody === false && isScrollable(el) === false);
	
	      isBody = null;
	
	      return el;
	    }
	
	    /**
	     * self invoked function that, given a context, steps through scrolling
	     * @method step
	     * @param {Object} context
	     * @returns {undefined}
	     */
	    function step(context) {
	      var time = now();
	      var value;
	      var currentX;
	      var currentY;
	      var elapsed = (time - context.startTime) / SCROLL_TIME;
	
	      // avoid elapsed times higher than one
	      elapsed = elapsed > 1 ? 1 : elapsed;
	
	      // apply easing to elapsed time
	      value = ease(elapsed);
	
	      currentX = context.startX + (context.x - context.startX) * value;
	      currentY = context.startY + (context.y - context.startY) * value;
	
	      context.method.call(context.scrollable, currentX, currentY);
	
	      // scroll more if we have not reached our destination
	      if (currentX !== context.x || currentY !== context.y) {
	        w.requestAnimationFrame(step.bind(w, context));
	      }
	    }
	
	    /**
	     * scrolls window or element with a smooth behavior
	     * @method smoothScroll
	     * @param {Object|Node} el
	     * @param {Number} x
	     * @param {Number} y
	     * @returns {undefined}
	     */
	    function smoothScroll(el, x, y) {
	      var scrollable;
	      var startX;
	      var startY;
	      var method;
	      var startTime = now();
	
	      // define scroll context
	      if (el === d.body) {
	        scrollable = w;
	        startX = w.scrollX || w.pageXOffset;
	        startY = w.scrollY || w.pageYOffset;
	        method = original.scroll;
	      } else {
	        scrollable = el;
	        startX = el.scrollLeft;
	        startY = el.scrollTop;
	        method = scrollElement;
	      }
	
	      // scroll looping over a frame
	      step({
	        scrollable: scrollable,
	        method: method,
	        startTime: startTime,
	        startX: startX,
	        startY: startY,
	        x: x,
	        y: y
	      });
	    }
	
	    // ORIGINAL METHODS OVERRIDES
	    // w.scroll and w.scrollTo
	    w.scroll = w.scrollTo = function() {
	      // avoid action when no arguments are passed
	      if (arguments[0] === undefined) {
	        return;
	      }
	
	      // avoid smooth behavior if not required
	      if (shouldBailOut(arguments[0]) === true) {
	        original.scroll.call(
	          w,
	          arguments[0].left !== undefined
	            ? arguments[0].left
	            : typeof arguments[0] !== 'object'
	              ? arguments[0]
	              : (w.scrollX || w.pageXOffset),
	          // use top prop, second argument if present or fallback to scrollY
	          arguments[0].top !== undefined
	            ? arguments[0].top
	            : arguments[1] !== undefined
	              ? arguments[1]
	              : (w.scrollY || w.pageYOffset)
	        );
	
	        return;
	      }
	
	      // LET THE SMOOTHNESS BEGIN!
	      smoothScroll.call(
	        w,
	        d.body,
	        arguments[0].left !== undefined
	          ? ~~arguments[0].left
	          : (w.scrollX || w.pageXOffset),
	        arguments[0].top !== undefined
	          ? ~~arguments[0].top
	          : (w.scrollY || w.pageYOffset)
	      );
	    };
	
	    // w.scrollBy
	    w.scrollBy = function() {
	      // avoid action when no arguments are passed
	      if (arguments[0] === undefined) {
	        return;
	      }
	
	      // avoid smooth behavior if not required
	      if (shouldBailOut(arguments[0])) {
	        original.scrollBy.call(
	          w,
	          arguments[0].left !== undefined
	            ? arguments[0].left
	            : typeof arguments[0] !== 'object'
	              ? arguments[0]
	              : 0,
	          arguments[0].top !== undefined
	            ? arguments[0].top
	            : arguments[1] !== undefined
	             ? arguments[1]
	             : 0
	        );
	
	        return;
	      }
	
	      // LET THE SMOOTHNESS BEGIN!
	      smoothScroll.call(
	        w,
	        d.body,
	        ~~arguments[0].left + (w.scrollX || w.pageXOffset),
	        ~~arguments[0].top + (w.scrollY || w.pageYOffset)
	      );
	    };
	
	    // Element.prototype.scroll and Element.prototype.scrollTo
	    Element.prototype.scroll = Element.prototype.scrollTo = function() {
	      // avoid action when no arguments are passed
	      if (arguments[0] === undefined) {
	        return;
	      }
	
	      // avoid smooth behavior if not required
	      if (shouldBailOut(arguments[0]) === true) {
	        // if one number is passed, throw error to match Firefox implementation
	        if (typeof arguments[0] === 'number' && arguments[1] === undefined) {
	          throw new SyntaxError('Value couldn\'t be converted');
	        }
	
	        original.elementScroll.call(
	          this,
	          // use left prop, first number argument or fallback to scrollLeft
	          arguments[0].left !== undefined
	            ? ~~arguments[0].left
	            : typeof arguments[0] !== 'object'
	              ? ~~arguments[0]
	              : this.scrollLeft,
	          // use top prop, second argument or fallback to scrollTop
	          arguments[0].top !== undefined
	            ? ~~arguments[0].top
	            : arguments[1] !== undefined
	              ? ~~arguments[1]
	              : this.scrollTop
	        );
	
	        return;
	      }
	
	      var left = arguments[0].left;
	      var top = arguments[0].top;
	
	      // LET THE SMOOTHNESS BEGIN!
	      smoothScroll.call(
	        this,
	        this,
	        typeof left === 'undefined' ? this.scrollLeft : ~~left,
	        typeof top === 'undefined' ? this.scrollTop : ~~top
	      );
	    };
	
	    // Element.prototype.scrollBy
	    Element.prototype.scrollBy = function() {
	      // avoid action when no arguments are passed
	      if (arguments[0] === undefined) {
	        return;
	      }
	
	      // avoid smooth behavior if not required
	      if (shouldBailOut(arguments[0]) === true) {
	        original.elementScroll.call(
	          this,
	          arguments[0].left !== undefined
	            ? ~~arguments[0].left + this.scrollLeft
	            : ~~arguments[0] + this.scrollLeft,
	          arguments[0].top !== undefined
	            ? ~~arguments[0].top + this.scrollTop
	            : ~~arguments[1] + this.scrollTop
	        );
	
	        return;
	      }
	
	      this.scroll({
	        left: ~~arguments[0].left + this.scrollLeft,
	        top: ~~arguments[0].top + this.scrollTop,
	        behavior: arguments[0].behavior
	      });
	    };
	
	    // Element.prototype.scrollIntoView
	    Element.prototype.scrollIntoView = function() {
	      // avoid smooth behavior if not required
	      if (shouldBailOut(arguments[0]) === true) {
	        original.scrollIntoView.call(
	          this,
	          arguments[0] === undefined
	            ? true
	            : arguments[0]
	        );
	
	        return;
	      }
	
	      // LET THE SMOOTHNESS BEGIN!
	      var scrollableParent = findScrollableParent(this);
	      var parentRects = scrollableParent.getBoundingClientRect();
	      var clientRects = this.getBoundingClientRect();
	
	      if (scrollableParent !== d.body) {
	        // reveal element inside parent
	        smoothScroll.call(
	          this,
	          scrollableParent,
	          scrollableParent.scrollLeft + clientRects.left - parentRects.left,
	          scrollableParent.scrollTop + clientRects.top - parentRects.top
	        );
	
	        // reveal parent in viewport unless is fixed
	        if (w.getComputedStyle(scrollableParent).position !== 'fixed') {
	          w.scrollBy({
	            left: parentRects.left,
	            top: parentRects.top,
	            behavior: 'smooth'
	          });
	        }
	      } else {
	        // reveal element in viewport
	        w.scrollBy({
	          left: clientRects.left,
	          top: clientRects.top,
	          behavior: 'smooth'
	        });
	      }
	    };
	  }
	
	  if (true) {
	    // commonjs
	    module.exports = { polyfill: polyfill };
	  } else {
	    // global
	    polyfill();
	  }
	
	}());
	
	
	/***/ })
	/******/ ]);
	});

/***/ }),

/***/ 39:
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(41);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(34);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(40);
	
	var _HelmetConstants = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),

/***/ 15:
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),

/***/ 40:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(53);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 41:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	var ExecutionEnvironment = _interopDefault(__webpack_require__(37));
	var shallowEqual = _interopDefault(__webpack_require__(42));
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !shallowEqual(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return React__default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(React.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = ExecutionEnvironment.canUseDOM;
	
	
	    return SideEffect;
	  };
	}
	
	module.exports = withSideEffect;


/***/ }),

/***/ 668:
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(1);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _propTypes = __webpack_require__(2);
	
		var _propTypes2 = _interopRequireDefault(_propTypes);
	
		var _Cursor = __webpack_require__(10);
	
		var _Cursor2 = _interopRequireDefault(_Cursor);
	
		var _Backspace = __webpack_require__(12);
	
		var _Backspace2 = _interopRequireDefault(_Backspace);
	
		var _Delay = __webpack_require__(13);
	
		var _Delay2 = _interopRequireDefault(_Delay);
	
		var _utils = __webpack_require__(14);
	
		var utils = _interopRequireWildcard(_utils);
	
		function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var ACTION_CHARS = ['🔙', '⏰'];
	
		var Typist = function (_Component) {
		  _inherits(Typist, _Component);
	
		  function Typist(props) {
		    _classCallCheck(this, Typist);
	
		    var _this = _possibleConstructorReturn(this, (Typist.__proto__ || Object.getPrototypeOf(Typist)).call(this, props));
	
		    _this.state = {
		      textLines: [],
		      isDone: false
		    };
	
		    _this.onTypingDone = function () {
		      if (!_this.mounted) {
		        return;
		      }
		      _this.setState({ isDone: true });
		      _this.props.onTypingDone();
		    };
	
		    _this.delayGenerator = function (line, lineIdx, character, charIdx) {
		      var mean = _this.props.avgTypingDelay;
		      var std = _this.props.stdTypingDelay;
	
		      return _this.props.delayGenerator(mean, std, {
		        line: line,
		        lineIdx: lineIdx,
		        character: character,
		        charIdx: charIdx,
		        defDelayGenerator: function defDelayGenerator() {
		          var mn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : mean;
		          var st = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : std;
		          return utils.gaussianRnd(mn, st);
		        }
		      });
		    };
	
		    _this.typeLine = function (line, lineIdx) {
		      if (!_this.mounted) {
		        return Promise.resolve();
		      }
	
		      var decoratedLine = line;
		      var onLineTyped = _this.props.onLineTyped;
	
	
		      if (utils.isBackspaceElement(line)) {
		        if (line.props.delay > 0) {
		          _this.introducedDelay = line.props.delay;
		        }
		        decoratedLine = String('🔙').repeat(line.props.count);
		      } else if (utils.isDelayElement(line)) {
		        _this.introducedDelay = line.props.ms;
		        decoratedLine = '⏰';
		      }
	
		      return new Promise(function (resolve, reject) {
		        _this.setState({ textLines: _this.state.textLines.concat(['']) }, function () {
		          utils.eachPromise(decoratedLine, _this.typeCharacter, decoratedLine, lineIdx).then(function () {
		            return onLineTyped(decoratedLine, lineIdx);
		          }).then(resolve).catch(reject);
		        });
		      });
		    };
	
		    _this.typeCharacter = function (character, charIdx, line, lineIdx) {
		      if (!_this.mounted) {
		        return Promise.resolve();
		      }
		      var onCharacterTyped = _this.props.onCharacterTyped;
	
	
		      return new Promise(function (resolve) {
		        var textLines = _this.state.textLines.slice();
	
		        utils.sleep(_this.introducedDelay).then(function () {
		          _this.introducedDelay = null;
	
		          var isBackspace = character === '🔙';
		          var isDelay = character === '⏰';
		          if (isDelay) {
		            resolve();
		            return;
		          }
	
		          if (isBackspace && lineIdx > 0) {
		            var prevLineIdx = lineIdx - 1;
		            var prevLine = textLines[prevLineIdx];
	
		            for (var idx = prevLineIdx; idx >= 0; idx--) {
		              if (prevLine.length > 0 && !ACTION_CHARS.includes(prevLine[0])) {
		                break;
		              }
		              prevLineIdx = idx;
		              prevLine = textLines[prevLineIdx];
		            }
	
		            textLines[prevLineIdx] = prevLine.substr(0, prevLine.length - 1);
		          } else {
		            textLines[lineIdx] += character;
		          }
	
		          _this.setState({ textLines: textLines }, function () {
		            var delay = _this.delayGenerator(line, lineIdx, character, charIdx);
		            onCharacterTyped(character, charIdx);
		            setTimeout(resolve, delay);
		          });
		        });
		      });
		    };
	
		    _this.mounted = false;
		    _this.linesToType = [];
		    _this.introducedDelay = null;
	
		    if (props.children) {
		      _this.linesToType = utils.extractTextFromElement(props.children);
		    }
		    return _this;
		  }
	
		  _createClass(Typist, [{
		    key: 'componentDidMount',
		    value: function componentDidMount() {
		      this.mounted = true;
		      var _props = this.props,
		          children = _props.children,
		          startDelay = _props.startDelay;
	
		      if (children) {
		        if (startDelay > 0 && typeof window !== 'undefined') {
		          setTimeout(this.typeAllLines.bind(this), startDelay);
		        } else {
		          this.typeAllLines();
		        }
		      } else {
		        this.onTypingDone();
		      }
		    }
		  }, {
		    key: 'shouldComponentUpdate',
		    value: function shouldComponentUpdate(nextProps, nextState) {
		      if (nextState.textLines.length !== this.state.textLines.length) {
		        return true;
		      }
		      for (var idx = 0; idx < nextState.textLines.length; idx++) {
		        var line = this.state.textLines[idx];
		        var nextLine = nextState.textLines[idx];
		        if (line !== nextLine) {
		          return true;
		        }
		      }
		      return this.state.isDone !== nextState.isDone;
		    }
		  }, {
		    key: 'componentWillUnmount',
		    value: function componentWillUnmount() {
		      this.mounted = false;
		    }
		  }, {
		    key: 'typeAllLines',
		    value: function typeAllLines() {
		      var _this2 = this;
	
		      var lines = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.linesToType;
	
		      return utils.eachPromise(lines, this.typeLine).then(function () {
		        return _this2.onTypingDone();
		      });
		    }
		  }, {
		    key: 'render',
		    value: function render() {
		      var _props2 = this.props,
		          className = _props2.className,
		          cursor = _props2.cursor;
		      var isDone = this.state.isDone;
	
		      var innerTree = utils.cloneElementWithSpecifiedText({
		        element: this.props.children,
		        textLines: this.state.textLines
		      });
	
		      return _react2.default.createElement(
		        'div',
		        { className: 'Typist ' + className },
		        innerTree,
		        _react2.default.createElement(_Cursor2.default, _extends({ isDone: isDone }, cursor))
		      );
		    }
		  }]);
	
		  return Typist;
		}(_react.Component);
	
		Typist.propTypes = {
		  children: _propTypes2.default.node,
		  className: _propTypes2.default.string,
		  avgTypingDelay: _propTypes2.default.number,
		  stdTypingDelay: _propTypes2.default.number,
		  startDelay: _propTypes2.default.number,
		  cursor: _propTypes2.default.object,
		  onCharacterTyped: _propTypes2.default.func,
		  onLineTyped: _propTypes2.default.func,
		  onTypingDone: _propTypes2.default.func,
		  delayGenerator: _propTypes2.default.func
		};
		Typist.defaultProps = {
		  className: '',
		  avgTypingDelay: 70,
		  stdTypingDelay: 25,
		  startDelay: 0,
		  cursor: {},
		  onCharacterTyped: function onCharacterTyped() {},
		  onLineTyped: function onLineTyped() {},
		  onTypingDone: function onTypingDone() {},
		  delayGenerator: utils.gaussianRnd
		};
		exports.default = Typist;
	
	
		Typist.Backspace = _Backspace2.default;
		Typist.Delay = _Delay2.default;
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports) {
	
		module.exports = __webpack_require__(1);
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 */
	
		if (false) {
		  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
		    Symbol.for &&
		    Symbol.for('react.element')) ||
		    0xeac7;
	
		  var isValidElement = function(object) {
		    return typeof object === 'object' &&
		      object !== null &&
		      object.$$typeof === REACT_ELEMENT_TYPE;
		  };
	
		  // By explicitly using `prop-types` you are opting into new development behavior.
		  // http://fb.me/prop-types-in-prod
		  var throwOnDirectAccess = true;
		  module.exports = __webpack_require__(3)(isValidElement, throwOnDirectAccess);
		} else {
		  // By explicitly using `prop-types` you are opting into new production behavior.
		  // http://fb.me/prop-types-in-prod
		  module.exports = __webpack_require__(9)();
		}
	
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 */
	
		'use strict';
	
		var emptyFunction = __webpack_require__(4);
		var invariant = __webpack_require__(5);
		var warning = __webpack_require__(6);
	
		var ReactPropTypesSecret = __webpack_require__(7);
		var checkPropTypes = __webpack_require__(8);
	
		module.exports = function(isValidElement, throwOnDirectAccess) {
		  /* global Symbol */
		  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
		  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
		  /**
		   * Returns the iterator method function contained on the iterable object.
		   *
		   * Be sure to invoke the function with the iterable as context:
		   *
		   *     var iteratorFn = getIteratorFn(myIterable);
		   *     if (iteratorFn) {
		   *       var iterator = iteratorFn.call(myIterable);
		   *       ...
		   *     }
		   *
		   * @param {?object} maybeIterable
		   * @return {?function}
		   */
		  function getIteratorFn(maybeIterable) {
		    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
		    if (typeof iteratorFn === 'function') {
		      return iteratorFn;
		    }
		  }
	
		  /**
		   * Collection of methods that allow declaration and validation of props that are
		   * supplied to React components. Example usage:
		   *
		   *   var Props = require('ReactPropTypes');
		   *   var MyArticle = React.createClass({
		   *     propTypes: {
		   *       // An optional string prop named "description".
		   *       description: Props.string,
		   *
		   *       // A required enum prop named "category".
		   *       category: Props.oneOf(['News','Photos']).isRequired,
		   *
		   *       // A prop named "dialog" that requires an instance of Dialog.
		   *       dialog: Props.instanceOf(Dialog).isRequired
		   *     },
		   *     render: function() { ... }
		   *   });
		   *
		   * A more formal specification of how these methods are used:
		   *
		   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
		   *   decl := ReactPropTypes.{type}(.isRequired)?
		   *
		   * Each and every declaration produces a function with the same signature. This
		   * allows the creation of custom validation functions. For example:
		   *
		   *  var MyLink = React.createClass({
		   *    propTypes: {
		   *      // An optional string or URI prop named "href".
		   *      href: function(props, propName, componentName) {
		   *        var propValue = props[propName];
		   *        if (propValue != null && typeof propValue !== 'string' &&
		   *            !(propValue instanceof URI)) {
		   *          return new Error(
		   *            'Expected a string or an URI for ' + propName + ' in ' +
		   *            componentName
		   *          );
		   *        }
		   *      }
		   *    },
		   *    render: function() {...}
		   *  });
		   *
		   * @internal
		   */
	
		  var ANONYMOUS = '<<anonymous>>';
	
		  // Important!
		  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
		  var ReactPropTypes = {
		    array: createPrimitiveTypeChecker('array'),
		    bool: createPrimitiveTypeChecker('boolean'),
		    func: createPrimitiveTypeChecker('function'),
		    number: createPrimitiveTypeChecker('number'),
		    object: createPrimitiveTypeChecker('object'),
		    string: createPrimitiveTypeChecker('string'),
		    symbol: createPrimitiveTypeChecker('symbol'),
	
		    any: createAnyTypeChecker(),
		    arrayOf: createArrayOfTypeChecker,
		    element: createElementTypeChecker(),
		    instanceOf: createInstanceTypeChecker,
		    node: createNodeChecker(),
		    objectOf: createObjectOfTypeChecker,
		    oneOf: createEnumTypeChecker,
		    oneOfType: createUnionTypeChecker,
		    shape: createShapeTypeChecker
		  };
	
		  /**
		   * inlined Object.is polyfill to avoid requiring consumers ship their own
		   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
		   */
		  /*eslint-disable no-self-compare*/
		  function is(x, y) {
		    // SameValue algorithm
		    if (x === y) {
		      // Steps 1-5, 7-10
		      // Steps 6.b-6.e: +0 != -0
		      return x !== 0 || 1 / x === 1 / y;
		    } else {
		      // Step 6.a: NaN == NaN
		      return x !== x && y !== y;
		    }
		  }
		  /*eslint-enable no-self-compare*/
	
		  /**
		   * We use an Error-like object for backward compatibility as people may call
		   * PropTypes directly and inspect their output. However, we don't use real
		   * Errors anymore. We don't inspect their stack anyway, and creating them
		   * is prohibitively expensive if they are created too often, such as what
		   * happens in oneOfType() for any type before the one that matched.
		   */
		  function PropTypeError(message) {
		    this.message = message;
		    this.stack = '';
		  }
		  // Make `instanceof Error` still work for returned errors.
		  PropTypeError.prototype = Error.prototype;
	
		  function createChainableTypeChecker(validate) {
		    if (false) {
		      var manualPropTypeCallCache = {};
		      var manualPropTypeWarningCount = 0;
		    }
		    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
		      componentName = componentName || ANONYMOUS;
		      propFullName = propFullName || propName;
	
		      if (secret !== ReactPropTypesSecret) {
		        if (throwOnDirectAccess) {
		          // New behavior only for users of `prop-types` package
		          invariant(
		            false,
		            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
		            'Use `PropTypes.checkPropTypes()` to call them. ' +
		            'Read more at http://fb.me/use-check-prop-types'
		          );
		        } else if (false) {
		          // Old behavior for people using React.PropTypes
		          var cacheKey = componentName + ':' + propName;
		          if (
		            !manualPropTypeCallCache[cacheKey] &&
		            // Avoid spamming the console because they are often not actionable except for lib authors
		            manualPropTypeWarningCount < 3
		          ) {
		            warning(
		              false,
		              'You are manually calling a React.PropTypes validation ' +
		              'function for the `%s` prop on `%s`. This is deprecated ' +
		              'and will throw in the standalone `prop-types` package. ' +
		              'You may be seeing this warning due to a third-party PropTypes ' +
		              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
		              propFullName,
		              componentName
		            );
		            manualPropTypeCallCache[cacheKey] = true;
		            manualPropTypeWarningCount++;
		          }
		        }
		      }
		      if (props[propName] == null) {
		        if (isRequired) {
		          if (props[propName] === null) {
		            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
		          }
		          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
		        }
		        return null;
		      } else {
		        return validate(props, propName, componentName, location, propFullName);
		      }
		    }
	
		    var chainedCheckType = checkType.bind(null, false);
		    chainedCheckType.isRequired = checkType.bind(null, true);
	
		    return chainedCheckType;
		  }
	
		  function createPrimitiveTypeChecker(expectedType) {
		    function validate(props, propName, componentName, location, propFullName, secret) {
		      var propValue = props[propName];
		      var propType = getPropType(propValue);
		      if (propType !== expectedType) {
		        // `propValue` being instance of, say, date/regexp, pass the 'object'
		        // check, but we can offer a more precise error message here rather than
		        // 'of type `object`'.
		        var preciseType = getPreciseType(propValue);
	
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
	
		  function createAnyTypeChecker() {
		    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
		  }
	
		  function createArrayOfTypeChecker(typeChecker) {
		    function validate(props, propName, componentName, location, propFullName) {
		      if (typeof typeChecker !== 'function') {
		        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
		      }
		      var propValue = props[propName];
		      if (!Array.isArray(propValue)) {
		        var propType = getPropType(propValue);
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
		      }
		      for (var i = 0; i < propValue.length; i++) {
		        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
		        if (error instanceof Error) {
		          return error;
		        }
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
	
		  function createElementTypeChecker() {
		    function validate(props, propName, componentName, location, propFullName) {
		      var propValue = props[propName];
		      if (!isValidElement(propValue)) {
		        var propType = getPropType(propValue);
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
	
		  function createInstanceTypeChecker(expectedClass) {
		    function validate(props, propName, componentName, location, propFullName) {
		      if (!(props[propName] instanceof expectedClass)) {
		        var expectedClassName = expectedClass.name || ANONYMOUS;
		        var actualClassName = getClassName(props[propName]);
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
	
		  function createEnumTypeChecker(expectedValues) {
		    if (!Array.isArray(expectedValues)) {
		       false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
		      return emptyFunction.thatReturnsNull;
		    }
	
		    function validate(props, propName, componentName, location, propFullName) {
		      var propValue = props[propName];
		      for (var i = 0; i < expectedValues.length; i++) {
		        if (is(propValue, expectedValues[i])) {
		          return null;
		        }
		      }
	
		      var valuesString = JSON.stringify(expectedValues);
		      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
		    }
		    return createChainableTypeChecker(validate);
		  }
	
		  function createObjectOfTypeChecker(typeChecker) {
		    function validate(props, propName, componentName, location, propFullName) {
		      if (typeof typeChecker !== 'function') {
		        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
		      }
		      var propValue = props[propName];
		      var propType = getPropType(propValue);
		      if (propType !== 'object') {
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
		      }
		      for (var key in propValue) {
		        if (propValue.hasOwnProperty(key)) {
		          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
		          if (error instanceof Error) {
		            return error;
		          }
		        }
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
	
		  function createUnionTypeChecker(arrayOfTypeCheckers) {
		    if (!Array.isArray(arrayOfTypeCheckers)) {
		       false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
		      return emptyFunction.thatReturnsNull;
		    }
	
		    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
		      var checker = arrayOfTypeCheckers[i];
		      if (typeof checker !== 'function') {
		        warning(
		          false,
		          'Invalid argument supplid to oneOfType. Expected an array of check functions, but ' +
		          'received %s at index %s.',
		          getPostfixForTypeWarning(checker),
		          i
		        );
		        return emptyFunction.thatReturnsNull;
		      }
		    }
	
		    function validate(props, propName, componentName, location, propFullName) {
		      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
		        var checker = arrayOfTypeCheckers[i];
		        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
		          return null;
		        }
		      }
	
		      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
		    }
		    return createChainableTypeChecker(validate);
		  }
	
		  function createNodeChecker() {
		    function validate(props, propName, componentName, location, propFullName) {
		      if (!isNode(props[propName])) {
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
	
		  function createShapeTypeChecker(shapeTypes) {
		    function validate(props, propName, componentName, location, propFullName) {
		      var propValue = props[propName];
		      var propType = getPropType(propValue);
		      if (propType !== 'object') {
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
		      }
		      for (var key in shapeTypes) {
		        var checker = shapeTypes[key];
		        if (!checker) {
		          continue;
		        }
		        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
		        if (error) {
		          return error;
		        }
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
	
		  function isNode(propValue) {
		    switch (typeof propValue) {
		      case 'number':
		      case 'string':
		      case 'undefined':
		        return true;
		      case 'boolean':
		        return !propValue;
		      case 'object':
		        if (Array.isArray(propValue)) {
		          return propValue.every(isNode);
		        }
		        if (propValue === null || isValidElement(propValue)) {
		          return true;
		        }
	
		        var iteratorFn = getIteratorFn(propValue);
		        if (iteratorFn) {
		          var iterator = iteratorFn.call(propValue);
		          var step;
		          if (iteratorFn !== propValue.entries) {
		            while (!(step = iterator.next()).done) {
		              if (!isNode(step.value)) {
		                return false;
		              }
		            }
		          } else {
		            // Iterator will provide entry [k,v] tuples rather than values.
		            while (!(step = iterator.next()).done) {
		              var entry = step.value;
		              if (entry) {
		                if (!isNode(entry[1])) {
		                  return false;
		                }
		              }
		            }
		          }
		        } else {
		          return false;
		        }
	
		        return true;
		      default:
		        return false;
		    }
		  }
	
		  function isSymbol(propType, propValue) {
		    // Native Symbol.
		    if (propType === 'symbol') {
		      return true;
		    }
	
		    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
		    if (propValue['@@toStringTag'] === 'Symbol') {
		      return true;
		    }
	
		    // Fallback for non-spec compliant Symbols which are polyfilled.
		    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
		      return true;
		    }
	
		    return false;
		  }
	
		  // Equivalent of `typeof` but with special handling for array and regexp.
		  function getPropType(propValue) {
		    var propType = typeof propValue;
		    if (Array.isArray(propValue)) {
		      return 'array';
		    }
		    if (propValue instanceof RegExp) {
		      // Old webkits (at least until Android 4.0) return 'function' rather than
		      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
		      // passes PropTypes.object.
		      return 'object';
		    }
		    if (isSymbol(propType, propValue)) {
		      return 'symbol';
		    }
		    return propType;
		  }
	
		  // This handles more types than `getPropType`. Only used for error messages.
		  // See `createPrimitiveTypeChecker`.
		  function getPreciseType(propValue) {
		    if (typeof propValue === 'undefined' || propValue === null) {
		      return '' + propValue;
		    }
		    var propType = getPropType(propValue);
		    if (propType === 'object') {
		      if (propValue instanceof Date) {
		        return 'date';
		      } else if (propValue instanceof RegExp) {
		        return 'regexp';
		      }
		    }
		    return propType;
		  }
	
		  // Returns a string that is postfixed to a warning about an invalid type.
		  // For example, "undefined" or "of type array"
		  function getPostfixForTypeWarning(value) {
		    var type = getPreciseType(value);
		    switch (type) {
		      case 'array':
		      case 'object':
		        return 'an ' + type;
		      case 'boolean':
		      case 'date':
		      case 'regexp':
		        return 'a ' + type;
		      default:
		        return type;
		    }
		  }
	
		  // Returns class name of the object, if any.
		  function getClassName(propValue) {
		    if (!propValue.constructor || !propValue.constructor.name) {
		      return ANONYMOUS;
		    }
		    return propValue.constructor.name;
		  }
	
		  ReactPropTypes.checkPropTypes = checkPropTypes;
		  ReactPropTypes.PropTypes = ReactPropTypes;
	
		  return ReactPropTypes;
		};
	
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports) {
	
		"use strict";
	
		/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 * 
		 */
	
		function makeEmptyFunction(arg) {
		  return function () {
		    return arg;
		  };
		}
	
		/**
		 * This function accepts and discards inputs; it has no side effects. This is
		 * primarily useful idiomatically for overridable function endpoints which
		 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
		 */
		var emptyFunction = function emptyFunction() {};
	
		emptyFunction.thatReturns = makeEmptyFunction;
		emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
		emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
		emptyFunction.thatReturnsNull = makeEmptyFunction(null);
		emptyFunction.thatReturnsThis = function () {
		  return this;
		};
		emptyFunction.thatReturnsArgument = function (arg) {
		  return arg;
		};
	
		module.exports = emptyFunction;
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports) {
	
		/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		/**
		 * Use invariant() to assert state which your program assumes to be true.
		 *
		 * Provide sprintf-style format (only %s is supported) and arguments
		 * to provide information about what broke and what you were
		 * expecting.
		 *
		 * The invariant message will be stripped in production, but the invariant
		 * will remain to ensure logic does not differ in production.
		 */
	
		var validateFormat = function validateFormat(format) {};
	
		if (false) {
		  validateFormat = function validateFormat(format) {
		    if (format === undefined) {
		      throw new Error('invariant requires an error message argument');
		    }
		  };
		}
	
		function invariant(condition, format, a, b, c, d, e, f) {
		  validateFormat(format);
	
		  if (!condition) {
		    var error;
		    if (format === undefined) {
		      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
		    } else {
		      var args = [a, b, c, d, e, f];
		      var argIndex = 0;
		      error = new Error(format.replace(/%s/g, function () {
		        return args[argIndex++];
		      }));
		      error.name = 'Invariant Violation';
		    }
	
		    error.framesToPop = 1; // we don't care about invariant's own frame
		    throw error;
		  }
		}
	
		module.exports = invariant;
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2014-2015, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
	
		'use strict';
	
		var emptyFunction = __webpack_require__(4);
	
		/**
		 * Similar to invariant but only logs a warning if the condition is not met.
		 * This can be used to log issues in development environments in critical
		 * paths. Removing the logging code for production environments will keep the
		 * same logic and follow the same code paths.
		 */
	
		var warning = emptyFunction;
	
		if (false) {
		  (function () {
		    var printWarning = function printWarning(format) {
		      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
		        args[_key - 1] = arguments[_key];
		      }
	
		      var argIndex = 0;
		      var message = 'Warning: ' + format.replace(/%s/g, function () {
		        return args[argIndex++];
		      });
		      if (typeof console !== 'undefined') {
		        console.error(message);
		      }
		      try {
		        // --- Welcome to debugging React ---
		        // This error was thrown as a convenience so that you can use this stack
		        // to find the callsite that caused this warning to fire.
		        throw new Error(message);
		      } catch (x) {}
		    };
	
		    warning = function warning(condition, format) {
		      if (format === undefined) {
		        throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
		      }
	
		      if (format.indexOf('Failed Composite propType: ') === 0) {
		        return; // Ignore CompositeComponent proptype check.
		      }
	
		      if (!condition) {
		        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
		          args[_key2 - 2] = arguments[_key2];
		        }
	
		        printWarning.apply(undefined, [format].concat(args));
		      }
		    };
		  })();
		}
	
		module.exports = warning;
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 */
	
		'use strict';
	
		var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
		module.exports = ReactPropTypesSecret;
	
	
	/***/ }),
	/* 8 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 */
	
		'use strict';
	
		if (false) {
		  var invariant = __webpack_require__(5);
		  var warning = __webpack_require__(6);
		  var ReactPropTypesSecret = __webpack_require__(7);
		  var loggedTypeFailures = {};
		}
	
		/**
		 * Assert that the values match with the type specs.
		 * Error messages are memorized and will only be shown once.
		 *
		 * @param {object} typeSpecs Map of name to a ReactPropType
		 * @param {object} values Runtime values that need to be type-checked
		 * @param {string} location e.g. "prop", "context", "child context"
		 * @param {string} componentName Name of the component for error messages.
		 * @param {?Function} getStack Returns the component stack.
		 * @private
		 */
		function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
		  if (false) {
		    for (var typeSpecName in typeSpecs) {
		      if (typeSpecs.hasOwnProperty(typeSpecName)) {
		        var error;
		        // Prop type validation may throw. In case they do, we don't want to
		        // fail the render phase where it didn't fail before. So we log it.
		        // After these have been cleaned up, we'll let them throw.
		        try {
		          // This is intentionally an invariant that gets caught. It's the same
		          // behavior as without this statement except with a better message.
		          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', location, typeSpecName);
		          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
		        } catch (ex) {
		          error = ex;
		        }
		        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
		        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
		          // Only monitor this failure once because there tends to be a lot of the
		          // same error.
		          loggedTypeFailures[error.message] = true;
	
		          var stack = getStack ? getStack() : '';
	
		          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
		        }
		      }
		    }
		  }
		}
	
		module.exports = checkPropTypes;
	
	
	/***/ }),
	/* 9 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 */
	
		'use strict';
	
		var emptyFunction = __webpack_require__(4);
		var invariant = __webpack_require__(5);
		var ReactPropTypesSecret = __webpack_require__(7);
	
		module.exports = function() {
		  function shim(props, propName, componentName, location, propFullName, secret) {
		    if (secret === ReactPropTypesSecret) {
		      // It is still safe when called from React.
		      return;
		    }
		    invariant(
		      false,
		      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
		      'Use PropTypes.checkPropTypes() to call them. ' +
		      'Read more at http://fb.me/use-check-prop-types'
		    );
		  };
		  shim.isRequired = shim;
		  function getShim() {
		    return shim;
		  };
		  // Important!
		  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
		  var ReactPropTypes = {
		    array: shim,
		    bool: shim,
		    func: shim,
		    number: shim,
		    object: shim,
		    string: shim,
		    symbol: shim,
	
		    any: shim,
		    arrayOf: getShim,
		    element: shim,
		    instanceOf: getShim,
		    node: shim,
		    objectOf: getShim,
		    oneOf: getShim,
		    oneOfType: getShim,
		    shape: getShim
		  };
	
		  ReactPropTypes.checkPropTypes = emptyFunction;
		  ReactPropTypes.PropTypes = ReactPropTypes;
	
		  return ReactPropTypes;
		};
	
	
	/***/ }),
	/* 10 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(1);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _propTypes = __webpack_require__(2);
	
		var _propTypes2 = _interopRequireDefault(_propTypes);
	
		__webpack_require__(11);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var Cursor = function (_Component) {
		  _inherits(Cursor, _Component);
	
		  function Cursor(props) {
		    _classCallCheck(this, Cursor);
	
		    var _this = _possibleConstructorReturn(this, (Cursor.__proto__ || Object.getPrototypeOf(Cursor)).call(this, props));
	
		    _this._isReRenderingCursor = false;
		    _this.state = {
		      shouldRender: _this.props.show
		    };
		    return _this;
		  }
	
		  _createClass(Cursor, [{
		    key: 'componentWillReceiveProps',
		    value: function componentWillReceiveProps(nextProps) {
		      var _this2 = this;
	
		      var shouldHide = !this.props.isDone && nextProps.isDone && this.props.hideWhenDone;
		      if (shouldHide) {
		        setTimeout(function () {
		          return _this2.setState({ shouldRender: false });
		        }, this.props.hideWhenDoneDelay);
		      }
		    }
		  }, {
		    key: 'componentDidUpdate',
		    value: function componentDidUpdate() {
		      var _props = this.props,
		          show = _props.show,
		          isDone = _props.isDone;
	
		      if (!show) {
		        return;
		      }
		      if (isDone) {
		        return;
		      }
		      if (this._isReRenderingCursor) {
		        return;
		      }
	
		      // In webkit and blink, rendering the cursor alongside the text as it
		      // animates sometimes causes the text to stop rendering when it reaches
		      // a new line break, even though the underlying DOM /does/ contain
		      // the text. This seems to happen when the space available for the text is
		      // at a specific width that makes it so the line break happens within a
		      // word.
		      // Using dev tools, when in this state, if you modify the dom or any style,
		      // it immediately renders all of the text in its correct position.
		      // Given that observation, this is a hackish solutions that re-renders the
		      // cursor every time a character is rendered, just to ensure that the text
		      // is rendered correctly.
		      // See #13 and #15 for more details
		      this._reRenderCursor();
		    }
		  }, {
		    key: '_reRenderCursor',
		    value: function _reRenderCursor() {
		      var _this3 = this;
	
		      this._isReRenderingCursor = true;
		      this.setState({ shouldRender: false }, function () {
		        _this3.setState({ shouldRender: true }, function () {
		          _this3._isReRenderingCursor = false;
		        });
		      });
		    }
		  }, {
		    key: 'render',
		    value: function render() {
		      if (this.state.shouldRender) {
		        var className = this.props.blink ? ' Cursor--blinking' : '';
		        return _react2.default.createElement(
		          'span',
		          { className: 'Cursor' + className },
		          this.props.element
		        );
		      }
		      return null;
		    }
		  }]);
	
		  return Cursor;
		}(_react.Component);
	
		Cursor.propTypes = {
		  blink: _propTypes2.default.bool,
		  show: _propTypes2.default.bool,
		  element: _propTypes2.default.node,
		  hideWhenDone: _propTypes2.default.bool,
		  hideWhenDoneDelay: _propTypes2.default.number,
		  isDone: _propTypes2.default.bool
		};
		Cursor.defaultProps = {
		  blink: true,
		  show: true,
		  element: '|',
		  hideWhenDone: false,
		  hideWhenDoneDelay: 1000,
		  isDone: false
		};
		exports.default = Cursor;
	
	/***/ }),
	/* 11 */
	/***/ (function(module, exports) {
	
		// removed by extract-text-webpack-plugin
	
	/***/ }),
	/* 12 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _react = __webpack_require__(1);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _propTypes = __webpack_require__(2);
	
		var _propTypes2 = _interopRequireDefault(_propTypes);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var Backspace = function Backspace() {
		  return _react2.default.createElement('noscript', null);
		};
	
		Backspace.propTypes = {
		  count: _propTypes2.default.number,
		  delay: _propTypes2.default.number
		};
	
		Backspace.defaultProps = {
		  count: 1,
		  delay: 0
		};
	
		exports.default = Backspace;
	
	/***/ }),
	/* 13 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _react = __webpack_require__(1);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _propTypes = __webpack_require__(2);
	
		var _propTypes2 = _interopRequireDefault(_propTypes);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var Delay = function Delay() {
		  return _react2.default.createElement('noscript', null);
		};
	
		Delay.propTypes = {
		  ms: _propTypes2.default.number.isRequired
		};
	
		exports.default = Delay;
	
	/***/ }),
	/* 14 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.sleep = undefined;
	
		var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
		exports.gaussianRnd = gaussianRnd;
		exports.eachPromise = eachPromise;
		exports.exclude = exclude;
		exports.isBackspaceElement = isBackspaceElement;
		exports.isDelayElement = isDelayElement;
		exports.extractTextFromElement = extractTextFromElement;
		exports.cloneElement = cloneElement;
		exports.cloneElementWithSpecifiedText = cloneElementWithSpecifiedText;
	
		var _react = __webpack_require__(1);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _Backspace = __webpack_require__(12);
	
		var _Backspace2 = _interopRequireDefault(_Backspace);
	
		var _Delay = __webpack_require__(13);
	
		var _Delay2 = _interopRequireDefault(_Delay);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
		var sleep = exports.sleep = function sleep(val) {
		  return new Promise(function (resolve) {
		    return val != null ? setTimeout(resolve, val) : resolve();
		  });
		};
	
		function gaussianRnd(mean, std) {
		  var times = 12;
		  var sum = 0;
		  for (var idx = 0; idx < times; idx++) {
		    sum += Math.random();
		  }
		  sum -= times / 2;
		  return Math.round(sum * std) + mean;
		}
	
		function eachPromise(arr, iterator) {
		  for (var _len = arguments.length, extraArgs = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
		    extraArgs[_key - 2] = arguments[_key];
		  }
	
		  var promiseReducer = function promiseReducer(prev, current, idx) {
		    return prev.then(function () {
		      return iterator.apply(undefined, [current, idx].concat(extraArgs));
		    });
		  };
		  return Array.from(arr).reduce(promiseReducer, Promise.resolve());
		}
	
		function exclude(obj, keys) {
		  var res = {};
		  for (var key in obj) {
		    if (keys.indexOf(key) === -1) {
		      res[key] = obj[key];
		    }
		  }
		  return res;
		}
	
		function isBackspaceElement(element) {
		  return element && element.type === _Backspace2.default;
		}
	
		function isDelayElement(element) {
		  return element && element.type === _Delay2.default;
		}
	
		function extractTextFromElement(element) {
		  var stack = element ? [element] : [];
		  var lines = [];
	
		  while (stack.length > 0) {
		    var current = stack.pop();
		    if (_react2.default.isValidElement(current)) {
		      if (isBackspaceElement(current) || isDelayElement(current)) {
		        // If it is a `Backspace` or `Delay` element, we want to keep it in our
		        // `textLines` state. These will serve as markers when updating the
		        // state of the text
		        lines.unshift(current);
		      } else {
		        _react2.default.Children.forEach(current.props.children, function (child) {
		          stack.push(child);
		        });
		      }
		    } else if (Array.isArray(current)) {
		      var _iteratorNormalCompletion = true;
		      var _didIteratorError = false;
		      var _iteratorError = undefined;
	
		      try {
		        for (var _iterator = current[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
		          var el = _step.value;
	
		          stack.push(el);
		        }
		      } catch (err) {
		        _didIteratorError = true;
		        _iteratorError = err;
		      } finally {
		        try {
		          if (!_iteratorNormalCompletion && _iterator.return) {
		            _iterator.return();
		          }
		        } finally {
		          if (_didIteratorError) {
		            throw _iteratorError;
		          }
		        }
		      }
		    } else {
		      lines.unshift(current);
		    }
		  }
	
		  return lines;
		}
	
		function cloneElement(element, children) {
		  var tag = element.type;
		  var props = exclude(element.props, ['children']);
		  // eslint-disable-next-line
		  props.key = 'Typist-element-' + tag + '-' + (Date.now() + Math.random() + Math.random());
		  return _react2.default.createElement.apply(_react2.default, [tag, props].concat(_toConsumableArray(children)));
		}
	
		function cloneElementWithSpecifiedTextAtIndex(element, textLines, textIdx) {
		  if (textIdx >= textLines.length) {
		    return [null, textIdx];
		  }
	
		  var idx = textIdx;
		  var recurse = function recurse(el) {
		    var _cloneElementWithSpec = cloneElementWithSpecifiedTextAtIndex(el, textLines, idx),
		        _cloneElementWithSpec2 = _slicedToArray(_cloneElementWithSpec, 2),
		        child = _cloneElementWithSpec2[0],
		        advIdx = _cloneElementWithSpec2[1];
	
		    idx = advIdx;
		    return child;
		  };
	
		  var isNonTypistElement = _react2.default.isValidElement(element) && !(isBackspaceElement(element) || isDelayElement(element));
	
		  if (isNonTypistElement) {
		    var clonedChildren = _react2.default.Children.map(element.props.children, recurse) || [];
		    return [cloneElement(element, clonedChildren), idx];
		  }
	
		  if (Array.isArray(element)) {
		    var children = element.map(recurse);
		    return [children, idx];
		  }
	
		  // Anything that isn't a React element or an Array is interpreted as text
		  return [textLines[idx], idx + 1];
		}
	
		function cloneElementWithSpecifiedText(_ref) {
		  var element = _ref.element,
		      textLines = _ref.textLines;
	
		  if (!element) {
		    return undefined;
		  }
	
		  return cloneElementWithSpecifiedTextAtIndex(element, textLines, 0)[0];
		}
	
	/***/ })
	/******/ ]);

/***/ }),

/***/ 671:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var $$observable = _interopDefault(__webpack_require__(682));
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = {
	  INIT: '@@redux/INIT' + Math.random().toString(36).substring(7).split('').join('.'),
	  REPLACE: '@@redux/REPLACE' + Math.random().toString(36).substring(7).split('').join('.')
	};
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	  return typeof obj;
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	};
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	/**
	 * @param {any} obj The object to inspect.
	 * @returns {boolean} True if the argument appears to be a plain object.
	 */
	function isPlainObject(obj) {
	  if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object' || obj === null) return false;
	
	  var proto = obj;
	  while (Object.getPrototypeOf(proto) !== null) {
	    proto = Object.getPrototypeOf(proto);
	  }
	
	  return Object.getPrototypeOf(obj) === proto;
	}
	
	/**
	 * Creates a Redux store that holds the state tree.
	 * The only way to change the data in the store is to call `dispatch()` on it.
	 *
	 * There should only be a single store in your app. To specify how different
	 * parts of the state tree respond to actions, you may combine several reducers
	 * into a single reducer function by using `combineReducers`.
	 *
	 * @param {Function} reducer A function that returns the next state tree, given
	 * the current state tree and the action to handle.
	 *
	 * @param {any} [preloadedState] The initial state. You may optionally specify it
	 * to hydrate the state from the server in universal apps, or to restore a
	 * previously serialized user session.
	 * If you use `combineReducers` to produce the root reducer function, this must be
	 * an object with the same shape as `combineReducers` keys.
	 *
	 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
	 * to enhance the store with third-party capabilities such as middleware,
	 * time travel, persistence, etc. The only store enhancer that ships with Redux
	 * is `applyMiddleware()`.
	 *
	 * @returns {Store} A Redux store that lets you read the state, dispatch actions
	 * and subscribe to changes.
	 */
	function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    if (isDispatching) {
	      throw new Error('You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
	    }
	
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected the listener to be a function.');
	    }
	
	    if (isDispatching) {
	      throw new Error('You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api-reference/store#subscribe(listener) for more details.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      if (isDispatching) {
	        throw new Error('You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api-reference/store#subscribe(listener) for more details.');
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!isPlainObject(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      var listener = listeners[i];
	      listener();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.REPLACE });
	  }
	
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/tc39/proposal-observable
	   */
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if ((typeof observer === 'undefined' ? 'undefined' : _typeof(observer)) !== 'object' || observer === null) {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    }, _ref[$$observable] = function () {
	      return this;
	    }, _ref;
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[$$observable] = observable, _ref2;
	}
	
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	  } catch (e) {} // eslint-disable-line no-empty
	}
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionDescription = actionType && 'action "' + String(actionType) + '"' || 'an action';
	
	  return 'Given ' + actionDescription + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!isPlainObject(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	
	  if (action && action.type === ActionTypes.REPLACE) return;
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerShape(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        warning('No reducer provided for key "' + key + '"');
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  var unexpectedKeyCache = void 0;
	  if (false) {
	    unexpectedKeyCache = {};
	  }
	
	  var shapeAssertionError = void 0;
	  try {
	    assertReducerShape(finalReducers);
	  } catch (e) {
	    shapeAssertionError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	
	    if (shapeAssertionError) {
	      throw shapeAssertionError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	      if (warningMessage) {
	        warning(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
	      var _key = finalReducerKeys[_i];
	      var reducer = finalReducers[_key];
	      var previousStateForKey = state[_key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(_key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[_key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}
	
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(this, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if ((typeof actionCreators === 'undefined' ? 'undefined' : _typeof(actionCreators)) !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators === 'undefined' ? 'undefined' : _typeof(actionCreators)) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}
	
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(undefined, arguments));
	    };
	  });
	}
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function () {
	      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      var store = createStore.apply(undefined, args);
	      var _dispatch = function dispatch() {
	        throw new Error('Dispatching while constructing your middleware is not allowed. ' + 'Other middleware would not be applied to this dispatch.');
	      };
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch() {
	          return _dispatch.apply(undefined, arguments);
	        }
	      };
	      var chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = compose.apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}
	
	/*
	 * This is a dummy function to check if the function name has been altered by minification.
	 * If the function has been minified and NODE_ENV !== 'production', warn the user.
	 */
	function isCrushed() {}
	
	if (false) {
	  warning("You are currently using minified code outside of NODE_ENV === 'production'. " + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = createStore;
	exports.combineReducers = combineReducers;
	exports.bindActionCreators = bindActionCreators;
	exports.applyMiddleware = applyMiddleware;
	exports.compose = compose;
	exports.__DO_NOT_USE__ActionTypes = ActionTypes;


/***/ }),

/***/ 42:
/***/ (function(module, exports) {

	//
	
	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	  if (ret !== void 0) {
	    return !!ret;
	  }
	
	  if (objA === objB) {
	    return true;
	  }
	
	  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	  // Test for A's keys different from B.
	  for (var idx = 0; idx < keysA.length; idx++) {
	    var key = keysA[idx];
	
	    if (!bHasOwnProperty(key)) {
	      return false;
	    }
	
	    var valueA = objA[key];
	    var valueB = objB[key];
	
	    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	    if (ret === false || (ret === void 0 && valueA !== valueB)) {
	      return false;
	    }
	  }
	
	  return true;
	};


/***/ }),

/***/ 682:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ponyfill = __webpack_require__(683);
	
	var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var root; /* global window */
	
	
	if (typeof self !== 'undefined') {
	  root = self;
	} else if (typeof window !== 'undefined') {
	  root = window;
	} else if (typeof global !== 'undefined') {
	  root = global;
	} else if (true) {
	  root = module;
	} else {
	  root = Function('return this')();
	}
	
	var result = (0, _ponyfill2['default'])(root);
	exports['default'] = result;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(95)(module)))

/***/ }),

/***/ 683:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports['default'] = symbolObservablePonyfill;
	function symbolObservablePonyfill(root) {
		var result;
		var _Symbol = root.Symbol;
	
		if (typeof _Symbol === 'function') {
			if (_Symbol.observable) {
				result = _Symbol.observable;
			} else {
				result = _Symbol('observable');
				_Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};

/***/ }),

/***/ 388:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 703:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _redux = __webpack_require__(671);
	
	var _reducers = __webpack_require__(254);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	var _player = __webpack_require__(65);
	
	var playerActions = _interopRequireWildcard(_player);
	
	var _video = __webpack_require__(179);
	
	var videoActions = _interopRequireWildcard(_video);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Manager = function () {
	  function Manager(store) {
	    _classCallCheck(this, Manager);
	
	    this.store = store || (0, _redux.createStore)(_reducers2.default);
	
	    this.video = null;
	    this.rootElement = null;
	  }
	
	  _createClass(Manager, [{
	    key: 'getActions',
	    value: function getActions() {
	      var manager = this;
	      var dispatch = this.store.dispatch;
	
	      var actions = _extends({}, playerActions, videoActions);
	
	      function bindActionCreator(actionCreator) {
	        return function bindAction() {
	          // eslint-disable-next-line prefer-rest-params
	          var action = actionCreator.apply(manager, arguments);
	          if (typeof action !== 'undefined') {
	            dispatch(action);
	          }
	        };
	      }
	
	      return Object.keys(actions).filter(function (key) {
	        return typeof actions[key] === 'function';
	      }).reduce(function (boundActions, key) {
	        boundActions[key] = bindActionCreator(actions[key]);
	        return boundActions;
	      }, {});
	    }
	  }, {
	    key: 'getState',
	    value: function getState() {
	      return this.store.getState();
	    }
	
	    // subscribe state change
	
	  }, {
	    key: 'subscribeToStateChange',
	    value: function subscribeToStateChange(listener, getState) {
	      if (!getState) {
	        getState = this.getState.bind(this);
	      }
	
	      var prevState = getState();
	
	      var handleChange = function handleChange() {
	        var state = getState();
	        if (state === prevState) {
	          return;
	        }
	        var prevStateCopy = prevState;
	        prevState = state;
	        listener(state, prevStateCopy);
	      };
	
	      return this.store.subscribe(handleChange);
	    }
	
	    // subscribe to operation state change
	
	  }, {
	    key: 'subscribeToOperationStateChange',
	    value: function subscribeToOperationStateChange(listener) {
	      var _this = this;
	
	      return this.subscribeToStateChange(listener, function () {
	        return _this.getState().operation;
	      });
	    }
	
	    // subscribe to player state change
	
	  }, {
	    key: 'subscribeToPlayerStateChange',
	    value: function subscribeToPlayerStateChange(listener) {
	      var _this2 = this;
	
	      return this.subscribeToStateChange(listener, function () {
	        return _this2.getState().player;
	      });
	    }
	  }]);
	
	  return Manager;
	}();
	
	exports.default = Manager;

/***/ }),

/***/ 65:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.USER_ACTIVATE = exports.PLAYER_ACTIVATE = exports.FULLSCREEN_CHANGE = exports.OPERATE = undefined;
	exports.handleFullscreenChange = handleFullscreenChange;
	exports.activate = activate;
	exports.userActivate = userActivate;
	exports.play = play;
	exports.pause = pause;
	exports.togglePlay = togglePlay;
	exports.seek = seek;
	exports.forward = forward;
	exports.replay = replay;
	exports.changeRate = changeRate;
	exports.changeVolume = changeVolume;
	exports.mute = mute;
	exports.toggleFullscreen = toggleFullscreen;
	
	var _fullscreen = __webpack_require__(255);
	
	var _fullscreen2 = _interopRequireDefault(_fullscreen);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OPERATE = exports.OPERATE = 'video-react/OPERATE';
	var FULLSCREEN_CHANGE = exports.FULLSCREEN_CHANGE = 'video-react/FULLSCREEN_CHANGE';
	var PLAYER_ACTIVATE = exports.PLAYER_ACTIVATE = 'video-react/PLAYER_ACTIVATE';
	var USER_ACTIVATE = exports.USER_ACTIVATE = 'video-react/USER_ACTIVATE';
	
	function handleFullscreenChange(isFullscreen) {
	  return {
	    type: FULLSCREEN_CHANGE,
	    isFullscreen: isFullscreen
	  };
	}
	
	function activate(activity) {
	  return {
	    type: PLAYER_ACTIVATE,
	    activity: activity
	  };
	}
	
	function userActivate(activity) {
	  return {
	    type: USER_ACTIVATE,
	    activity: activity
	  };
	}
	
	function play() {
	  var operation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
	    action: 'play',
	    source: ''
	  };
	
	  this.video.play();
	
	  return {
	    type: OPERATE,
	    operation: operation
	  };
	}
	
	function pause() {
	  var operation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
	    action: 'pause',
	    source: ''
	  };
	
	  this.video.pause();
	
	  return {
	    type: OPERATE,
	    operation: operation
	  };
	}
	
	function togglePlay() {
	  var operation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
	    action: 'toggle-play',
	    source: ''
	  };
	
	  this.video.togglePlay();
	
	  return {
	    type: OPERATE,
	    operation: operation
	  };
	}
	
	// seek video by time
	function seek(time) {
	  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
	    action: 'seek',
	    source: ''
	  };
	
	  this.video.seek(time);
	
	  return {
	    type: OPERATE,
	    operation: operation
	  };
	}
	
	// jump forward x seconds
	function forward(seconds) {
	  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
	    action: 'forward-' + seconds,
	    source: ''
	  };
	
	  this.video.forward(seconds);
	
	  return {
	    type: OPERATE,
	    operation: operation
	  };
	}
	
	// jump back x seconds
	function replay(seconds) {
	  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
	    action: 'replay-' + seconds,
	    source: ''
	  };
	
	  this.video.replay(seconds);
	
	  return {
	    type: OPERATE,
	    operation: operation
	  };
	}
	
	function changeRate(rate) {
	  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
	    action: 'change-rate',
	    source: ''
	  };
	
	  this.video.playbackRate = rate;
	
	  return {
	    type: OPERATE,
	    operation: operation
	  };
	}
	
	function changeVolume(volume) {
	  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
	    action: 'change-volume',
	    source: ''
	  };
	
	  var v = volume;
	  if (volume < 0) {
	    v = 0;
	  }
	  if (volume > 1) {
	    v = 1;
	  }
	  this.video.volume = v;
	
	  return {
	    type: OPERATE,
	    operation: operation
	  };
	}
	
	function mute(muted) {
	  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
	    action: muted ? 'muted' : 'unmuted',
	    source: ''
	  };
	
	  this.video.muted = muted;
	
	  return {
	    type: OPERATE,
	    operation: operation
	  };
	}
	
	function toggleFullscreen(player) {
	  if (_fullscreen2.default.enabled) {
	    if (_fullscreen2.default.isFullscreen) {
	      _fullscreen2.default.exit();
	    } else {
	      _fullscreen2.default.request(this.rootElement);
	    }
	    return {
	      type: OPERATE,
	      operation: {
	        action: 'toggle-fullscreen',
	        source: ''
	      }
	    };
	  }
	
	  return {
	    type: FULLSCREEN_CHANGE,
	    isFullscreen: !player.isFullscreen
	  };
	}

/***/ }),

/***/ 179:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.handleLoadStart = handleLoadStart;
	exports.handleCanPlay = handleCanPlay;
	exports.handleWaiting = handleWaiting;
	exports.handleCanPlayThrough = handleCanPlayThrough;
	exports.handlePlaying = handlePlaying;
	exports.handlePlay = handlePlay;
	exports.handlePause = handlePause;
	exports.handleEnd = handleEnd;
	exports.handleSeeking = handleSeeking;
	exports.handleSeeked = handleSeeked;
	exports.handleDurationChange = handleDurationChange;
	exports.handleTimeUpdate = handleTimeUpdate;
	exports.handleVolumeChange = handleVolumeChange;
	exports.handleProgressChange = handleProgressChange;
	exports.handleRateChange = handleRateChange;
	exports.handleSuspend = handleSuspend;
	exports.handleAbort = handleAbort;
	exports.handleEmptied = handleEmptied;
	exports.handleStalled = handleStalled;
	exports.handleLoadedMetaData = handleLoadedMetaData;
	exports.handleLoadedData = handleLoadedData;
	exports.handleResize = handleResize;
	exports.handleError = handleError;
	exports.handleSeekingTime = handleSeekingTime;
	exports.handleEndSeeking = handleEndSeeking;
	var LOAD_START = exports.LOAD_START = 'video-react/LOAD_START';
	var CAN_PLAY = exports.CAN_PLAY = 'video-react/CAN_PLAY';
	var WAITING = exports.WAITING = 'video-react/WAITING';
	var CAN_PLAY_THROUGH = exports.CAN_PLAY_THROUGH = 'video-react/CAN_PLAY_THROUGH';
	var PLAYING = exports.PLAYING = 'video-react/PLAYING';
	var PLAY = exports.PLAY = 'video-react/PLAY';
	var PAUSE = exports.PAUSE = 'video-react/PAUSE';
	var END = exports.END = 'video-react/END';
	var SEEKING = exports.SEEKING = 'video-react/SEEKING';
	var SEEKED = exports.SEEKED = 'video-react/SEEKED';
	var SEEKING_TIME = exports.SEEKING_TIME = 'video-react/SEEKING_TIME';
	var END_SEEKING = exports.END_SEEKING = 'video-react/END_SEEKING';
	var DURATION_CHANGE = exports.DURATION_CHANGE = 'video-react/DURATION_CHANGE';
	var TIME_UPDATE = exports.TIME_UPDATE = 'video-react/TIME_UPDATE';
	var VOLUME_CHANGE = exports.VOLUME_CHANGE = 'video-react/VOLUME_CHANGE';
	var PROGRESS_CHANGE = exports.PROGRESS_CHANGE = 'video-react/PROGRESS_CHANGE';
	var RATE_CHANGE = exports.RATE_CHANGE = 'video-react/RATE_CHANGE';
	var SUSPEND = exports.SUSPEND = 'video-react/SUSPEND';
	var ABORT = exports.ABORT = 'video-react/ABORT';
	var EMPTIED = exports.EMPTIED = 'video-react/EMPTIED';
	var STALLED = exports.STALLED = 'video-react/STALLED';
	var LOADED_META_DATA = exports.LOADED_META_DATA = 'video-react/LOADED_META_DATA';
	var LOADED_DATA = exports.LOADED_DATA = 'video-react/LOADED_DATA';
	var RESIZE = exports.RESIZE = 'video-react/RESIZE';
	var ERROR = exports.ERROR = 'video-react/ERROR';
	
	function handleLoadStart(videoProps) {
	  return {
	    type: LOAD_START,
	    videoProps: videoProps
	  };
	}
	
	function handleCanPlay(videoProps) {
	  return {
	    type: CAN_PLAY,
	    videoProps: videoProps
	  };
	}
	
	function handleWaiting(videoProps) {
	  return {
	    type: WAITING,
	    videoProps: videoProps
	  };
	}
	
	function handleCanPlayThrough(videoProps) {
	  return {
	    type: CAN_PLAY_THROUGH,
	    videoProps: videoProps
	  };
	}
	
	function handlePlaying(videoProps) {
	  return {
	    type: PLAYING,
	    videoProps: videoProps
	  };
	}
	
	function handlePlay(videoProps) {
	  return {
	    type: PLAY,
	    videoProps: videoProps
	  };
	}
	
	function handlePause(videoProps) {
	  return {
	    type: PAUSE,
	    videoProps: videoProps
	  };
	}
	
	function handleEnd(videoProps) {
	  return {
	    type: END,
	    videoProps: videoProps
	  };
	}
	
	function handleSeeking(videoProps) {
	  return {
	    type: SEEKING,
	    videoProps: videoProps
	  };
	}
	
	function handleSeeked(videoProps) {
	  return {
	    type: SEEKED,
	    videoProps: videoProps
	  };
	}
	
	function handleDurationChange(videoProps) {
	  return {
	    type: DURATION_CHANGE,
	    videoProps: videoProps
	  };
	}
	
	function handleTimeUpdate(videoProps) {
	  return {
	    type: TIME_UPDATE,
	    videoProps: videoProps
	  };
	}
	
	function handleVolumeChange(videoProps) {
	  return {
	    type: VOLUME_CHANGE,
	    videoProps: videoProps
	  };
	}
	
	function handleProgressChange(videoProps) {
	  return {
	    type: PROGRESS_CHANGE,
	    videoProps: videoProps
	  };
	}
	
	function handleRateChange(videoProps) {
	  return {
	    type: RATE_CHANGE,
	    videoProps: videoProps
	  };
	}
	
	function handleSuspend(videoProps) {
	  return {
	    type: SUSPEND,
	    videoProps: videoProps
	  };
	}
	
	function handleAbort(videoProps) {
	  return {
	    type: ABORT,
	    videoProps: videoProps
	  };
	}
	
	function handleEmptied(videoProps) {
	  return {
	    type: EMPTIED,
	    videoProps: videoProps
	  };
	}
	
	function handleStalled(videoProps) {
	  return {
	    type: STALLED,
	    videoProps: videoProps
	  };
	}
	
	function handleLoadedMetaData(videoProps) {
	  return {
	    type: LOADED_META_DATA,
	    videoProps: videoProps
	  };
	}
	
	function handleLoadedData(videoProps) {
	  return {
	    type: LOADED_DATA,
	    videoProps: videoProps
	  };
	}
	
	function handleResize(videoProps) {
	  return {
	    type: RESIZE,
	    videoProps: videoProps
	  };
	}
	
	function handleError(videoProps) {
	  return {
	    type: ERROR,
	    videoProps: videoProps
	  };
	}
	
	function handleSeekingTime(time) {
	  return {
	    type: SEEKING_TIME,
	    time: time
	  };
	}
	
	function handleEndSeeking(time) {
	  return {
	    type: END_SEEKING,
	    time: time
	  };
	}

/***/ }),

/***/ 231:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  manager: _propTypes2.default.object,
	  className: _propTypes2.default.string
	};
	
	var Bezel = function (_Component) {
	  _inherits(Bezel, _Component);
	
	  function Bezel(props, context) {
	    _classCallCheck(this, Bezel);
	
	    var _this = _possibleConstructorReturn(this, (Bezel.__proto__ || Object.getPrototypeOf(Bezel)).call(this, props, context));
	
	    _this.timer = null;
	    props.manager.subscribeToOperationStateChange(_this.handleStateChange.bind(_this));
	
	    _this.state = {
	      hidden: true,
	      operation: {}
	    };
	    return _this;
	  }
	
	  _createClass(Bezel, [{
	    key: 'handleStateChange',
	    value: function handleStateChange(state, prevState) {
	      var _this2 = this;
	
	      if (state.count !== prevState.count && state.operation.source === 'shortcut') {
	        if (this.timer) {
	          // previous animation is not finished
	          clearTimeout(this.timer); // cancel it
	          this.timer = null;
	        }
	
	        // show it
	        // update operation
	        this.setState({
	          hidden: false,
	          count: state.count,
	          operation: state.operation
	        });
	
	        // hide it after 0.5s
	        this.timer = setTimeout(function () {
	          _this2.setState({
	            hidden: true
	          });
	          _this2.timer = null;
	        }, 500);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      // only displays for shortcut so far
	      if (this.state.operation.source !== 'shortcut') {
	        return null;
	      }
	      var style = this.state.hidden ? {
	        display: 'none'
	      } : null;
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)({
	            'video-react-bezel': true,
	            'video-react-bezel-animation': this.state.count % 2 === 0,
	            'video-react-bezel-animation-alt': this.state.count % 2 === 1
	          }, this.props.className),
	          style: style,
	          role: 'status',
	          'aria-label': this.state.operation.action
	        },
	        _react2.default.createElement('div', {
	          className: (0, _classnames2.default)('video-react-bezel-icon', 'video-react-bezel-icon-' + this.state.operation.action)
	        })
	      );
	    }
	  }]);
	
	  return Bezel;
	}(_react.Component);
	
	exports.default = Bezel;
	
	
	Bezel.propTypes = propTypes;
	Bezel.displayName = 'Bezel';

/***/ }),

/***/ 232:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  actions: _propTypes2.default.object,
	  player: _propTypes2.default.object,
	  position: _propTypes2.default.string,
	  className: _propTypes2.default.string
	};
	
	var defaultProps = {
	  position: 'left'
	};
	
	var BigPlayButton = function (_Component) {
	  _inherits(BigPlayButton, _Component);
	
	  function BigPlayButton(props, context) {
	    _classCallCheck(this, BigPlayButton);
	
	    var _this = _possibleConstructorReturn(this, (BigPlayButton.__proto__ || Object.getPrototypeOf(BigPlayButton)).call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(BigPlayButton, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'handleClick',
	    value: function handleClick() {
	      var actions = this.props.actions;
	
	      actions.play();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          player = _props.player,
	          position = _props.position;
	
	      return _react2.default.createElement(
	        'button',
	        {
	          className: (0, _classnames2.default)('video-react-big-play-button', 'video-react-big-play-button-' + position, this.props.className, {
	            'big-play-button-hide': player.hasStarted || !player.currentSrc
	          }),
	          type: 'button',
	          'aria-live': 'polite',
	          tabIndex: '0',
	          onClick: this.handleClick
	        },
	        _react2.default.createElement(
	          'span',
	          { className: 'video-react-control-text' },
	          'Play Video'
	        )
	      );
	    }
	  }]);
	
	  return BigPlayButton;
	}(_react.Component);
	
	exports.default = BigPlayButton;
	
	
	BigPlayButton.propTypes = propTypes;
	BigPlayButton.defaultProps = defaultProps;
	BigPlayButton.displayName = 'BigPlayButton';

/***/ }),

/***/ 233:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  tagName: _propTypes2.default.string.isRequired,
	  onClick: _propTypes2.default.func.isRequired,
	  onFocus: _propTypes2.default.func,
	  onBlur: _propTypes2.default.func,
	  className: _propTypes2.default.string
	};
	
	var defaultProps = {
	  tagName: 'div'
	};
	
	var ClickableComponent = function (_Component) {
	  _inherits(ClickableComponent, _Component);
	
	  function ClickableComponent(props, context) {
	    _classCallCheck(this, ClickableComponent);
	
	    var _this = _possibleConstructorReturn(this, (ClickableComponent.__proto__ || Object.getPrototypeOf(ClickableComponent)).call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    _this.handleFocus = _this.handleFocus.bind(_this);
	    _this.handleBlur = _this.handleBlur.bind(_this);
	    _this.handleKeypress = _this.handleKeypress.bind(_this);
	    return _this;
	  }
	
	  _createClass(ClickableComponent, [{
	    key: 'handleKeypress',
	    value: function handleKeypress(event) {
	      // Support Space (32) or Enter (13) key operation to fire a click event
	      if (event.which === 32 || event.which === 13) {
	        event.preventDefault();
	        this.handleClick(event);
	      }
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick(event) {
	      var onClick = this.props.onClick;
	
	      onClick(event);
	    }
	  }, {
	    key: 'handleFocus',
	    value: function handleFocus(e) {
	      document.addEventListener('keydown', this.handleKeypress);
	      if (this.props.onFocus) {
	        this.props.onFocus(e);
	      }
	    }
	  }, {
	    key: 'handleBlur',
	    value: function handleBlur(e) {
	      document.removeEventListener('keydown', this.handleKeypress);
	      if (this.props.onBlur) {
	        this.props.onBlur(e);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var Tag = this.props.tagName;
	      var props = _extends({}, this.props);
	      delete props.tagName;
	      delete props.className;
	      return _react2.default.createElement(Tag, _extends({
	        className: (0, _classnames2.default)(this.props.className),
	        role: 'button',
	        tabIndex: '0',
	        onClick: this.handleClick,
	        onFocus: this.handleFocus,
	        onBlur: this.handleBlur
	      }, props));
	    }
	  }]);
	
	  return ClickableComponent;
	}(_react.Component);
	
	exports.default = ClickableComponent;
	
	
	ClickableComponent.propTypes = propTypes;
	ClickableComponent.defaultProps = defaultProps;
	ClickableComponent.displayName = 'ClickableComponent';

/***/ }),

/***/ 234:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = LoadingSpinner;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _player = __webpack_require__(65);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  player: _propTypes2.default.object,
	  className: _propTypes2.default.string
	};
	
	function LoadingSpinner(_ref) {
	  var player = _ref.player,
	      className = _ref.className;
	
	  if (player.error) {
	    return null;
	  }
	  return _react2.default.createElement('div', {
	    className: (0, _classnames2.default)('video-react-loading-spinner', className)
	  });
	}
	
	LoadingSpinner.propTypes = propTypes;
	LoadingSpinner.displayName = 'LoadingSpinner';

/***/ }),

/***/ 704:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Manager = __webpack_require__(703);
	
	var _Manager2 = _interopRequireDefault(_Manager);
	
	var _BigPlayButton = __webpack_require__(232);
	
	var _BigPlayButton2 = _interopRequireDefault(_BigPlayButton);
	
	var _LoadingSpinner = __webpack_require__(234);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	var _PosterImage = __webpack_require__(235);
	
	var _PosterImage2 = _interopRequireDefault(_PosterImage);
	
	var _Video = __webpack_require__(237);
	
	var _Video2 = _interopRequireDefault(_Video);
	
	var _Bezel = __webpack_require__(231);
	
	var _Bezel2 = _interopRequireDefault(_Bezel);
	
	var _Shortcut = __webpack_require__(236);
	
	var _Shortcut2 = _interopRequireDefault(_Shortcut);
	
	var _ControlBar = __webpack_require__(238);
	
	var _ControlBar2 = _interopRequireDefault(_ControlBar);
	
	var _browser = __webpack_require__(716);
	
	var browser = _interopRequireWildcard(_browser);
	
	var _utils = __webpack_require__(21);
	
	var _fullscreen = __webpack_require__(255);
	
	var _fullscreen2 = _interopRequireDefault(_fullscreen);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  children: _propTypes2.default.any,
	
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  fluid: _propTypes2.default.bool,
	  muted: _propTypes2.default.bool,
	  playsInline: _propTypes2.default.bool,
	  aspectRatio: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  videoId: _propTypes2.default.string,
	
	  startTime: _propTypes2.default.number,
	  loop: _propTypes2.default.bool,
	  autoPlay: _propTypes2.default.bool,
	  src: _propTypes2.default.string,
	  poster: _propTypes2.default.string,
	  preload: _propTypes2.default.oneOf(['auto', 'metadata', 'none']),
	
	  onLoadStart: _propTypes2.default.func,
	  onWaiting: _propTypes2.default.func,
	  onCanPlay: _propTypes2.default.func,
	  onCanPlayThrough: _propTypes2.default.func,
	  onPlaying: _propTypes2.default.func,
	  onEnded: _propTypes2.default.func,
	  onSeeking: _propTypes2.default.func,
	  onSeeked: _propTypes2.default.func,
	  onPlay: _propTypes2.default.func,
	  onPause: _propTypes2.default.func,
	  onProgress: _propTypes2.default.func,
	  onDurationChange: _propTypes2.default.func,
	  onError: _propTypes2.default.func,
	  onSuspend: _propTypes2.default.func,
	  onAbort: _propTypes2.default.func,
	  onEmptied: _propTypes2.default.func,
	  onStalled: _propTypes2.default.func,
	  onLoadedMetadata: _propTypes2.default.func,
	  onLoadedData: _propTypes2.default.func,
	  onTimeUpdate: _propTypes2.default.func,
	  onRateChange: _propTypes2.default.func,
	  onVolumeChange: _propTypes2.default.func,
	
	  store: _propTypes2.default.object
	};
	
	var defaultProps = {
	  fluid: true,
	  muted: false,
	  playsInline: false,
	  aspectRatio: 'auto'
	};
	
	var Player = function (_Component) {
	  _inherits(Player, _Component);
	
	  function Player(props) {
	    _classCallCheck(this, Player);
	
	    var _this = _possibleConstructorReturn(this, (Player.__proto__ || Object.getPrototypeOf(Player)).call(this, props));
	
	    _this.controlsHideTimer = null;
	
	    _this.video = null; // the Video component
	    _this.manager = new _Manager2.default(props.store);
	    _this.actions = _this.manager.getActions();
	    _this.manager.subscribeToPlayerStateChange(_this.handleStateChange.bind(_this));
	
	    _this.getStyle = _this.getStyle.bind(_this);
	    _this.handleResize = _this.handleResize.bind(_this);
	    _this.getChildren = _this.getChildren.bind(_this);
	    _this.handleMouseMove = (0, _utils.throttle)(_this.handleMouseMove.bind(_this), 250);
	    _this.handleMouseDown = _this.handleMouseDown.bind(_this);
	    _this.startControlsTimer = _this.startControlsTimer.bind(_this);
	    _this.handleFullScreenChange = _this.handleFullScreenChange.bind(_this);
	    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
	    _this.handleFocus = _this.handleFocus.bind(_this);
	    _this.handleBlur = _this.handleBlur.bind(_this);
	    return _this;
	  }
	
	  _createClass(Player, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.handleResize();
	      window.addEventListener('resize', this.handleResize);
	
	      _fullscreen2.default.addEventListener(this.handleFullScreenChange);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      // Remove event listener
	      window.removeEventListener('resize', this.handleResize);
	      _fullscreen2.default.removeEventListener(this.handleFullScreenChange);
	      if (this.controlsHideTimer) {
	        window.clearTimeout(this.controlsHideTimer);
	      }
	    }
	  }, {
	    key: 'getDefaultChildren',
	    value: function getDefaultChildren(props, fullProps) {
	      var _this2 = this;
	
	      return [_react2.default.createElement(_Video2.default, _extends({
	        ref: function ref(c) {
	          _this2.video = c;
	          _this2.manager.video = _this2.video;
	        },
	        key: 'video',
	        order: 0.0
	      }, fullProps)), _react2.default.createElement(_PosterImage2.default, _extends({
	        key: 'poster-image',
	        order: 1.0
	      }, props)), _react2.default.createElement(_LoadingSpinner2.default, _extends({
	        key: 'loading-spinner',
	        order: 2.0
	      }, props)), _react2.default.createElement(_Bezel2.default, _extends({
	        key: 'bezel',
	        order: 3.0
	      }, props)), _react2.default.createElement(_BigPlayButton2.default, _extends({
	        key: 'big-play-button',
	        order: 4.0
	      }, props)), _react2.default.createElement(_ControlBar2.default, _extends({
	        key: 'control-bar',
	        order: 5.0
	      }, props)), _react2.default.createElement(_Shortcut2.default, _extends({
	        key: 'shortcut',
	        order: 99.0
	      }, props))];
	    }
	  }, {
	    key: 'getChildren',
	    value: function getChildren(props) {
	      var propsWithoutChildren = _extends({}, props, {
	        children: null
	      });
	      var children = _react2.default.Children.toArray(this.props.children).filter(function (e) {
	        return !(0, _utils.isVideoChild)(e);
	      });
	      var defaultChildren = this.getDefaultChildren(propsWithoutChildren, props);
	      return (0, _utils.mergeAndSortChildren)(defaultChildren, children, propsWithoutChildren);
	    }
	  }, {
	    key: 'setWidthOrHeight',
	    value: function setWidthOrHeight(style, name, value) {
	      var styleVal = void 0;
	      if (typeof value === 'string') {
	        if (value === 'auto') {
	          styleVal = 'auto';
	        } else if (value.match(/\d+%/)) {
	          styleVal = value;
	        }
	      } else if (typeof value === 'number') {
	        styleVal = value + 'px';
	      }
	      Object.assign(style, _defineProperty({}, name, styleVal));
	    }
	  }, {
	    key: 'getStyle',
	    value: function getStyle() {
	      var fluid = this.props.fluid;
	
	      var _manager$getState = this.manager.getState(),
	          player = _manager$getState.player;
	
	      var style = {};
	      var width = void 0;
	      var height = void 0;
	      var aspectRatio = void 0;
	
	      // The aspect ratio is either used directly or to calculate width and height.
	      if (this.props.aspectRatio !== undefined && this.props.aspectRatio !== 'auto') {
	        // Use any aspectRatio that's been specifically set
	        aspectRatio = this.props.aspectRatio;
	      } else if (player.videoWidth) {
	        // Otherwise try to get the aspect ratio from the video metadata
	        aspectRatio = player.videoWidth + ':' + player.videoHeight;
	      } else {
	        // Or use a default. The video element's is 2:1, but 16:9 is more common.
	        aspectRatio = '16:9';
	      }
	
	      // Get the ratio as a decimal we can use to calculate dimensions
	      var ratioParts = aspectRatio.split(':');
	      var ratioMultiplier = ratioParts[1] / ratioParts[0];
	
	      if (this.props.width !== undefined) {
	        // Use any width that's been specifically set
	        width = this.props.width;
	      } else if (this.props.height !== undefined) {
	        // Or calulate the width from the aspect ratio if a height has been set
	        width = this.props.height / ratioMultiplier;
	      } else {
	        // Or use the video's metadata, or use the video el's default of 300
	        width = player.videoWidth || 400;
	      }
	
	      if (this.props.height !== undefined) {
	        // Use any height that's been specifically set
	        height = this.props.height;
	      } else {
	        // Otherwise calculate the height from the ratio and the width
	        height = width * ratioMultiplier;
	      }
	
	      if (fluid) {
	        style.paddingTop = ratioMultiplier * 100 + '%';
	      } else {
	        // If Width contains "auto", set "auto" in style
	        this.setWidthOrHeight(style, 'width', width);
	        this.setWidthOrHeight(style, 'height', height);
	      }
	
	      return style;
	    }
	
	    // get redux state
	    // { player, operation }
	
	  }, {
	    key: 'getState',
	    value: function getState() {
	      return this.manager.getState();
	    }
	
	    // get playback rate
	
	  }, {
	    key: 'play',
	
	
	    // play the video
	    value: function play() {
	      this.video.play();
	    }
	
	    // pause the video
	
	  }, {
	    key: 'pause',
	    value: function pause() {
	      this.video.pause();
	    }
	
	    // Change the video source and re-load the video:
	
	  }, {
	    key: 'load',
	    value: function load() {
	      this.video.load();
	    }
	
	    // Add a new text track to the video
	
	  }, {
	    key: 'addTextTrack',
	    value: function addTextTrack() {
	      var _video;
	
	      (_video = this.video).addTextTrack.apply(_video, arguments);
	    }
	
	    // Check if your browser can play different types of video:
	
	  }, {
	    key: 'canPlayType',
	    value: function canPlayType() {
	      var _video2;
	
	      (_video2 = this.video).canPlayType.apply(_video2, arguments);
	    }
	
	    // seek video by time
	
	  }, {
	    key: 'seek',
	    value: function seek(time) {
	      this.video.seek(time);
	    }
	
	    // jump forward x seconds
	
	  }, {
	    key: 'forward',
	    value: function forward(seconds) {
	      this.video.forward(seconds);
	    }
	
	    // jump back x seconds
	
	  }, {
	    key: 'replay',
	    value: function replay(seconds) {
	      this.video.replay(seconds);
	    }
	
	    // enter or exist full screen
	
	  }, {
	    key: 'toggleFullscreen',
	    value: function toggleFullscreen() {
	      this.video.toggleFullscreen();
	    }
	
	    // subscribe to player state change
	
	  }, {
	    key: 'subscribeToStateChange',
	    value: function subscribeToStateChange(listener) {
	      return this.manager.subscribeToPlayerStateChange(listener);
	    }
	
	    // player resize
	
	  }, {
	    key: 'handleResize',
	    value: function handleResize() {}
	  }, {
	    key: 'handleFullScreenChange',
	    value: function handleFullScreenChange() {
	      this.actions.handleFullscreenChange(_fullscreen2.default.isFullscreen);
	    }
	  }, {
	    key: 'handleMouseDown',
	    value: function handleMouseDown() {
	      this.startControlsTimer();
	    }
	  }, {
	    key: 'handleMouseMove',
	    value: function handleMouseMove() {
	      this.startControlsTimer();
	    }
	  }, {
	    key: 'handleKeyDown',
	    value: function handleKeyDown() {
	      this.startControlsTimer();
	    }
	  }, {
	    key: 'startControlsTimer',
	    value: function startControlsTimer() {
	      var _this3 = this;
	
	      this.actions.userActivate(true);
	      clearTimeout(this.controlsHideTimer);
	      this.controlsHideTimer = setTimeout(function () {
	        _this3.actions.userActivate(false);
	      }, 3000);
	    }
	  }, {
	    key: 'handleStateChange',
	    value: function handleStateChange(state, prevState) {
	      if (state.isFullscreen !== prevState.isFullscreen) {
	        this.handleResize();
	      }
	      this.forceUpdate(); // re-render
	    }
	  }, {
	    key: 'handleFocus',
	    value: function handleFocus() {
	      this.actions.activate(true);
	    }
	  }, {
	    key: 'handleBlur',
	    value: function handleBlur() {
	      this.actions.activate(false);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var fluid = this.props.fluid;
	
	      var _manager$getState2 = this.manager.getState(),
	          player = _manager$getState2.player;
	
	      var paused = player.paused,
	          hasStarted = player.hasStarted,
	          waiting = player.waiting,
	          seeking = player.seeking,
	          isFullscreen = player.isFullscreen,
	          userActivity = player.userActivity;
	
	
	      var props = _extends({}, this.props, {
	        player: player,
	        actions: this.actions,
	        manager: this.manager,
	        store: this.manager.store,
	        video: this.video ? this.video.video : null
	      });
	      var children = this.getChildren(props);
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)({
	            'video-react-controls-enabled': true,
	            'video-react-has-started': hasStarted,
	            'video-react-paused': paused,
	            'video-react-playing': !paused,
	            'video-react-waiting': waiting,
	            'video-react-seeking': seeking,
	            'video-react-fluid': fluid,
	            'video-react-fullscreen': isFullscreen,
	            'video-react-user-inactive': !userActivity,
	            'video-react-user-active': userActivity,
	            'video-react-workinghover': !browser.IS_IOS
	          }, 'video-react', this.props.className),
	          style: this.getStyle(),
	          ref: function ref(c) {
	            _this4.manager.rootElement = c;
	          },
	          role: 'region',
	          onTouchStart: this.handleMouseDown,
	          onMouseDown: this.handleMouseDown,
	          onMouseMove: this.handleMouseMove,
	          onKeyDown: this.handleKeyDown,
	          onFocus: this.handleFocus,
	          onBlur: this.handleBlur,
	          tabIndex: '-1'
	        },
	        children
	      );
	    }
	  }, {
	    key: 'playbackRate',
	    get: function get() {
	      return this.video.playbackRate;
	    }
	
	    // set playback rate
	    // speed of video
	    ,
	    set: function set(rate) {
	      this.video.playbackRate = rate;
	    }
	  }, {
	    key: 'muted',
	    get: function get() {
	      return this.video.muted;
	    },
	    set: function set(val) {
	      this.video.muted = val;
	    }
	  }, {
	    key: 'volume',
	    get: function get() {
	      return this.video.volume;
	    },
	    set: function set(val) {
	      this.video.volume = val;
	    }
	
	    // video width
	
	  }, {
	    key: 'videoWidth',
	    get: function get() {
	      return this.video.videoWidth;
	    }
	
	    // video height
	
	  }, {
	    key: 'videoHeight',
	    get: function get() {
	      return this.video.videoHeight;
	    }
	  }]);
	
	  return Player;
	}(_react.Component);
	
	exports.default = Player;
	
	
	Player.contextTypes = { store: _propTypes2.default.object };
	Player.propTypes = propTypes;
	Player.defaultProps = defaultProps;
	Player.displayName = 'Player';

/***/ }),

/***/ 235:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  poster: _propTypes2.default.string,
	  player: _propTypes2.default.object,
	  actions: _propTypes2.default.object,
	  className: _propTypes2.default.string
	};
	
	function PosterImage(_ref) {
	  var poster = _ref.poster,
	      player = _ref.player,
	      actions = _ref.actions,
	      className = _ref.className;
	
	  if (!poster || player.hasStarted) {
	    return null;
	  }
	
	  return _react2.default.createElement('div', {
	    className: (0, _classnames2.default)('video-react-poster', className),
	    style: {
	      backgroundImage: 'url("' + poster + '")'
	    },
	    onClick: function onClick() {
	      if (player.paused) {
	        actions.play();
	      }
	    }
	  });
	}
	
	PosterImage.propTypes = propTypes;
	PosterImage.displayName = 'PosterImage';
	
	exports.default = PosterImage;

/***/ }),

/***/ 236:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _dom = __webpack_require__(182);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  clickable: _propTypes2.default.bool,
	  dblclickable: _propTypes2.default.bool,
	  manager: _propTypes2.default.object,
	  actions: _propTypes2.default.object,
	  player: _propTypes2.default.object,
	  shortcuts: _propTypes2.default.array
	};
	
	var defaultProps = {
	  clickable: true,
	  dblclickable: true
	};
	
	var Shortcut = function (_Component) {
	  _inherits(Shortcut, _Component);
	
	  function Shortcut(props, context) {
	    _classCallCheck(this, Shortcut);
	
	    var _this = _possibleConstructorReturn(this, (Shortcut.__proto__ || Object.getPrototypeOf(Shortcut)).call(this, props, context));
	
	    _this.defaultShortcuts = [{
	      keyCode: 32, // spacebar
	      handle: _this.togglePlay
	    }, {
	      keyCode: 75, // k
	      handle: _this.togglePlay
	    }, {
	      keyCode: 70, // f
	      handle: _this.toggleFullscreen
	    }, {
	      keyCode: 37, // Left arrow
	      handle: function handle(player, actions) {
	        if (!player.hasStarted) {
	          return;
	        }
	        actions.replay(5, {
	          action: 'replay-5',
	          source: 'shortcut'
	        }); // Go back 5 seconds
	      }
	    }, {
	      keyCode: 74, // j
	      handle: function handle(player, actions) {
	        if (!player.hasStarted) {
	          return;
	        }
	        actions.replay(10, {
	          action: 'replay-10',
	          source: 'shortcut'
	        }); // Go back 10 seconds
	      }
	    }, {
	      keyCode: 39, // Right arrow
	      handle: function handle(player, actions) {
	        if (!player.hasStarted) {
	          return;
	        }
	        actions.forward(5, {
	          action: 'forward-5',
	          source: 'shortcut'
	        }); // Go forward 5 seconds
	      }
	    }, {
	      keyCode: 76, // l
	      handle: function handle(player, actions) {
	        if (!player.hasStarted) {
	          return;
	        }
	        actions.forward(10, {
	          action: 'forward-10',
	          source: 'shortcut'
	        }); // Go forward 10 seconds
	      }
	    }, {
	      keyCode: 36, // Home
	      handle: function handle(player, actions) {
	        if (!player.hasStarted) {
	          return;
	        }
	        actions.seek(0); // Go to beginning of video
	      }
	    }, {
	      keyCode: 35, // End
	      handle: function handle(player, actions) {
	        if (!player.hasStarted) {
	          return;
	        }
	        // Go to end of video
	        actions.seek(player.duration);
	      }
	    }, {
	      keyCode: 38, // Up arrow
	      handle: function handle(player, actions) {
	        // Increase volume 5%
	        var v = player.volume + 0.05;
	        if (v > 1) {
	          v = 1;
	        }
	        actions.changeVolume(v, {
	          action: 'volume-up',
	          source: 'shortcut'
	        });
	      }
	    }, {
	      keyCode: 40, // Down arrow
	      handle: function handle(player, actions) {
	        // Decrease volume 5%
	        var v = player.volume - 0.05;
	        if (v < 0) {
	          v = 0;
	        }
	        var action = v > 0 ? 'volume-down' : 'volume-off';
	        actions.changeVolume(v, {
	          action: action,
	          source: 'shortcut'
	        });
	      }
	    }, {
	      keyCode: 190, // Shift + >
	      shift: true,
	      handle: function handle(player, actions) {
	        // Increase speed
	        var playbackRate = player.playbackRate;
	        if (playbackRate >= 1.5) {
	          playbackRate = 2;
	        } else if (playbackRate >= 1.25) {
	          playbackRate = 1.5;
	        } else if (playbackRate >= 1.0) {
	          playbackRate = 1.25;
	        } else if (playbackRate >= 0.5) {
	          playbackRate = 1.0;
	        } else if (playbackRate >= 0.25) {
	          playbackRate = 0.5;
	        } else if (playbackRate >= 0) {
	          playbackRate = 0.25;
	        }
	        actions.changeRate(playbackRate, {
	          action: 'fast-forward',
	          source: 'shortcut'
	        });
	      }
	    }, {
	      keyCode: 188, // Shift + <
	      shift: true,
	      handle: function handle(player, actions) {
	        // Decrease speed
	        var playbackRate = player.playbackRate;
	        if (playbackRate <= 0.5) {
	          playbackRate = 0.25;
	        } else if (playbackRate <= 1.0) {
	          playbackRate = 0.5;
	        } else if (playbackRate <= 1.25) {
	          playbackRate = 1.0;
	        } else if (playbackRate <= 1.5) {
	          playbackRate = 1.25;
	        } else if (playbackRate <= 2) {
	          playbackRate = 1.5;
	        }
	        actions.changeRate(playbackRate, {
	          action: 'fast-rewind',
	          source: 'shortcut'
	        });
	      }
	    }];
	
	    _this.shortcuts = [].concat(_toConsumableArray(_this.defaultShortcuts));
	
	    _this.mergeShortcuts = _this.mergeShortcuts.bind(_this);
	    _this.handleKeyPress = _this.handleKeyPress.bind(_this);
	    _this.handleClick = _this.handleClick.bind(_this);
	    _this.handleDoubleClick = _this.handleDoubleClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(Shortcut, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.mergeShortcuts();
	      document.addEventListener('keydown', this.handleKeyPress);
	      document.addEventListener('click', this.handleClick);
	      document.addEventListener('dblclick', this.handleDoubleClick);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.shortcuts !== this.props.shortcuts) {
	        this.mergeShortcuts();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.removeEventListener('keydown', this.handleKeyPress);
	      document.removeEventListener('click', this.handleClick);
	      document.removeEventListener('dblclick', this.handleDoubleClick);
	    }
	
	    // merge the shortcuts from props
	
	  }, {
	    key: 'mergeShortcuts',
	    value: function mergeShortcuts() {
	      var getShortcutKey = function getShortcutKey(_ref) {
	        var _ref$keyCode = _ref.keyCode,
	            keyCode = _ref$keyCode === undefined ? 0 : _ref$keyCode,
	            _ref$ctrl = _ref.ctrl,
	            ctrl = _ref$ctrl === undefined ? false : _ref$ctrl,
	            _ref$shift = _ref.shift,
	            shift = _ref$shift === undefined ? false : _ref$shift,
	            _ref$alt = _ref.alt,
	            alt = _ref$alt === undefined ? false : _ref$alt;
	        return keyCode + ':' + ctrl + ':' + shift + ':' + alt;
	      };
	      var defaultShortcuts = this.defaultShortcuts.reduce(function (shortcuts, shortcut) {
	        return Object.assign(shortcuts, _defineProperty({}, getShortcutKey(shortcut), shortcut));
	      }, {});
	      var mergedShortcuts = (this.props.shortcuts || []).reduce(function (shortcuts, shortcut) {
	        var keyCode = shortcut.keyCode,
	            handle = shortcut.handle;
	
	        if (keyCode && typeof handle === 'function') {
	          return Object.assign(shortcuts, _defineProperty({}, getShortcutKey(shortcut), shortcut));
	        }
	        return shortcuts;
	      }, defaultShortcuts);
	
	      var gradeShortcut = function gradeShortcut(s) {
	        var score = 0;
	        var ps = ['ctrl', 'shift', 'alt'];
	        ps.forEach(function (key) {
	          if (s[key]) {
	            score++;
	          }
	        });
	        return score;
	      };
	
	      this.shortcuts = Object.keys(mergedShortcuts).map(function (key) {
	        return mergedShortcuts[key];
	      }).sort(function (a, b) {
	        return gradeShortcut(b) - gradeShortcut(a);
	      });
	    }
	  }, {
	    key: 'togglePlay',
	    value: function togglePlay(player, actions) {
	      if (player.paused) {
	        actions.play({
	          action: 'play',
	          source: 'shortcut'
	        });
	      } else {
	        actions.pause({
	          action: 'pause',
	          source: 'shortcut'
	        });
	      }
	    }
	  }, {
	    key: 'toggleFullscreen',
	    value: function toggleFullscreen(player, actions) {
	      actions.toggleFullscreen(player);
	    }
	  }, {
	    key: 'handleKeyPress',
	    value: function handleKeyPress(e) {
	      var _props = this.props,
	          player = _props.player,
	          actions = _props.actions;
	
	      if (!player.isActive) {
	        return;
	      }
	      if (document.activeElement && ((0, _dom.hasClass)(document.activeElement, 'video-react-control') || (0, _dom.hasClass)(document.activeElement, 'video-react-menu-button-active')
	      // || hasClass(document.activeElement, 'video-react-slider')
	      || (0, _dom.hasClass)(document.activeElement, 'video-react-big-play-button'))) {
	        return;
	      }
	
	      var keyCode = e.keyCode || e.which;
	      var ctrl = e.ctrlKey || e.metaKey;
	      var shift = e.shiftKey;
	      var alt = e.altKey;
	
	      var shortcut = this.shortcuts.filter(function (s) {
	        if (!s.keyCode || s.keyCode - keyCode !== 0) {
	          return false;
	        }
	        if (s.ctrl !== undefined && s.ctrl !== ctrl || s.shift !== undefined && s.shift !== shift || s.alt !== undefined && s.alt !== alt) {
	          return false;
	        }
	        return true;
	      })[0];
	
	      if (shortcut) {
	        shortcut.handle(player, actions);
	        e.preventDefault();
	      }
	    }
	
	    // only if player is active and player is ready
	
	  }, {
	    key: 'canBeClicked',
	    value: function canBeClicked(player, e) {
	      if (!player.isActive || e.target.nodeName !== 'VIDEO' || player.readyState !== 4) {
	        return false;
	      }
	      return true;
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick(e) {
	      var _props2 = this.props,
	          player = _props2.player,
	          actions = _props2.actions,
	          clickable = _props2.clickable;
	
	      if (!this.canBeClicked(player, e) || !clickable) {
	        return;
	      }
	      this.togglePlay(player, actions);
	      // e.preventDefault();
	    }
	  }, {
	    key: 'handleDoubleClick',
	    value: function handleDoubleClick(e) {
	      var _props3 = this.props,
	          player = _props3.player,
	          actions = _props3.actions,
	          dblclickable = _props3.dblclickable;
	
	      if (!this.canBeClicked(player, e) || !dblclickable) {
	        return;
	      }
	      this.toggleFullscreen(player, actions);
	      // e.preventDefault();
	    }
	
	    // this component dose not render anything
	    // it's just for the key down event
	
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return Shortcut;
	}(_react.Component);
	
	exports.default = Shortcut;
	
	
	Shortcut.propTypes = propTypes;
	Shortcut.defaultProps = defaultProps;
	Shortcut.displayName = 'Shortcut';

/***/ }),

/***/ 180:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(24);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _dom = __webpack_require__(182);
	
	var Dom = _interopRequireWildcard(_dom);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  className: _propTypes2.default.string,
	  onMouseDown: _propTypes2.default.func,
	  onMouseMove: _propTypes2.default.func,
	  stepForward: _propTypes2.default.func,
	  stepBack: _propTypes2.default.func,
	  sliderActive: _propTypes2.default.func,
	  sliderInactive: _propTypes2.default.func,
	  onMouseUp: _propTypes2.default.func,
	  onFocus: _propTypes2.default.func,
	  onBlur: _propTypes2.default.func,
	  onClick: _propTypes2.default.func,
	  getPercent: _propTypes2.default.func,
	  vertical: _propTypes2.default.bool,
	  children: _propTypes2.default.node,
	  label: _propTypes2.default.string,
	  valuenow: _propTypes2.default.string,
	  valuetext: _propTypes2.default.string
	};
	
	var Slider = function (_Component) {
	  _inherits(Slider, _Component);
	
	  function Slider(props, context) {
	    _classCallCheck(this, Slider);
	
	    var _this = _possibleConstructorReturn(this, (Slider.__proto__ || Object.getPrototypeOf(Slider)).call(this, props, context));
	
	    _this.handleMouseDown = _this.handleMouseDown.bind(_this);
	    _this.handleMouseMove = _this.handleMouseMove.bind(_this);
	    _this.handleMouseUp = _this.handleMouseUp.bind(_this);
	    _this.handleFocus = _this.handleFocus.bind(_this);
	    _this.handleBlur = _this.handleBlur.bind(_this);
	    _this.handleClick = _this.handleClick.bind(_this);
	    _this.handleKeyPress = _this.handleKeyPress.bind(_this);
	    _this.stepForward = _this.stepForward.bind(_this);
	    _this.stepBack = _this.stepBack.bind(_this);
	    _this.calculateDistance = _this.calculateDistance.bind(_this);
	    _this.getProgress = _this.getProgress.bind(_this);
	    _this.renderChildren = _this.renderChildren.bind(_this);
	
	    _this.state = {
	      active: false
	    };
	    return _this;
	  }
	
	  _createClass(Slider, [{
	    key: 'getProgress',
	    value: function getProgress() {
	      var getPercent = this.props.getPercent;
	
	      if (!getPercent) {
	        return 0;
	      }
	      var progress = getPercent();
	
	      // Protect against no duration and other division issues
	      if (typeof progress !== 'number' || progress < 0 || progress === Infinity) {
	        progress = 0;
	      }
	      return progress;
	    }
	  }, {
	    key: 'handleMouseDown',
	    value: function handleMouseDown(event) {
	      var onMouseDown = this.props.onMouseDown;
	      // event.preventDefault();
	      // event.stopPropagation();
	
	      document.addEventListener('mousemove', this.handleMouseMove, true);
	      document.addEventListener('mouseup', this.handleMouseUp, true);
	      document.addEventListener('touchmove', this.handleMouseMove, true);
	      document.addEventListener('touchend', this.handleMouseUp, true);
	
	      this.setState({
	        active: true,
	        distance: 0
	      });
	
	      if (this.props.sliderActive) {
	        this.props.sliderActive(event);
	      }
	
	      this.handleMouseMove(event);
	
	      if (onMouseDown) {
	        onMouseDown(event);
	      }
	    }
	  }, {
	    key: 'handleMouseMove',
	    value: function handleMouseMove(event) {
	      var onMouseMove = this.props.onMouseMove;
	
	
	      if (onMouseMove) {
	        onMouseMove(event);
	      }
	    }
	  }, {
	    key: 'handleMouseUp',
	    value: function handleMouseUp(event) {
	      var onMouseUp = this.props.onMouseUp;
	
	
	      document.removeEventListener('mousemove', this.handleMouseMove, true);
	      document.removeEventListener('mouseup', this.handleMouseUp, true);
	      document.removeEventListener('touchmove', this.handleMouseMove, true);
	      document.removeEventListener('touchend', this.handleMouseUp, true);
	
	      this.setState({
	        active: false
	      });
	
	      if (this.props.sliderInactive) {
	        this.props.sliderInactive(event);
	      }
	
	      if (onMouseUp) {
	        onMouseUp(event);
	      }
	    }
	  }, {
	    key: 'handleFocus',
	    value: function handleFocus(e) {
	      document.addEventListener('keydown', this.handleKeyPress, true);
	      if (this.props.onFocus) {
	        this.props.onFocus(e);
	      }
	    }
	  }, {
	    key: 'handleBlur',
	    value: function handleBlur(e) {
	      document.removeEventListener('keydown', this.handleKeyPress, true);
	      if (this.props.onBlur) {
	        this.props.onBlur(e);
	      }
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick(event) {
	      event.preventDefault();
	      // event.stopPropagation();
	      if (this.props.onClick) {
	        this.props.onClick(event);
	      }
	    }
	  }, {
	    key: 'handleKeyPress',
	    value: function handleKeyPress(event) {
	      if (event.which === 37 || event.which === 40) {
	        // Left and Down Arrows
	        event.preventDefault();
	        event.stopPropagation();
	        this.stepBack();
	      } else if (event.which === 38 || event.which === 39) {
	        // Up and Right Arrows
	        event.preventDefault();
	        event.stopPropagation();
	        this.stepForward();
	      }
	    }
	  }, {
	    key: 'stepForward',
	    value: function stepForward() {
	      if (this.props.stepForward) {
	        this.props.stepForward();
	      }
	    }
	  }, {
	    key: 'stepBack',
	    value: function stepBack() {
	      if (this.props.stepBack) {
	        this.props.stepBack();
	      }
	    }
	  }, {
	    key: 'calculateDistance',
	    value: function calculateDistance(event) {
	      var node = (0, _reactDom.findDOMNode)(this);
	      var position = Dom.getPointerPosition(node, event);
	      if (this.props.vertical) {
	        return position.y;
	      }
	      return position.x;
	    }
	  }, {
	    key: 'renderChildren',
	    value: function renderChildren() {
	      var progress = this.getProgress();
	      var percentage = (progress * 100).toFixed(2) + '%';
	      return _react2.default.Children.map(this.props.children, function (child) {
	        return _react2.default.cloneElement(child, { progress: progress, percentage: percentage });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          vertical = _props.vertical,
	          label = _props.label,
	          valuenow = _props.valuenow,
	          valuetext = _props.valuetext;
	
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)(this.props.className, {
	            'video-react-slider-vertical': vertical,
	            'video-react-slider-horizontal': !vertical,
	            'video-react-sliding': this.state.active
	          }, 'video-react-slider'),
	          tabIndex: '0',
	          onMouseDown: this.handleMouseDown,
	          onTouchStart: this.handleMouseDown,
	          onFocus: this.handleFocus,
	          onBlur: this.handleBlur,
	          onClick: this.handleClick,
	          'aria-label': label || '',
	          'aria-valuenow': valuenow || '',
	          'aria-valuetext': valuetext || '',
	          'aria-valuemin': 0,
	          'aria-valuemax': 100
	        },
	        this.renderChildren()
	      );
	    }
	  }]);
	
	  return Slider;
	}(_react.Component);
	
	exports.default = Slider;
	
	
	Slider.propTypes = propTypes;
	Slider.displayName = 'Slider';

/***/ }),

/***/ 237:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utils = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  actions: _propTypes2.default.object,
	  player: _propTypes2.default.object,
	  children: _propTypes2.default.any,
	  startTime: _propTypes2.default.number,
	  loop: _propTypes2.default.bool,
	  muted: _propTypes2.default.bool,
	  autoPlay: _propTypes2.default.bool,
	  playsInline: _propTypes2.default.bool,
	  src: _propTypes2.default.string,
	  poster: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  preload: _propTypes2.default.oneOf(['auto', 'metadata', 'none']),
	  crossOrigin: _propTypes2.default.string,
	
	  onLoadStart: _propTypes2.default.func,
	  onWaiting: _propTypes2.default.func,
	  onCanPlay: _propTypes2.default.func,
	  onCanPlayThrough: _propTypes2.default.func,
	  onPlaying: _propTypes2.default.func,
	  onEnded: _propTypes2.default.func,
	  onSeeking: _propTypes2.default.func,
	  onSeeked: _propTypes2.default.func,
	  onPlay: _propTypes2.default.func,
	  onPause: _propTypes2.default.func,
	  onProgress: _propTypes2.default.func,
	  onDurationChange: _propTypes2.default.func,
	  onError: _propTypes2.default.func,
	  onSuspend: _propTypes2.default.func,
	  onAbort: _propTypes2.default.func,
	  onEmptied: _propTypes2.default.func,
	  onStalled: _propTypes2.default.func,
	  onLoadedMetadata: _propTypes2.default.func,
	  onLoadedData: _propTypes2.default.func,
	  onTimeUpdate: _propTypes2.default.func,
	  onRateChange: _propTypes2.default.func,
	  onVolumeChange: _propTypes2.default.func,
	  onResize: _propTypes2.default.func
	};
	
	var defaultProps = {
	  preload: 'auto'
	};
	
	var Video = function (_Component) {
	  _inherits(Video, _Component);
	
	  function Video(props) {
	    _classCallCheck(this, Video);
	
	    var _this = _possibleConstructorReturn(this, (Video.__proto__ || Object.getPrototypeOf(Video)).call(this, props));
	
	    _this.video = null; // the html5 video
	    _this.play = _this.play.bind(_this);
	    _this.pause = _this.pause.bind(_this);
	    _this.seek = _this.seek.bind(_this);
	    _this.forward = _this.forward.bind(_this);
	    _this.replay = _this.replay.bind(_this);
	    _this.toggleFullscreen = _this.toggleFullscreen.bind(_this);
	    _this.getProperties = _this.getProperties.bind(_this);
	    _this.renderChildren = _this.renderChildren.bind(_this);
	    _this.handleLoadStart = _this.handleLoadStart.bind(_this);
	    _this.handleCanPlay = _this.handleCanPlay.bind(_this);
	    _this.handleCanPlayThrough = _this.handleCanPlayThrough.bind(_this);
	    _this.handlePlay = _this.handlePlay.bind(_this);
	    _this.handlePlaying = _this.handlePlaying.bind(_this);
	    _this.handlePause = _this.handlePause.bind(_this);
	    _this.handleEnded = _this.handleEnded.bind(_this);
	    _this.handleWaiting = _this.handleWaiting.bind(_this);
	    _this.handleSeeking = _this.handleSeeking.bind(_this);
	    _this.handleSeeked = _this.handleSeeked.bind(_this);
	    _this.handleFullscreenChange = _this.handleFullscreenChange.bind(_this);
	    _this.handleError = _this.handleError.bind(_this);
	    _this.handleSuspend = _this.handleSuspend.bind(_this);
	    _this.handleAbort = _this.handleAbort.bind(_this);
	    _this.handleEmptied = _this.handleEmptied.bind(_this);
	    _this.handleStalled = _this.handleStalled.bind(_this);
	    _this.handleLoadedMetaData = _this.handleLoadedMetaData.bind(_this);
	    _this.handleLoadedData = _this.handleLoadedData.bind(_this);
	    _this.handleTimeUpdate = _this.handleTimeUpdate.bind(_this);
	    _this.handleRateChange = _this.handleRateChange.bind(_this);
	    _this.handleVolumeChange = _this.handleVolumeChange.bind(_this);
	    _this.handleDurationChange = _this.handleDurationChange.bind(_this);
	    _this.handleProgress = (0, _utils.throttle)(_this.handleProgress.bind(_this), 250);
	    _this.handleKeypress = _this.handleKeypress.bind(_this);
	    return _this;
	  }
	
	  _createClass(Video, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.forceUpdate(); // make sure the children can get the video property
	    }
	
	    // get all video properties
	
	  }, {
	    key: 'getProperties',
	    value: function getProperties() {
	      var _this2 = this;
	
	      if (!this.video) {
	        return null;
	      }
	
	      return _utils.mediaProperties.reduce(function (properties, key) {
	        properties[key] = _this2.video[key];
	        return properties;
	      }, {});
	    }
	
	    // get playback rate
	
	  }, {
	    key: 'play',
	
	
	    // play the video
	    value: function play() {
	      var promise = this.video.play();
	      if (promise !== undefined) {
	        promise.catch(function (error) {}).then(function () {});
	      }
	    }
	
	    // pause the video
	
	  }, {
	    key: 'pause',
	    value: function pause() {
	      var promise = this.video.pause();
	      if (promise !== undefined) {
	        promise.catch(function (error) {}).then(function () {});
	      }
	    }
	
	    // Change the video source and re-load the video:
	
	  }, {
	    key: 'load',
	    value: function load() {
	      this.video.load();
	    }
	
	    // Add a new text track to the video
	
	  }, {
	    key: 'addTextTrack',
	    value: function addTextTrack() {
	      var _video;
	
	      (_video = this.video).addTextTrack.apply(_video, arguments);
	    }
	
	    // Check if your browser can play different types of video:
	
	  }, {
	    key: 'canPlayType',
	    value: function canPlayType() {
	      var _video2;
	
	      (_video2 = this.video).canPlayType.apply(_video2, arguments);
	    }
	
	    // toggle play
	
	  }, {
	    key: 'togglePlay',
	    value: function togglePlay() {
	      if (this.video.paused) {
	        this.play();
	      } else {
	        this.pause();
	      }
	    }
	
	    // seek video by time
	
	  }, {
	    key: 'seek',
	    value: function seek(time) {
	      try {
	        this.video.currentTime = time;
	      } catch (e) {
	        // console.log(e, 'Video is not ready.')
	      }
	    }
	
	    // jump forward x seconds
	
	  }, {
	    key: 'forward',
	    value: function forward(seconds) {
	      this.seek(this.video.currentTime + seconds);
	    }
	
	    // jump back x seconds
	
	  }, {
	    key: 'replay',
	    value: function replay(seconds) {
	      this.forward(-seconds);
	    }
	
	    // enter or exist full screen
	
	  }, {
	    key: 'toggleFullscreen',
	    value: function toggleFullscreen() {
	      var _props = this.props,
	          player = _props.player,
	          actions = _props.actions;
	
	      actions.toggleFullscreen(player);
	    }
	
	    // Fired when the user agent
	    // begins looking for media data
	
	  }, {
	    key: 'handleLoadStart',
	    value: function handleLoadStart() {
	      var _props2 = this.props,
	          actions = _props2.actions,
	          onLoadStart = _props2.onLoadStart;
	
	      actions.handleLoadStart(this.getProperties());
	      if (onLoadStart) {
	        onLoadStart.apply(undefined, arguments);
	      }
	    }
	
	    // A handler for events that
	    // signal that waiting has ended
	
	  }, {
	    key: 'handleCanPlay',
	    value: function handleCanPlay() {
	      var _props3 = this.props,
	          actions = _props3.actions,
	          onCanPlay = _props3.onCanPlay;
	
	
	      actions.handleCanPlay(this.getProperties());
	
	      if (onCanPlay) {
	        onCanPlay.apply(undefined, arguments);
	      }
	    }
	
	    // A handler for events that
	    // signal that waiting has ended
	
	  }, {
	    key: 'handleCanPlayThrough',
	    value: function handleCanPlayThrough() {
	      var _props4 = this.props,
	          actions = _props4.actions,
	          onCanPlayThrough = _props4.onCanPlayThrough;
	
	      actions.handleCanPlayThrough(this.getProperties());
	
	      if (onCanPlayThrough) {
	        onCanPlayThrough.apply(undefined, arguments);
	      }
	    }
	
	    // A handler for events that
	    // signal that waiting has ended
	
	  }, {
	    key: 'handlePlaying',
	    value: function handlePlaying() {
	      var _props5 = this.props,
	          actions = _props5.actions,
	          onPlaying = _props5.onPlaying;
	
	      actions.handlePlaying(this.getProperties());
	
	      if (onPlaying) {
	        onPlaying.apply(undefined, arguments);
	      }
	    }
	
	    // Fired whenever the media has been started
	
	  }, {
	    key: 'handlePlay',
	    value: function handlePlay() {
	      var _props6 = this.props,
	          actions = _props6.actions,
	          onPlay = _props6.onPlay;
	
	      actions.handlePlay(this.getProperties());
	
	      if (onPlay) {
	        onPlay.apply(undefined, arguments);
	      }
	    }
	
	    // Fired whenever the media has been paused
	
	  }, {
	    key: 'handlePause',
	    value: function handlePause() {
	      var _props7 = this.props,
	          actions = _props7.actions,
	          onPause = _props7.onPause;
	
	      actions.handlePause(this.getProperties());
	
	      if (onPause) {
	        onPause.apply(undefined, arguments);
	      }
	    }
	
	    // Fired when the duration of
	    // the media resource is first known or changed
	
	  }, {
	    key: 'handleDurationChange',
	    value: function handleDurationChange() {
	      var _props8 = this.props,
	          actions = _props8.actions,
	          onDurationChange = _props8.onDurationChange;
	
	      actions.handleDurationChange(this.getProperties());
	
	      if (onDurationChange) {
	        onDurationChange.apply(undefined, arguments);
	      }
	    }
	
	    // Fired while the user agent
	    // is downloading media data
	
	  }, {
	    key: 'handleProgress',
	    value: function handleProgress() {
	      var _props9 = this.props,
	          actions = _props9.actions,
	          onProgress = _props9.onProgress;
	
	      if (this.video) {
	        actions.handleProgressChange(this.getProperties());
	      }
	
	      if (onProgress) {
	        onProgress.apply(undefined, arguments);
	      }
	    }
	
	    // Fired when the end of the media resource
	    // is reached (currentTime == duration)
	
	  }, {
	    key: 'handleEnded',
	    value: function handleEnded() {
	      var _props10 = this.props,
	          loop = _props10.loop,
	          player = _props10.player,
	          actions = _props10.actions,
	          onEnded = _props10.onEnded;
	
	      if (loop) {
	        this.seek(0);
	        this.play();
	      } else if (!player.paused) {
	        this.pause();
	      }
	      actions.handleEnd(this.getProperties());
	
	      if (onEnded) {
	        onEnded.apply(undefined, arguments);
	      }
	    }
	
	    // Fired whenever the media begins waiting
	
	  }, {
	    key: 'handleWaiting',
	    value: function handleWaiting() {
	      var _props11 = this.props,
	          actions = _props11.actions,
	          onWaiting = _props11.onWaiting;
	
	      actions.handleWaiting(this.getProperties());
	
	      if (onWaiting) {
	        onWaiting.apply(undefined, arguments);
	      }
	    }
	
	    // Fired whenever the player
	    // is jumping to a new time
	
	  }, {
	    key: 'handleSeeking',
	    value: function handleSeeking() {
	      var _props12 = this.props,
	          actions = _props12.actions,
	          onSeeking = _props12.onSeeking;
	
	      actions.handleSeeking(this.getProperties());
	
	      if (onSeeking) {
	        onSeeking.apply(undefined, arguments);
	      }
	    }
	
	    // Fired when the player has
	    // finished jumping to a new time
	
	  }, {
	    key: 'handleSeeked',
	    value: function handleSeeked() {
	      var _props13 = this.props,
	          actions = _props13.actions,
	          onSeeked = _props13.onSeeked;
	
	      actions.handleSeeked(this.getProperties());
	
	      if (onSeeked) {
	        onSeeked.apply(undefined, arguments);
	      }
	    }
	
	    // Handle Fullscreen Change
	
	  }, {
	    key: 'handleFullscreenChange',
	    value: function handleFullscreenChange() {}
	
	    // Fires when the browser is
	    // intentionally not getting media data
	
	  }, {
	    key: 'handleSuspend',
	    value: function handleSuspend() {
	      var _props14 = this.props,
	          actions = _props14.actions,
	          onSuspend = _props14.onSuspend;
	
	      actions.handleSuspend(this.getProperties());
	      if (onSuspend) {
	        onSuspend.apply(undefined, arguments);
	      }
	    }
	
	    // Fires when the loading of an audio/video is aborted
	
	  }, {
	    key: 'handleAbort',
	    value: function handleAbort() {
	      var _props15 = this.props,
	          actions = _props15.actions,
	          onAbort = _props15.onAbort;
	
	      actions.handleAbort(this.getProperties());
	      if (onAbort) {
	        onAbort.apply(undefined, arguments);
	      }
	    }
	
	    // Fires when the current playlist is empty
	
	  }, {
	    key: 'handleEmptied',
	    value: function handleEmptied() {
	      var _props16 = this.props,
	          actions = _props16.actions,
	          onEmptied = _props16.onEmptied;
	
	      actions.handleEmptied(this.getProperties());
	      if (onEmptied) {
	        onEmptied.apply(undefined, arguments);
	      }
	    }
	
	    // Fires when the browser is trying to
	    // get media data, but data is not available
	
	  }, {
	    key: 'handleStalled',
	    value: function handleStalled() {
	      var _props17 = this.props,
	          actions = _props17.actions,
	          onStalled = _props17.onStalled;
	
	      actions.handleStalled(this.getProperties());
	
	      if (onStalled) {
	        onStalled.apply(undefined, arguments);
	      }
	    }
	
	    // Fires when the browser has loaded
	    // meta data for the audio/video
	
	  }, {
	    key: 'handleLoadedMetaData',
	    value: function handleLoadedMetaData() {
	      var _props18 = this.props,
	          actions = _props18.actions,
	          onLoadedMetadata = _props18.onLoadedMetadata,
	          startTime = _props18.startTime;
	
	
	      if (startTime && startTime > 0) {
	        this.video.currentTime = startTime;
	      }
	
	      actions.handleLoadedMetaData(this.getProperties());
	
	      if (onLoadedMetadata) {
	        onLoadedMetadata.apply(undefined, arguments);
	      }
	    }
	
	    // Fires when the browser has loaded
	    // the current frame of the audio/video
	
	  }, {
	    key: 'handleLoadedData',
	    value: function handleLoadedData() {
	      var _props19 = this.props,
	          actions = _props19.actions,
	          onLoadedData = _props19.onLoadedData;
	
	      actions.handleLoadedData(this.getProperties());
	
	      if (onLoadedData) {
	        onLoadedData.apply(undefined, arguments);
	      }
	    }
	
	    // Fires when the current
	    // playback position has changed
	
	  }, {
	    key: 'handleTimeUpdate',
	    value: function handleTimeUpdate() {
	      var _props20 = this.props,
	          actions = _props20.actions,
	          onTimeUpdate = _props20.onTimeUpdate;
	
	      actions.handleTimeUpdate(this.getProperties());
	
	      if (onTimeUpdate) {
	        onTimeUpdate.apply(undefined, arguments);
	      }
	    }
	
	    /**
	     * Fires when the playing speed of the audio/video is changed
	     */
	
	  }, {
	    key: 'handleRateChange',
	    value: function handleRateChange() {
	      var _props21 = this.props,
	          actions = _props21.actions,
	          onRateChange = _props21.onRateChange;
	
	      actions.handleRateChange(this.getProperties());
	
	      if (onRateChange) {
	        onRateChange.apply(undefined, arguments);
	      }
	    }
	
	    // Fires when the volume has been changed
	
	  }, {
	    key: 'handleVolumeChange',
	    value: function handleVolumeChange() {
	      var _props22 = this.props,
	          actions = _props22.actions,
	          onVolumeChange = _props22.onVolumeChange;
	
	      actions.handleVolumeChange(this.getProperties());
	
	      if (onVolumeChange) {
	        onVolumeChange.apply(undefined, arguments);
	      }
	    }
	
	    // Fires when an error occurred
	    // during the loading of an audio/video
	
	  }, {
	    key: 'handleError',
	    value: function handleError() {
	      var _props23 = this.props,
	          actions = _props23.actions,
	          onError = _props23.onError;
	
	      actions.handleError(this.getProperties());
	      if (onError) {
	        onError.apply(undefined, arguments);
	      }
	    }
	  }, {
	    key: 'handleResize',
	    value: function handleResize() {
	      var _props24 = this.props,
	          actions = _props24.actions,
	          onResize = _props24.onResize;
	
	      actions.handleResize(this.getProperties());
	      if (onResize) {
	        onResize.apply(undefined, arguments);
	      }
	    }
	  }, {
	    key: 'handleKeypress',
	    value: function handleKeypress() {}
	  }, {
	    key: 'renderChildren',
	    value: function renderChildren() {
	      var _this3 = this;
	
	      var props = _extends({}, this.props, {
	        video: this.video
	      });
	
	      // to make sure the children can get video property
	      if (!this.video) {
	        return null;
	      }
	
	      // only keep <source />, <track />, <MyComponent isVideoChild /> elements
	      return _react2.default.Children.toArray(this.props.children).filter(_utils.isVideoChild).map(function (c) {
	        var cprops = void 0;
	        if (typeof c.type === 'string') {
	          // add onError to <source />
	          if (c.type === 'source') {
	            cprops = _extends({}, c.props);
	            var preOnError = cprops.onError;
	            cprops.onError = function () {
	              if (preOnError) {
	                preOnError.apply(undefined, arguments);
	              }
	              _this3.handleError.apply(_this3, arguments);
	            };
	          }
	        } else {
	          cprops = props;
	        }
	        return _react2.default.cloneElement(c, cprops);
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props25 = this.props,
	          loop = _props25.loop,
	          poster = _props25.poster,
	          preload = _props25.preload,
	          src = _props25.src,
	          autoPlay = _props25.autoPlay,
	          playsInline = _props25.playsInline,
	          muted = _props25.muted,
	          crossOrigin = _props25.crossOrigin,
	          videoId = _props25.videoId;
	
	
	      return _react2.default.createElement(
	        'video',
	        {
	          className: (0, _classnames2.default)('video-react-video', this.props.className),
	          id: videoId,
	          crossOrigin: crossOrigin,
	          ref: function ref(c) {
	            _this4.video = c;
	          },
	          muted: muted,
	          preload: preload,
	          loop: loop,
	          playsInline: playsInline,
	          autoPlay: autoPlay,
	          poster: poster,
	          src: src,
	          onLoadStart: this.handleLoadStart,
	          onWaiting: this.handleWaiting,
	          onCanPlay: this.handleCanPlay,
	          onCanPlayThrough: this.handleCanPlayThrough,
	          onPlaying: this.handlePlaying,
	          onEnded: this.handleEnded,
	          onSeeking: this.handleSeeking,
	          onSeeked: this.handleSeeked,
	          onPlay: this.handlePlay,
	          onPause: this.handlePause,
	          onProgress: this.handleProgress,
	          onDurationChange: this.handleDurationChange,
	          onError: this.handleError,
	          onSuspend: this.handleSuspend,
	          onAbort: this.handleAbort,
	          onEmptied: this.handleEmptied,
	          onStalled: this.handleStalled,
	          onLoadedMetadata: this.handleLoadedMetaData,
	          onLoadedData: this.handleLoadedData,
	          onTimeUpdate: this.handleTimeUpdate,
	          onRateChange: this.handleRateChange,
	          onVolumeChange: this.handleVolumeChange
	        },
	        this.renderChildren()
	      );
	    }
	  }, {
	    key: 'playbackRate',
	    get: function get() {
	      return this.video.playbackRate;
	    }
	
	    // set playback rate
	    // speed of video
	    ,
	    set: function set(rate) {
	      this.video.playbackRate = rate;
	    }
	  }, {
	    key: 'muted',
	    get: function get() {
	      return this.video.muted;
	    },
	    set: function set(val) {
	      this.video.muted = val;
	    }
	  }, {
	    key: 'volume',
	    get: function get() {
	      return this.video.volume;
	    },
	    set: function set(val) {
	      if (val > 1) {
	        val = 1;
	      }
	      if (val < 0) {
	        val = 0;
	      }
	      this.video.volume = val;
	    }
	
	    // video width
	
	  }, {
	    key: 'videoWidth',
	    get: function get() {
	      return this.video.videoWidth;
	    }
	
	    // video height
	
	  }, {
	    key: 'videoHeight',
	    get: function get() {
	      return this.video.videoHeight;
	    }
	  }]);
	
	  return Video;
	}(_react.Component);
	
	exports.default = Video;
	
	
	Video.propTypes = propTypes;
	Video.defaultProps = defaultProps;
	Video.displayName = 'Video';

/***/ }),

/***/ 238:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ProgressControl = __webpack_require__(246);
	
	var _ProgressControl2 = _interopRequireDefault(_ProgressControl);
	
	var _PlayToggle = __webpack_require__(245);
	
	var _PlayToggle2 = _interopRequireDefault(_PlayToggle);
	
	var _ForwardControl = __webpack_require__(239);
	
	var _ForwardControl2 = _interopRequireDefault(_ForwardControl);
	
	var _ReplayControl = __webpack_require__(247);
	
	var _ReplayControl2 = _interopRequireDefault(_ReplayControl);
	
	var _FullscreenToggle = __webpack_require__(241);
	
	var _FullscreenToggle2 = _interopRequireDefault(_FullscreenToggle);
	
	var _RemainingTimeDisplay = __webpack_require__(252);
	
	var _RemainingTimeDisplay2 = _interopRequireDefault(_RemainingTimeDisplay);
	
	var _CurrentTimeDisplay = __webpack_require__(250);
	
	var _CurrentTimeDisplay2 = _interopRequireDefault(_CurrentTimeDisplay);
	
	var _DurationDisplay = __webpack_require__(251);
	
	var _DurationDisplay2 = _interopRequireDefault(_DurationDisplay);
	
	var _TimeDivider = __webpack_require__(253);
	
	var _TimeDivider2 = _interopRequireDefault(_TimeDivider);
	
	var _VolumeMenuButton = __webpack_require__(249);
	
	var _VolumeMenuButton2 = _interopRequireDefault(_VolumeMenuButton);
	
	var _PlaybackRateMenuButton = __webpack_require__(181);
	
	var _PlaybackRateMenuButton2 = _interopRequireDefault(_PlaybackRateMenuButton);
	
	var _utils = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  children: _propTypes2.default.any,
	  autoHide: _propTypes2.default.bool,
	  disableDefaultControls: _propTypes2.default.bool,
	  disableCompletely: _propTypes2.default.bool,
	  className: _propTypes2.default.string
	};
	
	var defaultProps = {
	  autoHide: true,
	  disableCompletely: false
	};
	
	var ControlBar = function (_Component) {
	  _inherits(ControlBar, _Component);
	
	  function ControlBar(props) {
	    _classCallCheck(this, ControlBar);
	
	    var _this = _possibleConstructorReturn(this, (ControlBar.__proto__ || Object.getPrototypeOf(ControlBar)).call(this, props));
	
	    _this.getDefaultChildren = _this.getDefaultChildren.bind(_this);
	    _this.getFullChildren = _this.getFullChildren.bind(_this);
	    return _this;
	  }
	
	  _createClass(ControlBar, [{
	    key: 'getDefaultChildren',
	    value: function getDefaultChildren() {
	      return [_react2.default.createElement(_PlayToggle2.default, _extends({}, this.props, {
	        key: 'play-toggle',
	        order: 1
	      })), _react2.default.createElement(_VolumeMenuButton2.default, _extends({}, this.props, {
	        key: 'volume-menu-button',
	        order: 4
	      })), _react2.default.createElement(_CurrentTimeDisplay2.default, _extends({}, this.props, {
	        key: 'current-time-display',
	        order: 5.1
	      })), _react2.default.createElement(_TimeDivider2.default, _extends({}, this.props, {
	        key: 'time-divider',
	        order: 5.2
	      })), _react2.default.createElement(_DurationDisplay2.default, _extends({}, this.props, {
	        key: 'duration-display',
	        order: 5.3
	      })), _react2.default.createElement(_ProgressControl2.default, _extends({}, this.props, {
	        key: 'progress-control',
	        order: 6
	      })), _react2.default.createElement(_FullscreenToggle2.default, _extends({}, this.props, {
	        key: 'fullscreen-toggle',
	        order: 8
	      }))];
	    }
	  }, {
	    key: 'getFullChildren',
	    value: function getFullChildren() {
	      return [_react2.default.createElement(_PlayToggle2.default, _extends({}, this.props, {
	        key: 'play-toggle',
	        order: 1
	      })), _react2.default.createElement(_ReplayControl2.default, _extends({}, this.props, {
	        key: 'replay-control',
	        order: 2
	      })), _react2.default.createElement(_ForwardControl2.default, _extends({}, this.props, {
	        key: 'forward-control',
	        order: 3
	      })), _react2.default.createElement(_VolumeMenuButton2.default, _extends({}, this.props, {
	        key: 'volume-menu-button',
	        order: 4
	      })), _react2.default.createElement(_CurrentTimeDisplay2.default, _extends({}, this.props, {
	        key: 'current-time-display',
	        order: 5
	      })), _react2.default.createElement(_TimeDivider2.default, _extends({}, this.props, {
	        key: 'time-divider',
	        order: 6
	      })), _react2.default.createElement(_DurationDisplay2.default, _extends({}, this.props, {
	        key: 'duration-display',
	        order: 7
	      })), _react2.default.createElement(_ProgressControl2.default, _extends({}, this.props, {
	        key: 'progress-control',
	        order: 8
	      })), _react2.default.createElement(_RemainingTimeDisplay2.default, _extends({}, this.props, {
	        key: 'remaining-time-display',
	        order: 9
	      })), _react2.default.createElement(_PlaybackRateMenuButton2.default, _extends({}, this.props, {
	        rates: [1, 1.25, 1.5, 2],
	        key: 'playback-rate',
	        order: 10
	      })), _react2.default.createElement(_FullscreenToggle2.default, _extends({}, this.props, {
	        key: 'fullscreen-toggle',
	        order: 11
	      }))];
	    }
	  }, {
	    key: 'getChildren',
	    value: function getChildren() {
	      var children = _react2.default.Children.toArray(this.props.children);
	      var defaultChildren = this.props.disableDefaultControls ? [] : this.getDefaultChildren();
	      return (0, _utils.mergeAndSortChildren)(defaultChildren, children, this.props);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          autoHide = _props.autoHide,
	          className = _props.className,
	          disableCompletely = _props.disableCompletely;
	
	      var children = this.getChildren();
	
	      return disableCompletely ? null : _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)('video-react-control-bar', {
	            'video-react-control-bar-auto-hide': autoHide
	          }, className)
	        },
	        children
	      );
	    }
	  }]);
	
	  return ControlBar;
	}(_react.Component);
	
	exports.default = ControlBar;
	
	
	ControlBar.propTypes = propTypes;
	ControlBar.defaultProps = defaultProps;
	ControlBar.displayName = 'ControlBar';

/***/ }),

/***/ 239:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ForwardReplayControl = __webpack_require__(240);
	
	var _ForwardReplayControl2 = _interopRequireDefault(_ForwardReplayControl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Pass mode into parent function
	var ForwardControl = (0, _ForwardReplayControl2.default)('forward');
	
	ForwardControl.displayName = 'ForwardControl';
	exports.default = ForwardControl;

/***/ }),

/***/ 240:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  actions: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  seconds: _propTypes2.default.oneOf([5, 10, 30])
	};
	
	var defaultProps = {
	  seconds: 10
	};
	
	exports.default = function (mode) {
	  var ForwardReplayControl = function (_Component) {
	    _inherits(ForwardReplayControl, _Component);
	
	    function ForwardReplayControl(props, context) {
	      _classCallCheck(this, ForwardReplayControl);
	
	      var _this = _possibleConstructorReturn(this, (ForwardReplayControl.__proto__ || Object.getPrototypeOf(ForwardReplayControl)).call(this, props, context));
	
	      _this.handleClick = _this.handleClick.bind(_this);
	      return _this;
	    }
	
	    _createClass(ForwardReplayControl, [{
	      key: 'handleClick',
	      value: function handleClick() {
	        var _props = this.props,
	            actions = _props.actions,
	            seconds = _props.seconds;
	        // Depends mode to implement different actions
	
	        if (mode === 'forward') {
	          actions.forward(seconds);
	        } else {
	          actions.replay(seconds);
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _this2 = this;
	
	        var _props2 = this.props,
	            seconds = _props2.seconds,
	            className = _props2.className;
	
	        var classNames = ['video-react-control', 'video-react-button', 'video-react-icon'];
	        classNames.push('video-react-icon-' + mode + '-' + seconds, 'video-react-' + mode + '-control');
	        if (this.props.className) {
	          classNames.push(this.props.className);
	        }
	        return _react2.default.createElement(
	          'button',
	          {
	            ref: function ref(c) {
	              _this2.button = c;
	            },
	            className: classNames.join(' '),
	            type: 'button',
	            onClick: this.handleClick
	          },
	          _react2.default.createElement(
	            'span',
	            { className: 'video-react-control-text' },
	            mode + ' ' + seconds + ' seconds'
	          )
	        );
	      }
	    }]);
	
	    return ForwardReplayControl;
	  }(_react.Component);
	
	  ForwardReplayControl.propTypes = propTypes;
	  ForwardReplayControl.defaultProps = defaultProps;
	  return ForwardReplayControl;
	};

/***/ }),

/***/ 241:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  actions: _propTypes2.default.object,
	  player: _propTypes2.default.object,
	  className: _propTypes2.default.string
	};
	
	var FullscreenToggle = function (_Component) {
	  _inherits(FullscreenToggle, _Component);
	
	  function FullscreenToggle(props, context) {
	    _classCallCheck(this, FullscreenToggle);
	
	    var _this = _possibleConstructorReturn(this, (FullscreenToggle.__proto__ || Object.getPrototypeOf(FullscreenToggle)).call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(FullscreenToggle, [{
	    key: 'handleClick',
	    value: function handleClick() {
	      var _props = this.props,
	          player = _props.player,
	          actions = _props.actions;
	
	      actions.toggleFullscreen(player);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          player = _props2.player,
	          className = _props2.className;
	
	      return _react2.default.createElement(
	        'button',
	        {
	          className: (0, _classnames2.default)(className, {
	            'video-react-icon-fullscreen-exit': player.isFullscreen,
	            'video-react-icon-fullscreen': !player.isFullscreen
	          }, 'video-react-fullscreen-control video-react-control video-react-button video-react-icon'),
	          ref: function ref(c) {
	            _this2.button = c;
	          },
	          type: 'button',
	          tabIndex: '0',
	          onClick: this.handleClick
	        },
	        _react2.default.createElement(
	          'span',
	          { className: 'video-react-control-text' },
	          'Non-Fullscreen'
	        )
	      );
	    }
	  }]);
	
	  return FullscreenToggle;
	}(_react.Component);
	
	exports.default = FullscreenToggle;
	
	
	FullscreenToggle.propTypes = propTypes;
	FullscreenToggle.displayName = 'FullscreenToggle';

/***/ }),

/***/ 242:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = LoadProgressBar;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  duration: _propTypes2.default.number,
	  buffered: _propTypes2.default.object,
	  className: _propTypes2.default.string
	};
	
	// Shows load progress
	function LoadProgressBar(_ref) {
	  var buffered = _ref.buffered,
	      duration = _ref.duration,
	      className = _ref.className;
	
	  if (!buffered || !buffered.length) {
	    return null;
	  }
	  var bufferedEnd = buffered.end(buffered.length - 1);
	  var style = {};
	
	  if (bufferedEnd > duration) {
	    bufferedEnd = duration;
	  }
	
	  // get the percent width of a time compared to the total end
	  function percentify(time, end) {
	    var percent = time / end || 0; // no NaN
	    return (percent >= 1 ? 1 : percent) * 100 + '%';
	  }
	
	  // the width of the progress bar
	  style.width = percentify(bufferedEnd, duration);
	
	  var parts = [];
	
	  // add child elements to represent the individual buffered time ranges
	  for (var i = 0; i < buffered.length; i++) {
	    var start = buffered.start(i);
	    var end = buffered.end(i);
	    // set the percent based on the width of the progress bar (bufferedEnd)
	    var part = _react2.default.createElement('div', {
	      style: {
	        left: percentify(start, bufferedEnd),
	        width: percentify(end - start, bufferedEnd)
	      },
	      key: 'part-' + i
	    });
	    parts.push(part);
	  }
	
	  if (parts.length === 0) {
	    parts = null;
	  }
	
	  return _react2.default.createElement(
	    'div',
	    {
	      style: style,
	      className: (0, _classnames2.default)('video-react-load-progress', className)
	    },
	    _react2.default.createElement(
	      'span',
	      { className: 'video-react-control-text' },
	      _react2.default.createElement(
	        'span',
	        null,
	        'Loaded'
	      ),
	      ': 0%'
	    ),
	    parts
	  );
	}
	
	LoadProgressBar.propTypes = propTypes;
	LoadProgressBar.displayName = 'LoadProgressBar';

/***/ }),

/***/ 243:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utils = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function MouseTimeDisplay(_ref) {
	  var duration = _ref.duration,
	      mouseTime = _ref.mouseTime,
	      className = _ref.className,
	      text = _ref.text;
	
	  if (!mouseTime.time) {
	    return null;
	  }
	
	  var time = text || (0, _utils.formatTime)(mouseTime.time, duration);
	
	  return _react2.default.createElement('div', {
	    className: (0, _classnames2.default)('video-react-mouse-display', className),
	    style: {
	      left: mouseTime.position + 'px'
	    },
	    'data-current-time': time
	  });
	}
	
	MouseTimeDisplay.propTypes = {
	  duration: _propTypes2.default.number,
	  mouseTime: _propTypes2.default.object,
	  className: _propTypes2.default.string
	};
	MouseTimeDisplay.displayName = 'MouseTimeDisplay';
	
	exports.default = MouseTimeDisplay;

/***/ }),

/***/ 244:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = PlayProgressBar;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utils = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  currentTime: _propTypes2.default.number,
	  duration: _propTypes2.default.number,
	  percentage: _propTypes2.default.string,
	  className: _propTypes2.default.string
	};
	
	// Shows play progress
	function PlayProgressBar(_ref) {
	  var currentTime = _ref.currentTime,
	      duration = _ref.duration,
	      percentage = _ref.percentage,
	      className = _ref.className;
	
	  return _react2.default.createElement(
	    'div',
	    {
	      'data-current-time': (0, _utils.formatTime)(currentTime, duration),
	      className: (0, _classnames2.default)('video-react-play-progress video-react-slider-bar', className),
	      style: {
	        width: percentage
	      }
	    },
	    _react2.default.createElement(
	      'span',
	      { className: 'video-react-control-text' },
	      _react2.default.createElement(
	        'span',
	        null,
	        'Progress'
	      ),
	      ': ',
	      percentage
	    )
	  );
	}
	
	PlayProgressBar.propTypes = propTypes;
	PlayProgressBar.displayName = 'PlayProgressBar';

/***/ }),

/***/ 245:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  actions: _propTypes2.default.object,
	  player: _propTypes2.default.object,
	  className: _propTypes2.default.string
	};
	
	var PlayToggle = function (_Component) {
	  _inherits(PlayToggle, _Component);
	
	  function PlayToggle(props, context) {
	    _classCallCheck(this, PlayToggle);
	
	    var _this = _possibleConstructorReturn(this, (PlayToggle.__proto__ || Object.getPrototypeOf(PlayToggle)).call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(PlayToggle, [{
	    key: 'handleClick',
	    value: function handleClick() {
	      var _props = this.props,
	          actions = _props.actions,
	          player = _props.player;
	
	      if (player.paused) {
	        actions.play();
	      } else {
	        actions.pause();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          player = _props2.player,
	          className = _props2.className;
	
	      var controlText = player.paused ? 'Play' : 'Pause';
	
	      return _react2.default.createElement(
	        'button',
	        {
	          ref: function ref(c) {
	            _this2.button = c;
	          },
	          className: (0, _classnames2.default)(className, {
	            'video-react-play-control': true,
	            'video-react-control': true,
	            'video-react-button': true,
	            'video-react-paused': player.paused,
	            'video-react-playing': !player.paused
	          }),
	          type: 'button',
	          tabIndex: '0',
	          onClick: this.handleClick
	        },
	        _react2.default.createElement(
	          'span',
	          { className: 'video-react-control-text' },
	          controlText
	        )
	      );
	    }
	  }]);
	
	  return PlayToggle;
	}(_react.Component);
	
	exports.default = PlayToggle;
	
	
	PlayToggle.propTypes = propTypes;
	PlayToggle.displayName = 'PlayToggle';

/***/ }),

/***/ 705:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PlaybackRateMenuButton = __webpack_require__(181);
	
	var _PlaybackRateMenuButton2 = _interopRequireDefault(_PlaybackRateMenuButton);
	
	var _utils = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PlaybackRate = function (_Component) {
	  _inherits(PlaybackRate, _Component);
	
	  function PlaybackRate(props, context) {
	    _classCallCheck(this, PlaybackRate);
	
	    var _this = _possibleConstructorReturn(this, (PlaybackRate.__proto__ || Object.getPrototypeOf(PlaybackRate)).call(this, props, context));
	
	    (0, _utils.deprecatedWarning)('PlaybackRate', 'PlaybackRateMenuButton');
	    return _this;
	  }
	
	  _createClass(PlaybackRate, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_PlaybackRateMenuButton2.default, this.props);
	    }
	  }]);
	
	  return PlaybackRate;
	}(_react.Component);
	
	exports.default = PlaybackRate;
	
	
	PlaybackRate.displayName = 'PlaybackRate';

/***/ }),

/***/ 181:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _MenuButton = __webpack_require__(707);
	
	var _MenuButton2 = _interopRequireDefault(_MenuButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  player: _propTypes2.default.object,
	  actions: _propTypes2.default.object,
	  rates: _propTypes2.default.array,
	  className: _propTypes2.default.string
	};
	
	var defaultProps = {
	  rates: [2, 1.5, 1.25, 1, 0.5, 0.25]
	};
	
	var PlaybackRateMenuButton = function (_Component) {
	  _inherits(PlaybackRateMenuButton, _Component);
	
	  function PlaybackRateMenuButton(props, context) {
	    _classCallCheck(this, PlaybackRateMenuButton);
	
	    var _this = _possibleConstructorReturn(this, (PlaybackRateMenuButton.__proto__ || Object.getPrototypeOf(PlaybackRateMenuButton)).call(this, props, context));
	
	    _this.handleSelectItem = _this.handleSelectItem.bind(_this);
	    return _this;
	  }
	
	  _createClass(PlaybackRateMenuButton, [{
	    key: 'handleSelectItem',
	    value: function handleSelectItem(index) {
	      var _props = this.props,
	          rates = _props.rates,
	          actions = _props.actions;
	
	      if (index >= 0 && index < rates.length) {
	        actions.changeRate(rates[index]);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          rates = _props2.rates,
	          player = _props2.player;
	
	      var items = rates.map(function (rate) {
	        return {
	          label: rate + 'x',
	          value: rate
	        };
	      });
	      var selectedIndex = rates.indexOf(player.playbackRate) || 0;
	
	      return _react2.default.createElement(
	        _MenuButton2.default,
	        {
	          className: (0, _classnames2.default)('video-react-playback-rate', this.props.className),
	          onSelectItem: this.handleSelectItem,
	          items: items,
	          selectedIndex: selectedIndex
	        },
	        _react2.default.createElement(
	          'span',
	          { className: 'video-react-control-text' },
	          'Playback Rate'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'video-react-playback-rate-value' },
	          player.playbackRate.toFixed(2),
	          'x'
	        )
	      );
	    }
	  }]);
	
	  return PlaybackRateMenuButton;
	}(_react.Component);
	
	PlaybackRateMenuButton.propTypes = propTypes;
	PlaybackRateMenuButton.defaultProps = defaultProps;
	PlaybackRateMenuButton.displayName = 'PlaybackRateMenuButton';
	exports.default = PlaybackRateMenuButton;

/***/ }),

/***/ 246:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(24);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _dom = __webpack_require__(182);
	
	var Dom = _interopRequireWildcard(_dom);
	
	var _SeekBar = __webpack_require__(248);
	
	var _SeekBar2 = _interopRequireDefault(_SeekBar);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  player: _propTypes2.default.object,
	  className: _propTypes2.default.string
	};
	
	var ProgressControl = function (_Component) {
	  _inherits(ProgressControl, _Component);
	
	  function ProgressControl(props, context) {
	    _classCallCheck(this, ProgressControl);
	
	    var _this = _possibleConstructorReturn(this, (ProgressControl.__proto__ || Object.getPrototypeOf(ProgressControl)).call(this, props, context));
	
	    _this.state = {
	      mouseTime: {
	        time: null,
	        position: 0
	      }
	    };
	
	    _this.handleMouseMoveThrottle = _this.handleMouseMove.bind(_this);
	    return _this;
	  }
	
	  _createClass(ProgressControl, [{
	    key: 'handleMouseMove',
	    value: function handleMouseMove(event) {
	      if (!event.pageX) {
	        return;
	      }
	      var duration = this.props.player.duration;
	
	      var node = (0, _reactDom.findDOMNode)(this.seekBar);
	      var newTime = Dom.getPointerPosition(node, event).x * duration;
	      var position = event.pageX - Dom.findElPosition(node).left;
	
	      this.setState({
	        mouseTime: {
	          time: newTime,
	          position: position
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var className = this.props.className;
	
	      return _react2.default.createElement(
	        'div',
	        {
	          onMouseMove: this.handleMouseMoveThrottle,
	          className: (0, _classnames2.default)('video-react-progress-control video-react-control', className)
	        },
	        _react2.default.createElement(_SeekBar2.default, _extends({
	          mouseTime: this.state.mouseTime,
	          ref: function ref(c) {
	            _this2.seekBar = c;
	          }
	        }, this.props))
	      );
	    }
	  }]);
	
	  return ProgressControl;
	}(_react.Component);
	
	exports.default = ProgressControl;
	
	
	ProgressControl.propTypes = propTypes;
	ProgressControl.displayName = 'ProgressControl';

/***/ }),

/***/ 247:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ForwardReplayControl = __webpack_require__(240);
	
	var _ForwardReplayControl2 = _interopRequireDefault(_ForwardReplayControl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Pass mode into parent function
	var ReplayControl = (0, _ForwardReplayControl2.default)('replay');
	ReplayControl.displayName = 'ReplayControl';
	
	exports.default = ReplayControl;

/***/ }),

/***/ 248:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Slider = __webpack_require__(180);
	
	var _Slider2 = _interopRequireDefault(_Slider);
	
	var _PlayProgressBar = __webpack_require__(244);
	
	var _PlayProgressBar2 = _interopRequireDefault(_PlayProgressBar);
	
	var _LoadProgressBar = __webpack_require__(242);
	
	var _LoadProgressBar2 = _interopRequireDefault(_LoadProgressBar);
	
	var _MouseTimeDisplay = __webpack_require__(243);
	
	var _MouseTimeDisplay2 = _interopRequireDefault(_MouseTimeDisplay);
	
	var _utils = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  player: _propTypes2.default.object,
	  mouseTime: _propTypes2.default.object,
	  actions: _propTypes2.default.object,
	  className: _propTypes2.default.string
	};
	
	var SeekBar = function (_Component) {
	  _inherits(SeekBar, _Component);
	
	  function SeekBar(props, context) {
	    _classCallCheck(this, SeekBar);
	
	    var _this = _possibleConstructorReturn(this, (SeekBar.__proto__ || Object.getPrototypeOf(SeekBar)).call(this, props, context));
	
	    _this.getPercent = _this.getPercent.bind(_this);
	    _this.getNewTime = _this.getNewTime.bind(_this);
	    _this.stepForward = _this.stepForward.bind(_this);
	    _this.stepBack = _this.stepBack.bind(_this);
	
	    _this.handleMouseDown = _this.handleMouseDown.bind(_this);
	    _this.handleMouseMove = _this.handleMouseMove.bind(_this);
	    _this.handleMouseUp = _this.handleMouseUp.bind(_this);
	    return _this;
	  }
	
	  _createClass(SeekBar, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {}
	
	    /**
	     * Get percentage of video played
	     *
	     * @return {Number} Percentage played
	     * @method getPercent
	     */
	
	  }, {
	    key: 'getPercent',
	    value: function getPercent() {
	      var _props$player = this.props.player,
	          currentTime = _props$player.currentTime,
	          seekingTime = _props$player.seekingTime,
	          duration = _props$player.duration;
	
	      var time = seekingTime || currentTime;
	      var percent = time / duration;
	      return percent >= 1 ? 1 : percent;
	    }
	  }, {
	    key: 'getNewTime',
	    value: function getNewTime(event) {
	      var duration = this.props.player.duration;
	
	      var distance = this.slider.calculateDistance(event);
	      var newTime = distance * duration;
	
	      // Don't let video end while scrubbing.
	      return newTime === duration ? newTime - 0.1 : newTime;
	    }
	  }, {
	    key: 'handleMouseDown',
	    value: function handleMouseDown() {}
	  }, {
	    key: 'handleMouseUp',
	    value: function handleMouseUp(event) {
	      var actions = this.props.actions;
	
	      var newTime = this.getNewTime(event);
	      // Set new time (tell video to seek to new time)
	      actions.seek(newTime);
	      actions.handleEndSeeking(newTime);
	    }
	  }, {
	    key: 'handleMouseMove',
	    value: function handleMouseMove(event) {
	      var actions = this.props.actions;
	
	      var newTime = this.getNewTime(event);
	      actions.handleSeekingTime(newTime);
	    }
	  }, {
	    key: 'stepForward',
	    value: function stepForward() {
	      var actions = this.props.actions;
	
	      actions.forward(5);
	    }
	  }, {
	    key: 'stepBack',
	    value: function stepBack() {
	      var actions = this.props.actions;
	
	      actions.replay(5);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          _props$player2 = _props.player,
	          currentTime = _props$player2.currentTime,
	          seekingTime = _props$player2.seekingTime,
	          duration = _props$player2.duration,
	          buffered = _props$player2.buffered,
	          mouseTime = _props.mouseTime;
	
	      var time = seekingTime || currentTime;
	
	      return _react2.default.createElement(
	        _Slider2.default,
	        {
	          ref: function ref(input) {
	            _this2.slider = input;
	          },
	          label: 'video progress bar',
	          className: (0, _classnames2.default)('video-react-progress-holder', this.props.className),
	          valuenow: (this.getPercent() * 100).toFixed(2),
	          valuetext: (0, _utils.formatTime)(time, duration),
	          onMouseDown: this.handleMouseDown,
	          onMouseMove: this.handleMouseMove,
	          onMouseUp: this.handleMouseUp,
	          getPercent: this.getPercent,
	          stepForward: this.stepForward,
	          stepBack: this.stepBack
	        },
	        _react2.default.createElement(_LoadProgressBar2.default, {
	          buffered: buffered,
	          currentTime: time,
	          duration: duration
	        }),
	        _react2.default.createElement(_MouseTimeDisplay2.default, {
	          duration: duration,
	          mouseTime: mouseTime
	        }),
	        _react2.default.createElement(_PlayProgressBar2.default, {
	          currentTime: time,
	          duration: duration
	        })
	      );
	    }
	  }]);
	
	  return SeekBar;
	}(_react.Component);
	
	exports.default = SeekBar;
	
	
	SeekBar.propTypes = propTypes;
	SeekBar.displayName = 'SeekBar';

/***/ }),

/***/ 249:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PopupButton = __webpack_require__(710);
	
	var _PopupButton2 = _interopRequireDefault(_PopupButton);
	
	var _VolumeBar = __webpack_require__(711);
	
	var _VolumeBar2 = _interopRequireDefault(_VolumeBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  player: _propTypes2.default.object,
	  actions: _propTypes2.default.object,
	  vertical: _propTypes2.default.bool,
	  className: _propTypes2.default.string,
	  alwaysShowVolume: _propTypes2.default.bool
	};
	
	var defaultProps = {
	  vertical: false
	};
	
	var VolumeMenuButton = function (_Component) {
	  _inherits(VolumeMenuButton, _Component);
	
	  function VolumeMenuButton(props, context) {
	    _classCallCheck(this, VolumeMenuButton);
	
	    var _this = _possibleConstructorReturn(this, (VolumeMenuButton.__proto__ || Object.getPrototypeOf(VolumeMenuButton)).call(this, props, context));
	
	    _this.state = {
	      active: false
	    };
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    _this.handleFocus = _this.handleFocus.bind(_this);
	    _this.handleBlur = _this.handleBlur.bind(_this);
	    return _this;
	  }
	
	  _createClass(VolumeMenuButton, [{
	    key: 'handleClick',
	    value: function handleClick() {
	      var _props = this.props,
	          player = _props.player,
	          actions = _props.actions;
	
	      actions.mute(!player.muted);
	    }
	  }, {
	    key: 'handleFocus',
	    value: function handleFocus() {
	      this.setState({
	        active: true
	      });
	    }
	  }, {
	    key: 'handleBlur',
	    value: function handleBlur() {
	      this.setState({
	        active: false
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          vertical = _props2.vertical,
	          player = _props2.player,
	          className = _props2.className;
	
	      var inline = !vertical;
	      var level = this.volumeLevel;
	      return _react2.default.createElement(
	        _PopupButton2.default,
	        {
	          className: (0, _classnames2.default)(className, {
	            'video-react-volume-menu-button-vertical': vertical,
	            'video-react-volume-menu-button-horizontal': !vertical,
	            'video-react-vol-muted': player.muted,
	            'video-react-vol-0': level === 0 && !player.muted,
	            'video-react-vol-1': level === 1,
	            'video-react-vol-2': level === 2,
	            'video-react-vol-3': level === 3,
	            'video-react-slider-active': this.props.alwaysShowVolume || this.state.active,
	            'video-react-lock-showing': this.props.alwaysShowVolume || this.state.active
	          }, 'video-react-volume-menu-button'),
	          onClick: this.handleClick,
	          inline: inline
	        },
	        _react2.default.createElement(_VolumeBar2.default, _extends({
	          onFocus: this.handleFocus,
	          onBlur: this.handleBlur
	        }, this.props))
	      );
	    }
	  }, {
	    key: 'volumeLevel',
	    get: function get() {
	      var _props$player = this.props.player,
	          volume = _props$player.volume,
	          muted = _props$player.muted;
	
	      var level = 3;
	      if (volume === 0 || muted) {
	        level = 0;
	      } else if (volume < 0.33) {
	        level = 1;
	      } else if (volume < 0.67) {
	        level = 2;
	      }
	      return level;
	    }
	  }]);
	
	  return VolumeMenuButton;
	}(_react.Component);
	
	VolumeMenuButton.propTypes = propTypes;
	VolumeMenuButton.defaultProps = defaultProps;
	VolumeMenuButton.displayName = 'VolumeMenuButton';
	exports.default = VolumeMenuButton;

/***/ }),

/***/ 706:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  children: _propTypes2.default.any
	};
	
	var Menu = function (_Component) {
	  _inherits(Menu, _Component);
	
	  function Menu(props, context) {
	    _classCallCheck(this, Menu);
	
	    var _this = _possibleConstructorReturn(this, (Menu.__proto__ || Object.getPrototypeOf(Menu)).call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(Menu, [{
	    key: 'handleClick',
	    value: function handleClick(event) {
	      event.preventDefault();
	      // event.stopPropagation();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'video-react-menu video-react-lock-showing',
	          role: 'presentation',
	          onClick: this.handleClick
	        },
	        _react2.default.createElement(
	          'ul',
	          { className: 'video-react-menu-content' },
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  return Menu;
	}(_react.Component);
	
	exports.default = Menu;
	
	
	Menu.propTypes = propTypes;
	Menu.displayName = 'Menu';

/***/ }),

/***/ 707:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Menu = __webpack_require__(706);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _MenuItem = __webpack_require__(708);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	var _ClickableComponent = __webpack_require__(233);
	
	var _ClickableComponent2 = _interopRequireDefault(_ClickableComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  inline: _propTypes2.default.bool,
	  items: _propTypes2.default.array,
	  className: _propTypes2.default.string,
	  onSelectItem: _propTypes2.default.func,
	  children: _propTypes2.default.any,
	  selectedIndex: _propTypes2.default.number
	};
	
	var MenuButton = function (_Component) {
	  _inherits(MenuButton, _Component);
	
	  function MenuButton(props, context) {
	    _classCallCheck(this, MenuButton);
	
	    var _this = _possibleConstructorReturn(this, (MenuButton.__proto__ || Object.getPrototypeOf(MenuButton)).call(this, props, context));
	
	    _this.state = {
	      active: false,
	      activateIndex: props.selectedIndex || 0
	    };
	
	    _this.commitSelection = _this.commitSelection.bind(_this);
	    _this.activateMenuItem = _this.activateMenuItem.bind(_this);
	    _this.handleClick = _this.handleClick.bind(_this);
	    _this.renderMenu = _this.renderMenu.bind(_this);
	    _this.handleFocus = _this.handleFocus.bind(_this);
	    _this.handleBlur = _this.handleBlur.bind(_this);
	    _this.handleUpArrow = _this.handleUpArrow.bind(_this);
	    _this.handleDownArrow = _this.handleDownArrow.bind(_this);
	    _this.handleEscape = _this.handleEscape.bind(_this);
	    _this.handleReturn = _this.handleReturn.bind(_this);
	    _this.handleTab = _this.handleTab.bind(_this);
	    _this.handleKeyPress = _this.handleKeyPress.bind(_this);
	    _this.handleSelectItem = _this.handleSelectItem.bind(_this);
	    _this.handleIndexChange = _this.handleIndexChange.bind(_this);
	    return _this;
	  }
	
	  // componentDidUpdate(prevProps) {
	  // }
	
	  _createClass(MenuButton, [{
	    key: 'commitSelection',
	    value: function commitSelection(index) {
	      this.setState({
	        activateIndex: index,
	        active: false
	      });
	      this.handleIndexChange(index);
	    }
	  }, {
	    key: 'activateMenuItem',
	    value: function activateMenuItem(index) {
	      this.setState({
	        activateIndex: index
	      });
	      this.handleIndexChange(index);
	    }
	  }, {
	    key: 'handleIndexChange',
	    value: function handleIndexChange(index) {
	      var onSelectItem = this.props.onSelectItem;
	
	      onSelectItem(index);
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick() {
	      this.setState({
	        active: !this.state.active
	      });
	    }
	  }, {
	    key: 'handleFocus',
	    value: function handleFocus() {
	      document.addEventListener('keydown', this.handleKeyPress);
	    }
	  }, {
	    key: 'handleBlur',
	    value: function handleBlur() {
	      this.setState({
	        active: false
	      });
	      document.removeEventListener('keydown', this.handleKeyPress);
	    }
	  }, {
	    key: 'handleUpArrow',
	    value: function handleUpArrow(e) {
	      var items = this.props.items;
	
	      if (this.state.active) {
	        e.preventDefault();
	        var newIndex = this.state.activateIndex - 1;
	        if (newIndex < 0) {
	          newIndex = items.length ? items.length - 1 : 0;
	        }
	        this.activateMenuItem(newIndex);
	      }
	    }
	  }, {
	    key: 'handleDownArrow',
	    value: function handleDownArrow(e) {
	      var items = this.props.items;
	
	      if (this.state.active) {
	        e.preventDefault();
	        var newIndex = this.state.activateIndex + 1;
	        if (newIndex >= items.length) {
	          newIndex = 0;
	        }
	        this.activateMenuItem(newIndex);
	      }
	    }
	  }, {
	    key: 'handleTab',
	    value: function handleTab(e) {
	      if (this.state.active) {
	        e.preventDefault();
	        this.commitSelection(this.state.activateIndex);
	      }
	    }
	  }, {
	    key: 'handleReturn',
	    value: function handleReturn(e) {
	      e.preventDefault();
	      if (this.state.active) {
	        this.commitSelection(this.state.activateIndex);
	      } else {
	        this.setState({
	          active: true
	        });
	      }
	    }
	  }, {
	    key: 'handleEscape',
	    value: function handleEscape() {
	      this.setState({
	        active: false,
	        activateIndex: 0
	      });
	    }
	  }, {
	    key: 'handleKeyPress',
	    value: function handleKeyPress(event) {
	      // Escape (27) key
	      if (event.which === 27) {
	        this.handleEscape(event);
	      } else if (event.which === 9) {
	        // Tab (9) key
	        this.handleTab(event);
	      } else if (event.which === 13) {
	        // Enter (13) key
	        this.handleReturn(event);
	      } else if (event.which === 38) {
	        // Up (38) key
	        this.handleUpArrow(event);
	      } else if (event.which === 40) {
	        // Down (40) key press
	        this.handleDownArrow(event);
	      }
	    }
	  }, {
	    key: 'handleSelectItem',
	    value: function handleSelectItem(i) {
	      this.commitSelection(i);
	    }
	  }, {
	    key: 'renderMenu',
	    value: function renderMenu() {
	      var _this2 = this;
	
	      if (!this.state.active) {
	        return null;
	      }
	
	      var items = this.props.items;
	
	      return _react2.default.createElement(
	        _Menu2.default,
	        null,
	        items.map(function (item, i) {
	          return _react2.default.createElement(_MenuItem2.default, {
	            item: item,
	            index: i,
	            onSelectItem: _this2.handleSelectItem,
	            activateIndex: _this2.state.activateIndex,
	            key: 'item-' + i++
	          });
	        })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props,
	          inline = _props.inline,
	          className = _props.className;
	
	
	      return _react2.default.createElement(
	        _ClickableComponent2.default,
	        {
	          className: (0, _classnames2.default)(className, {
	            'video-react-menu-button-inline': !!inline,
	            'video-react-menu-button-popup': !inline,
	            'video-react-menu-button-active': this.state.active
	          }, 'video-react-control video-react-button video-react-menu-button'),
	          role: 'presentation',
	          tabIndex: '0',
	          ref: function ref(c) {
	            _this3.menuButton = c;
	          },
	          onClick: this.handleClick,
	          onFocus: this.handleFocus,
	          onBlur: this.handleBlur
	        },
	        this.props.children,
	        this.renderMenu()
	      );
	    }
	  }]);
	
	  return MenuButton;
	}(_react.Component);
	
	exports.default = MenuButton;
	
	
	MenuButton.propTypes = propTypes;
	MenuButton.displayName = 'MenuButton';

/***/ }),

/***/ 708:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  item: _propTypes2.default.object,
	  index: _propTypes2.default.number,
	  activateIndex: _propTypes2.default.number,
	  onSelectItem: _propTypes2.default.func
	};
	
	var MenuItem = function (_Component) {
	  _inherits(MenuItem, _Component);
	
	  function MenuItem(props, context) {
	    _classCallCheck(this, MenuItem);
	
	    var _this = _possibleConstructorReturn(this, (MenuItem.__proto__ || Object.getPrototypeOf(MenuItem)).call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(MenuItem, [{
	    key: 'handleClick',
	    value: function handleClick() {
	      var _props = this.props,
	          index = _props.index,
	          onSelectItem = _props.onSelectItem;
	
	      onSelectItem(index);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          item = _props2.item,
	          index = _props2.index,
	          activateIndex = _props2.activateIndex;
	
	      return _react2.default.createElement(
	        'li',
	        {
	          className: (0, _classnames2.default)({
	            'video-react-menu-item': true,
	            'video-react-selected': index === activateIndex
	          }),
	          onClick: this.handleClick
	        },
	        item.label,
	        _react2.default.createElement('span', { className: 'video-react-control-text' })
	      );
	    }
	  }]);
	
	  return MenuItem;
	}(_react.Component);
	
	exports.default = MenuItem;
	
	
	MenuItem.propTypes = propTypes;
	MenuItem.displayName = 'MenuItem';

/***/ }),

/***/ 709:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  player: _propTypes2.default.object,
	  children: _propTypes2.default.any
	};
	
	var Popup = function (_Component) {
	  _inherits(Popup, _Component);
	
	  function Popup(props, context) {
	    _classCallCheck(this, Popup);
	
	    var _this = _possibleConstructorReturn(this, (Popup.__proto__ || Object.getPrototypeOf(Popup)).call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(Popup, [{
	    key: 'handleClick',
	    value: function handleClick(event) {
	      event.preventDefault();
	      // event.stopPropagation();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var children = this.props.children;
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'video-react-menu',
	          onClick: this.handleClick
	        },
	        _react2.default.createElement(
	          'div',
	          { className: 'video-react-menu-content' },
	          children
	        )
	      );
	    }
	  }]);
	
	  return Popup;
	}(_react.Component);
	
	exports.default = Popup;
	
	
	Popup.propTypes = propTypes;
	Popup.displayName = 'Popup';

/***/ }),

/***/ 710:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = PopupButton;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ClickableComponent = __webpack_require__(233);
	
	var _ClickableComponent2 = _interopRequireDefault(_ClickableComponent);
	
	var _Popup = __webpack_require__(709);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  inline: _propTypes2.default.bool,
	  onClick: _propTypes2.default.func.isRequired,
	  onFocus: _propTypes2.default.func,
	  onBlur: _propTypes2.default.func,
	  className: _propTypes2.default.string
	};
	
	var defaultProps = {
	  inline: true
	};
	
	function PopupButton(props) {
	  var inline = props.inline,
	      className = props.className;
	
	  var ps = _extends({}, props);
	  delete ps.children;
	  delete ps.inline;
	  delete ps.className;
	  return _react2.default.createElement(
	    _ClickableComponent2.default,
	    _extends({
	      className: (0, _classnames2.default)(className, {
	        'video-react-menu-button-inline': !!inline,
	        'video-react-menu-button-popup': !inline
	      }, 'video-react-control video-react-button video-react-menu-button')
	    }, ps),
	    _react2.default.createElement(_Popup2.default, props)
	  );
	}
	
	PopupButton.propTypes = propTypes;
	PopupButton.defaultProps = defaultProps;
	PopupButton.displayName = 'PopupButton';

/***/ }),

/***/ 250:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utils = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  player: _propTypes2.default.object,
	  className: _propTypes2.default.string
	};
	
	function CurrentTimeDisplay(_ref) {
	  var _ref$player = _ref.player,
	      currentTime = _ref$player.currentTime,
	      duration = _ref$player.duration,
	      className = _ref.className;
	
	  var formattedTime = (0, _utils.formatTime)(currentTime, duration);
	  return _react2.default.createElement(
	    'div',
	    {
	      className: (0, _classnames2.default)('video-react-current-time video-react-time-control video-react-control', className)
	    },
	    _react2.default.createElement(
	      'div',
	      {
	        className: 'video-react-current-time-display',
	        'aria-live': 'off'
	      },
	      _react2.default.createElement(
	        'span',
	        { className: 'video-react-control-text' },
	        'Current Time '
	      ),
	      formattedTime
	    )
	  );
	}
	
	CurrentTimeDisplay.propTypes = propTypes;
	CurrentTimeDisplay.displayName = 'CurrentTimeDisplay';
	
	exports.default = CurrentTimeDisplay;

/***/ }),

/***/ 251:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utils = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  player: _propTypes2.default.object,
	  className: _propTypes2.default.string
	};
	
	function DurationDisplay(_ref) {
	  var duration = _ref.player.duration,
	      className = _ref.className;
	
	  var formattedTime = (0, _utils.formatTime)(duration);
	  return _react2.default.createElement(
	    'div',
	    {
	      className: (0, _classnames2.default)(className, 'video-react-duration video-react-time-control video-react-control')
	    },
	    _react2.default.createElement(
	      'div',
	      {
	        className: 'video-react-duration-display',
	        'aria-live': 'off'
	      },
	      _react2.default.createElement(
	        'span',
	        { className: 'video-react-control-text' },
	        'Duration Time '
	      ),
	      formattedTime
	    )
	  );
	}
	
	DurationDisplay.propTypes = propTypes;
	DurationDisplay.displayName = 'DurationDisplay';
	
	exports.default = DurationDisplay;

/***/ }),

/***/ 252:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utils = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  player: _propTypes2.default.object,
	  className: _propTypes2.default.string
	};
	
	function RemainingTimeDisplay(_ref) {
	  var _ref$player = _ref.player,
	      currentTime = _ref$player.currentTime,
	      duration = _ref$player.duration,
	      className = _ref.className;
	
	  var remainingTime = duration - currentTime;
	  var formattedTime = (0, _utils.formatTime)(remainingTime);
	  return _react2.default.createElement(
	    'div',
	    {
	      className: (0, _classnames2.default)('video-react-remaining-time video-react-time-control video-react-control', className)
	    },
	    _react2.default.createElement(
	      'div',
	      {
	        className: 'video-react-remaining-time-display',
	        'aria-live': 'off'
	      },
	      _react2.default.createElement(
	        'span',
	        { className: 'video-react-control-text' },
	        'Remaining Time '
	      ),
	      '-',
	      formattedTime
	    )
	  );
	}
	
	RemainingTimeDisplay.propTypes = propTypes;
	RemainingTimeDisplay.displayName = 'RemainingTimeDisplay';
	
	exports.default = RemainingTimeDisplay;

/***/ }),

/***/ 253:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = TimeDivider;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  separator: _propTypes2.default.string,
	  className: _propTypes2.default.string
	};
	
	function TimeDivider(_ref) {
	  var separator = _ref.separator,
	      className = _ref.className;
	
	  var separatorText = separator || '/';
	  return _react2.default.createElement(
	    'div',
	    {
	      className: (0, _classnames2.default)('video-react-time-control video-react-time-divider', className),
	      dir: 'ltr'
	    },
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'span',
	        null,
	        separatorText
	      )
	    )
	  );
	}
	
	TimeDivider.propTypes = propTypes;
	TimeDivider.displayName = 'TimeDivider';

/***/ }),

/***/ 711:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Slider = __webpack_require__(180);
	
	var _Slider2 = _interopRequireDefault(_Slider);
	
	var _VolumeLevel = __webpack_require__(712);
	
	var _VolumeLevel2 = _interopRequireDefault(_VolumeLevel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  actions: _propTypes2.default.object,
	  player: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  onFocus: _propTypes2.default.func,
	  onBlur: _propTypes2.default.func
	};
	
	var VolumeBar = function (_Component) {
	  _inherits(VolumeBar, _Component);
	
	  function VolumeBar(props, context) {
	    _classCallCheck(this, VolumeBar);
	
	    var _this = _possibleConstructorReturn(this, (VolumeBar.__proto__ || Object.getPrototypeOf(VolumeBar)).call(this, props, context));
	
	    _this.state = {
	      percentage: '0%'
	    };
	
	    _this.handleMouseMove = _this.handleMouseMove.bind(_this);
	    _this.handlePercentageChange = _this.handlePercentageChange.bind(_this);
	    _this.checkMuted = _this.checkMuted.bind(_this);
	    _this.getPercent = _this.getPercent.bind(_this);
	    _this.stepForward = _this.stepForward.bind(_this);
	    _this.stepBack = _this.stepBack.bind(_this);
	    _this.handleFocus = _this.handleFocus.bind(_this);
	    _this.handleBlur = _this.handleBlur.bind(_this);
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(VolumeBar, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'getPercent',
	    value: function getPercent() {
	      var player = this.props.player;
	
	      if (player.muted) {
	        return 0;
	      }
	      return player.volume;
	    }
	  }, {
	    key: 'checkMuted',
	    value: function checkMuted() {
	      var _props = this.props,
	          player = _props.player,
	          actions = _props.actions;
	
	      if (player.muted) {
	        actions.mute(false);
	      }
	    }
	  }, {
	    key: 'handleMouseMove',
	    value: function handleMouseMove(event) {
	      var actions = this.props.actions;
	
	      this.checkMuted();
	      var distance = this.slider.calculateDistance(event);
	      actions.changeVolume(distance);
	    }
	  }, {
	    key: 'stepForward',
	    value: function stepForward() {
	      var _props2 = this.props,
	          player = _props2.player,
	          actions = _props2.actions;
	
	      this.checkMuted();
	      actions.changeVolume(player.volume + 0.1);
	    }
	  }, {
	    key: 'stepBack',
	    value: function stepBack() {
	      var _props3 = this.props,
	          player = _props3.player,
	          actions = _props3.actions;
	
	      this.checkMuted();
	      actions.changeVolume(player.volume - 0.1);
	    }
	  }, {
	    key: 'handleFocus',
	    value: function handleFocus(e) {
	      if (this.props.onFocus) {
	        this.props.onFocus(e);
	      }
	    }
	  }, {
	    key: 'handleBlur',
	    value: function handleBlur(e) {
	      if (this.props.onBlur) {
	        this.props.onBlur(e);
	      }
	    }
	  }, {
	    key: 'handlePercentageChange',
	    value: function handlePercentageChange(percentage) {
	      if (percentage !== this.state.percentage) {
	        this.setState({
	          percentage: percentage
	        });
	      }
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick(event) {
	      event.stopPropagation();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props4 = this.props,
	          player = _props4.player,
	          className = _props4.className;
	
	
	      var volume = (player.volume * 100).toFixed(2);
	      return _react2.default.createElement(
	        _Slider2.default,
	        _extends({
	          ref: function ref(c) {
	            _this2.slider = c;
	          },
	          label: 'volume level',
	          valuenow: volume,
	          valuetext: volume + '%',
	          onMouseMove: this.handleMouseMove,
	          onFocus: this.handleFocus,
	          onBlur: this.handleBlur,
	          onClick: this.handleClick,
	          sliderActive: this.handleFocus,
	          sliderInactive: this.handleBlur,
	          getPercent: this.getPercent,
	          onPercentageChange: this.handlePercentageChange,
	          stepForward: this.stepForward,
	          stepBack: this.stepBack
	        }, this.props, {
	          className: (0, _classnames2.default)(className, 'video-react-volume-bar video-react-slider-bar')
	        }),
	        _react2.default.createElement(_VolumeLevel2.default, this.props)
	      );
	    }
	  }]);
	
	  return VolumeBar;
	}(_react.Component);
	
	VolumeBar.propTypes = propTypes;
	VolumeBar.displayName = 'VolumeBar';
	
	exports.default = VolumeBar;

/***/ }),

/***/ 712:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  percentage: _propTypes2.default.string,
	  vertical: _propTypes2.default.bool,
	  className: _propTypes2.default.string
	};
	
	var defaultProps = {
	  percentage: '100%',
	  vertical: false
	};
	
	function VolumeLevel(_ref) {
	  var percentage = _ref.percentage,
	      vertical = _ref.vertical,
	      className = _ref.className;
	
	  var style = {};
	  if (vertical) {
	    style.height = percentage;
	  } else {
	    style.width = percentage;
	  }
	
	  return _react2.default.createElement(
	    'div',
	    {
	      className: (0, _classnames2.default)(className, 'video-react-volume-level'),
	      style: style
	    },
	    _react2.default.createElement('span', { className: 'video-react-control-text' })
	  );
	}
	
	VolumeLevel.propTypes = propTypes;
	VolumeLevel.defaultProps = defaultProps;
	VolumeLevel.displayName = 'VolumeLevel';
	exports.default = VolumeLevel;

/***/ }),

/***/ 713:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.operationReducer = exports.playerReducer = exports.videoActions = exports.playerActions = exports.PlaybackRate = exports.PlaybackRateMenuButton = exports.VolumeMenuButton = exports.TimeDivider = exports.DurationDisplay = exports.CurrentTimeDisplay = exports.RemainingTimeDisplay = exports.MouseTimeDisplay = exports.LoadProgressBar = exports.PlayProgressBar = exports.Slider = exports.SeekBar = exports.ProgressControl = exports.FullscreenToggle = exports.ReplayControl = exports.ForwardControl = exports.PlayToggle = exports.ControlBar = exports.Shortcut = exports.Bezel = exports.PosterImage = exports.LoadingSpinner = exports.BigPlayButton = exports.Video = exports.Player = undefined;
	
	var _Player = __webpack_require__(704);
	
	var _Player2 = _interopRequireDefault(_Player);
	
	var _Video = __webpack_require__(237);
	
	var _Video2 = _interopRequireDefault(_Video);
	
	var _BigPlayButton = __webpack_require__(232);
	
	var _BigPlayButton2 = _interopRequireDefault(_BigPlayButton);
	
	var _LoadingSpinner = __webpack_require__(234);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	var _PosterImage = __webpack_require__(235);
	
	var _PosterImage2 = _interopRequireDefault(_PosterImage);
	
	var _Slider = __webpack_require__(180);
	
	var _Slider2 = _interopRequireDefault(_Slider);
	
	var _Bezel = __webpack_require__(231);
	
	var _Bezel2 = _interopRequireDefault(_Bezel);
	
	var _Shortcut = __webpack_require__(236);
	
	var _Shortcut2 = _interopRequireDefault(_Shortcut);
	
	var _ControlBar = __webpack_require__(238);
	
	var _ControlBar2 = _interopRequireDefault(_ControlBar);
	
	var _PlayToggle = __webpack_require__(245);
	
	var _PlayToggle2 = _interopRequireDefault(_PlayToggle);
	
	var _ForwardControl = __webpack_require__(239);
	
	var _ForwardControl2 = _interopRequireDefault(_ForwardControl);
	
	var _ReplayControl = __webpack_require__(247);
	
	var _ReplayControl2 = _interopRequireDefault(_ReplayControl);
	
	var _FullscreenToggle = __webpack_require__(241);
	
	var _FullscreenToggle2 = _interopRequireDefault(_FullscreenToggle);
	
	var _ProgressControl = __webpack_require__(246);
	
	var _ProgressControl2 = _interopRequireDefault(_ProgressControl);
	
	var _SeekBar = __webpack_require__(248);
	
	var _SeekBar2 = _interopRequireDefault(_SeekBar);
	
	var _PlayProgressBar = __webpack_require__(244);
	
	var _PlayProgressBar2 = _interopRequireDefault(_PlayProgressBar);
	
	var _LoadProgressBar = __webpack_require__(242);
	
	var _LoadProgressBar2 = _interopRequireDefault(_LoadProgressBar);
	
	var _MouseTimeDisplay = __webpack_require__(243);
	
	var _MouseTimeDisplay2 = _interopRequireDefault(_MouseTimeDisplay);
	
	var _VolumeMenuButton = __webpack_require__(249);
	
	var _VolumeMenuButton2 = _interopRequireDefault(_VolumeMenuButton);
	
	var _PlaybackRateMenuButton = __webpack_require__(181);
	
	var _PlaybackRateMenuButton2 = _interopRequireDefault(_PlaybackRateMenuButton);
	
	var _PlaybackRate = __webpack_require__(705);
	
	var _PlaybackRate2 = _interopRequireDefault(_PlaybackRate);
	
	var _RemainingTimeDisplay = __webpack_require__(252);
	
	var _RemainingTimeDisplay2 = _interopRequireDefault(_RemainingTimeDisplay);
	
	var _CurrentTimeDisplay = __webpack_require__(250);
	
	var _CurrentTimeDisplay2 = _interopRequireDefault(_CurrentTimeDisplay);
	
	var _DurationDisplay = __webpack_require__(251);
	
	var _DurationDisplay2 = _interopRequireDefault(_DurationDisplay);
	
	var _TimeDivider = __webpack_require__(253);
	
	var _TimeDivider2 = _interopRequireDefault(_TimeDivider);
	
	var _player = __webpack_require__(65);
	
	var playerActions = _interopRequireWildcard(_player);
	
	var _video = __webpack_require__(179);
	
	var videoActions = _interopRequireWildcard(_video);
	
	var _reducers = __webpack_require__(254);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Player = _Player2.default;
	exports.Video = _Video2.default;
	exports.BigPlayButton = _BigPlayButton2.default;
	exports.LoadingSpinner = _LoadingSpinner2.default;
	exports.PosterImage = _PosterImage2.default;
	exports.Bezel = _Bezel2.default;
	exports.Shortcut = _Shortcut2.default;
	exports.ControlBar = _ControlBar2.default;
	exports.PlayToggle = _PlayToggle2.default;
	exports.ForwardControl = _ForwardControl2.default;
	exports.ReplayControl = _ReplayControl2.default;
	exports.FullscreenToggle = _FullscreenToggle2.default;
	exports.ProgressControl = _ProgressControl2.default;
	exports.SeekBar = _SeekBar2.default;
	exports.Slider = _Slider2.default;
	exports.PlayProgressBar = _PlayProgressBar2.default;
	exports.LoadProgressBar = _LoadProgressBar2.default;
	exports.MouseTimeDisplay = _MouseTimeDisplay2.default;
	exports.RemainingTimeDisplay = _RemainingTimeDisplay2.default;
	exports.CurrentTimeDisplay = _CurrentTimeDisplay2.default;
	exports.DurationDisplay = _DurationDisplay2.default;
	exports.TimeDivider = _TimeDivider2.default;
	exports.VolumeMenuButton = _VolumeMenuButton2.default;
	exports.PlaybackRateMenuButton = _PlaybackRateMenuButton2.default;
	exports.PlaybackRate = _PlaybackRate2.default;
	exports.playerActions = playerActions;
	exports.videoActions = videoActions;
	exports.playerReducer = _reducers.playerReducer;
	exports.operationReducer = _reducers.operationReducer;

/***/ }),

/***/ 254:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.operationReducer = exports.playerReducer = undefined;
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  return {
	    player: (0, _player2.default)(state.player, action),
	    operation: (0, _operation2.default)(state.operation, action)
	  };
	};
	
	var _player = __webpack_require__(715);
	
	var _player2 = _interopRequireDefault(_player);
	
	var _operation = __webpack_require__(714);
	
	var _operation2 = _interopRequireDefault(_operation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var playerReducer = exports.playerReducer = _player2.default;
	var operationReducer = exports.operationReducer = _operation2.default;

/***/ }),

/***/ 714:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.operation = operation;
	
	var _player = __webpack_require__(65);
	
	var initialState = {
	  count: 0,
	  operation: {
	    action: '',
	    source: ''
	  }
	};
	
	function operation() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _player.OPERATE:
	      return _extends({}, state, {
	        count: state.count + 1,
	        operation: _extends({}, state.operation, action.operation)
	      });
	    default:
	      return state;
	  }
	}
	
	exports.default = operation;

/***/ }),

/***/ 715:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.player = player;
	
	var _video = __webpack_require__(179);
	
	var _player = __webpack_require__(65);
	
	var initialState = {
	  currentSrc: null,
	  duration: 0,
	  currentTime: 0,
	  seekingTime: 0,
	  buffered: null,
	  waiting: false,
	  seeking: false,
	  paused: true,
	  autoPaused: false,
	  ended: false,
	  playbackRate: 1,
	  muted: false,
	  volume: 1,
	  readyState: 0,
	  networkState: 0,
	  videoWidth: 0,
	  videoHeight: 0,
	  hasStarted: false,
	  userActivity: true,
	  isActive: false,
	  isFullscreen: false
	};
	
	function player() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _player.USER_ACTIVATE:
	      return _extends({}, state, {
	        userActivity: action.activity
	      });
	    case _player.PLAYER_ACTIVATE:
	      return _extends({}, state, {
	        isActive: action.activity
	      });
	    case _player.FULLSCREEN_CHANGE:
	      return _extends({}, state, {
	        isFullscreen: !!action.isFullscreen
	      });
	    case _video.SEEKING_TIME:
	      return _extends({}, state, {
	        seekingTime: action.time
	      });
	    case _video.END_SEEKING:
	      return _extends({}, state, {
	        seekingTime: 0
	      });
	    case _video.LOAD_START:
	      return _extends({}, state, action.videoProps, {
	        hasStarted: false,
	        ended: false
	      });
	    case _video.CAN_PLAY:
	      return _extends({}, state, action.videoProps, {
	        waiting: false
	      });
	    case _video.WAITING:
	      return _extends({}, state, action.videoProps, {
	        waiting: true
	      });
	    case _video.CAN_PLAY_THROUGH:
	    case _video.PLAYING:
	      return _extends({}, state, action.videoProps, {
	        waiting: false
	      });
	    case _video.PLAY:
	      return _extends({}, state, action.videoProps, {
	        ended: false,
	        paused: false,
	        autoPaused: false,
	        waiting: false,
	        hasStarted: true
	      });
	    case _video.PAUSE:
	      return _extends({}, state, action.videoProps, {
	        paused: true
	      });
	    case _video.END:
	      return _extends({}, state, action.videoProps, {
	        ended: true
	      });
	    case _video.SEEKING:
	      return _extends({}, state, action.videoProps, {
	        seeking: true
	      });
	    case _video.SEEKED:
	      return _extends({}, state, action.videoProps, {
	        seeking: false
	      });
	    case _video.ERROR:
	      return _extends({}, state, action.videoProps, {
	        error: 'UNKNOWN ERROR',
	        ended: true
	      });
	    case _video.DURATION_CHANGE:
	    case _video.TIME_UPDATE:
	    case _video.VOLUME_CHANGE:
	    case _video.PROGRESS_CHANGE:
	    case _video.RATE_CHANGE:
	    case _video.SUSPEND:
	    case _video.ABORT:
	    case _video.EMPTIED:
	    case _video.STALLED:
	    case _video.LOADED_META_DATA:
	    case _video.LOADED_DATA:
	    case _video.RESIZE:
	      var newState = _extends({}, state, action.videoProps);
	      if (action.videoProps.paused === false) {
	        newState.hasStarted = true;
	        newState.waiting = false;
	      }
	      return newState;
	    default:
	      return state;
	  }
	}
	
	exports.default = player;

/***/ }),

/***/ 716:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var USER_AGENT = typeof window !== 'undefined' && window.navigator ? window.navigator.userAgent : '';
	// const webkitVersionMap = (/AppleWebKit\/([\d.]+)/i).exec(USER_AGENT);
	// const appleWebkitVersion = webkitVersionMap ? parseFloat(webkitVersionMap.pop()) : null;
	
	/*
	 * Device is an iPhone
	 *
	 * @type {Boolean}
	 * @constant
	 * @private
	 */
	var IS_IPAD = exports.IS_IPAD = /iPad/i.test(USER_AGENT);
	
	// The Facebook app's UIWebView identifies as both an iPhone and iPad, so
	// to identify iPhones, we need to exclude iPads.
	// http://artsy.github.io/blog/2012/10/18/the-perils-of-ios-user-agent-sniffing/
	var IS_IPHONE = exports.IS_IPHONE = /iPhone/i.test(USER_AGENT) && !IS_IPAD;
	var IS_IPOD = exports.IS_IPOD = /iPod/i.test(USER_AGENT);
	var IS_IOS = exports.IS_IOS = IS_IPHONE || IS_IPAD || IS_IPOD;

/***/ }),

/***/ 182:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.findElPosition = findElPosition;
	exports.getPointerPosition = getPointerPosition;
	exports.blurNode = blurNode;
	exports.hasClass = hasClass;
	
	var _reactDom = __webpack_require__(24);
	
	/**
	 * Offset Left
	 * getBoundingClientRect technique from
	 * John Resig http://ejohn.org/blog/getboundingclientrect-is-awesome/
	 *
	 * @function findElPosition
	 * @param {Element} el Element from which to get offset
	 * @return {Object}
	 */
	function findElPosition(el) {
	  var box = void 0;
	
	  if (el.getBoundingClientRect && el.parentNode) {
	    box = el.getBoundingClientRect();
	  }
	
	  if (!box) {
	    return {
	      left: 0,
	      top: 0
	    };
	  }
	
	  var docEl = document.documentElement;
	  var body = document.body;
	
	  var clientLeft = docEl.clientLeft || body.clientLeft || 0;
	  var scrollLeft = window.pageXOffset || body.scrollLeft;
	  var left = box.left + scrollLeft - clientLeft;
	
	  var clientTop = docEl.clientTop || body.clientTop || 0;
	  var scrollTop = window.pageYOffset || body.scrollTop;
	  var top = box.top + scrollTop - clientTop;
	
	  // Android sometimes returns slightly off decimal values, so need to round
	  return {
	    left: Math.round(left),
	    top: Math.round(top)
	  };
	}
	
	/**
	 * Get pointer position in element
	 * Returns an object with x and y coordinates.
	 * The base on the coordinates are the bottom left of the element.
	 *
	 * @function getPointerPosition
	 * @param {Element} el Element on which to get the pointer position on
	 * @param {Event} event Event object
	 * @return {Object} This object will have x and y coordinates corresponding to the mouse position
	 */
	function getPointerPosition(el, event) {
	  var position = {};
	  var box = findElPosition(el);
	  var boxW = el.offsetWidth;
	  var boxH = el.offsetHeight;
	
	  var boxY = box.top;
	  var boxX = box.left;
	  var pageY = event.pageY;
	  var pageX = event.pageX;
	
	  if (event.changedTouches) {
	    pageX = event.changedTouches[0].pageX;
	    pageY = event.changedTouches[0].pageY;
	  }
	
	  position.y = Math.max(0, Math.min(1, (boxY - pageY + boxH) / boxH));
	  position.x = Math.max(0, Math.min(1, (pageX - boxX) / boxW));
	
	  return position;
	}
	
	// blur an element
	function blurNode(reactNode) {
	  var domNode = (0, _reactDom.findDOMNode)(reactNode);
	  if (domNode && domNode.blur) {
	    domNode.blur();
	  }
	}
	
	// check if an element has a class name
	function hasClass(elm, cls) {
	  var classes = elm.className.split(' ');
	  for (var i = 0; i < classes.length; i++) {
	    if (classes[i].toLowerCase() === cls.toLowerCase()) {
	      return true;
	    }
	  }
	  return false;
	}

/***/ }),

/***/ 255:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Fullscreen = function () {
	  function Fullscreen() {
	    _classCallCheck(this, Fullscreen);
	  }
	
	  _createClass(Fullscreen, [{
	    key: 'request',
	    value: function request(elm) {
	      if (elm.requestFullscreen) {
	        elm.requestFullscreen();
	      } else if (elm.webkitRequestFullscreen) {
	        elm.webkitRequestFullscreen();
	      } else if (elm.mozRequestFullScreen) {
	        elm.mozRequestFullScreen();
	      } else if (elm.msRequestFullscreen) {
	        elm.msRequestFullscreen();
	      }
	    }
	  }, {
	    key: 'exit',
	    value: function exit() {
	      if (document.exitFullscreen) {
	        document.exitFullscreen();
	      } else if (document.webkitExitFullscreen) {
	        document.webkitExitFullscreen();
	      } else if (document.mozCancelFullScreen) {
	        document.mozCancelFullScreen();
	      } else if (document.msExitFullscreen) {
	        document.msExitFullscreen();
	      }
	    }
	  }, {
	    key: 'addEventListener',
	    value: function addEventListener(handler) {
	      document.addEventListener('fullscreenchange', handler);
	      document.addEventListener('webkitfullscreenchange', handler);
	      document.addEventListener('mozfullscreenchange', handler);
	      document.addEventListener('MSFullscreenChange', handler);
	    }
	  }, {
	    key: 'removeEventListener',
	    value: function removeEventListener(handler) {
	      document.removeEventListener('fullscreenchange', handler);
	      document.removeEventListener('webkitfullscreenchange', handler);
	      document.removeEventListener('mozfullscreenchange', handler);
	      document.removeEventListener('MSFullscreenChange', handler);
	    }
	  }, {
	    key: 'isFullscreen',
	    get: function get() {
	      return document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement;
	    }
	  }, {
	    key: 'enabled',
	    get: function get() {
	      return document.fullscreenEnabled || document.webkitFullscreenEnabled || document.mozFullScreenEnabled || document.msFullscreenEnabled;
	    }
	  }]);
	
	  return Fullscreen;
	}();
	
	exports.default = new Fullscreen();

/***/ }),

/***/ 21:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.mediaProperties = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.formatTime = formatTime;
	exports.isVideoChild = isVideoChild;
	exports.mergeAndSortChildren = mergeAndSortChildren;
	exports.deprecatedWarning = deprecatedWarning;
	exports.throttle = throttle;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @file format-time.js
	 *
	 * Format seconds as a time string, H:MM:SS or M:SS
	 * Supplying a guide (in seconds) will force a number of leading zeros
	 * to cover the length of the guide
	 *
	 * @param  {Number} seconds Number of seconds to be turned into a string
	 * @param  {Number} guide   Number (in seconds) to model the string after
	 * @return {String}         Time formatted as H:MM:SS or M:SS
	 * @private
	 * @function formatTime
	 */
	function formatTime() {
	  var seconds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	  var guide = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : seconds;
	
	  var s = Math.floor(seconds % 60);
	  var m = Math.floor(seconds / 60 % 60);
	  var h = Math.floor(seconds / 3600);
	  var gm = Math.floor(guide / 60 % 60);
	  var gh = Math.floor(guide / 3600);
	
	  // handle invalid times
	  if (isNaN(seconds) || seconds === Infinity) {
	    // '-' is false for all relational operators (e.g. <, >=) so this setting
	    // will add the minimum number of fields specified by the guide
	    h = m = s = '-';
	  }
	
	  // Check if we need to show hours
	  h = h > 0 || gh > 0 ? h + ':' : '';
	
	  // If hours are showing, we may need to add a leading zero.
	  // Always show at least one digit of minutes.
	  m = ((h || gm >= 10) && m < 10 ? '0' + m : m) + ':';
	
	  // Check if leading zero is need for seconds
	  s = s < 10 ? '0' + s : s;
	
	  return h + m + s;
	}
	
	// Check if the element belongs to a video element
	// only accept <source />, <track />,
	// <MyComponent isVideoChild />
	// elements
	function isVideoChild(c) {
	  if (c.props && c.props.isVideoChild) {
	    return true;
	  }
	  return c.type === 'source' || c.type === 'track';
	}
	
	var find = function find(elements, func) {
	  return elements.filter(func)[0];
	};
	
	// check if two components are the same type
	var isTypeEqual = function isTypeEqual(component1, component2) {
	  var type1 = component1.type;
	  var type2 = component2.type;
	
	  if (typeof type1 === 'string' || typeof type2 === 'string') {
	    return type1 === type2;
	  }
	
	  if (typeof type1 === 'function' && typeof type2 === 'function') {
	    return type1.displayName === type2.displayName;
	  }
	
	  return false;
	};
	
	// merge default children
	// sort them by `order` property
	// filter them by `disabled` property
	function mergeAndSortChildren(defaultChildren, _children, _parentProps) {
	  var defaultOrder = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
	
	  var children = _react2.default.Children.toArray(_children);
	  var parentProps = _extends({}, _parentProps);
	  return children.filter(function (e) {
	    return !e.props.disabled;
	  }) // filter the disabled components
	  .concat(defaultChildren.filter(function (c) {
	    return !find(children, function (component) {
	      return isTypeEqual(component, c);
	    });
	  })).map(function (element) {
	    var defaultComponent = find(defaultChildren, function (c) {
	      return isTypeEqual(c, element);
	    });
	    delete parentProps.order;
	    var defaultProps = defaultComponent ? defaultComponent.props : {};
	    var props = _extends({}, parentProps, defaultProps, element.props);
	    var e = _react2.default.cloneElement(element, props, element.props.children);
	    return e;
	  }).sort(function (a, b) {
	    return (a.props.order || defaultOrder) - (b.props.order || defaultOrder);
	  });
	}
	
	/**
	 * Temporary utility for generating the warnings
	 */
	function deprecatedWarning(oldMethodCall, newMethodCall) {
	  // eslint-disable-next-line no-console
	  console.warn('WARNING: ' + oldMethodCall + ' will be deprecated soon! Please use ' + newMethodCall + ' instead.');
	}
	
	function throttle(callback, limit) {
	  var _arguments = arguments;
	
	  var wait = false;
	  return function () {
	    if (!wait) {
	      callback.apply(null, _arguments);
	      wait = true;
	      setTimeout(function () {
	        wait = false;
	      }, limit);
	    }
	  };
	}
	
	var mediaProperties = exports.mediaProperties = ['error', 'src', 'srcObject', 'currentSrc', 'crossOrigin', 'networkState', 'preload', 'buffered', 'readyState', 'seeking', 'currentTime', 'duration', 'paused', 'defaultPlaybackRate', 'playbackRate', 'played', 'seekable', 'ended', 'autoplay', 'loop', 'mediaGroup', 'controller', 'controls', 'volume', 'muted', 'defaultMuted', 'audioTracks', 'videoTracks', 'textTracks', 'width', 'height', 'videoWidth', 'videoHeight', 'poster'];

/***/ }),

/***/ 95:
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),

/***/ 272:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAnchorLinkSmoothScroll = __webpack_require__(629);
	
	var _reactAnchorLinkSmoothScroll2 = _interopRequireDefault(_reactAnchorLinkSmoothScroll);
	
	var _Logo = __webpack_require__(68);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	var _VideoCover = __webpack_require__(278);
	
	var _VideoCover2 = _interopRequireDefault(_VideoCover);
	
	var _Map = __webpack_require__(273);
	
	var _Map2 = _interopRequireDefault(_Map);
	
	var _SEO = __webpack_require__(55);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	var _HomePageModule = __webpack_require__(379);
	
	var _HomePageModule2 = _interopRequireDefault(_HomePageModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HomePage = function (_Component) {
		_inherits(HomePage, _Component);
	
		function HomePage() {
			var _temp, _this, _ret;
	
			_classCallCheck(this, HomePage);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = { isOnMap: null }, _this.handleScroll = function () {
				if (window.scrollY >= _this.refs.sectionMap.offsetTop - 350) {
					_this.setState({ isOnMap: true });
				} else {
					_this.setState({ isOnMap: false });
				}
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		HomePage.prototype.componentDidMount = function componentDidMount() {
			window.addEventListener('scroll', this.handleScroll);
		};
	
		HomePage.prototype.componentWillUnmount = function componentWillUnmount() {
			window.removeEventListener('scroll', this.handleScroll);
		};
	
		HomePage.prototype.render = function render() {
			var isOnMap = this.state.isOnMap;
			var data = this.props.data;
	
			return _react2.default.createElement(
				_react.Fragment,
				null,
				_react2.default.createElement(_SEO2.default, null),
				_react2.default.createElement(
					'section',
					{ className: _HomePageModule2.default.videoCoverContainer },
					_react2.default.createElement(
						'div',
						{ className: _HomePageModule2.default.copy },
						_react2.default.createElement(_Logo2.default, { fill: '#fff', containerClassName: _HomePageModule2.default.logoContainer }),
						_react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: data.markdownRemark.frontmatter.description } }),
						_react2.default.createElement(
							_reactAnchorLinkSmoothScroll2.default,
							{ href: '#map', className: _HomePageModule2.default.goMapButton },
							'Despl\xE1zate para continuar'
						)
					),
					_react2.default.createElement(_VideoCover2.default, { src: data.markdownRemark.frontmatter.video.src.publicURL })
				),
				_react2.default.createElement(
					'section',
					{ id: 'map', className: _HomePageModule2.default.mapContainer, ref: 'sectionMap' },
					_react2.default.createElement(_Map2.default, { isOnMap: isOnMap,
						places: data.markdownRemark.frontmatter.map.places,
						bgImage: data.markdownRemark.frontmatter.map.bgImage.childImageSharp,
						bgPageImage: data.markdownRemark.frontmatter.map.bgPageImage.childImageSharp })
				)
			);
		};
	
		return HomePage;
	}(_react.Component);
	
	exports.default = HomePage;
	module.exports = exports['default'];

/***/ }),

/***/ 379:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"videoCoverContainer":"src-components-HomePage----HomePage-module---videoCoverContainer---3ZbUD","copy":"src-components-HomePage----HomePage-module---copy---2Be8Z","logoContainer":"src-components-HomePage----HomePage-module---logoContainer---33H2O","goMapButton":"src-components-HomePage----HomePage-module---goMapButton---yJpcT","mapContainer":"src-components-HomePage----HomePage-module---mapContainer---cqsPr"};

/***/ }),

/***/ 68:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Logo = function (_Component) {
		_inherits(Logo, _Component);
	
		function Logo() {
			_classCallCheck(this, Logo);
	
			return _possibleConstructorReturn(this, _Component.apply(this, arguments));
		}
	
		Logo.prototype.render = function render() {
			var _props = this.props,
			    containerClassName = _props.containerClassName,
			    fill = _props.fill,
			    style = _props.style;
	
			return _react2.default.createElement(
				'div',
				{ className: containerClassName, style: style },
				_react2.default.createElement(
					'svg',
					{ xmlns: 'http://www.w3.org/2000/svg', width: '100%', viewBox: '0 0 300 139', style: { maxWidth: "158px" } },
					_react2.default.createElement(
						'g',
						{ fill: fill },
						_react2.default.createElement('path', { d: 'M49.0540541,12.1621622 C48.3783784,12.8378378 47.5675676,13.2432432 46.6216216,13.3783784 C45.6756757,13.5135135 45.1351351,13.2432432 44.8648649,12.5675676 C44.5945946,11.8918919 44.5945946,11.4864865 44.7297297,11.2162162 C44.8648649,10.9459459 45.2702703,10.4054054 45.8108108,9.59459459 C46.3513514,8.91891892 46.3513514,8.10810811 45.6756757,7.16216216 C45,6.35135135 44.0540541,5.67567568 42.8378378,5.13513514 C41.6216216,4.72972973 40.4054054,4.59459459 39.1891892,4.72972973 C37.972973,4.86486486 37.1621622,5.27027027 36.4864865,5.94594595 C35.8108108,6.62162162 35.4054054,7.43243243 35.4054054,8.51351351 C35.2702703,9.59459459 35.5405405,10.6756757 36.0810811,11.8918919 C36.6216216,13.1081081 37.2972973,14.1891892 38.1081081,15 C38.9189189,15.8108108 39.7297297,16.6216216 40.5405405,17.4324324 C41.3513514,18.2432432 41.7567568,18.9189189 41.7567568,19.5945946 C41.7567568,20.2702703 41.4864865,20.9459459 40.9459459,21.6216216 C40.4054054,22.2972973 39.4594595,22.8378378 38.1081081,23.3783784 C36.7567568,23.7837838 35.1351351,24.7297297 33.2432432,26.0810811 C31.3513514,27.4324324 29.4594595,28.5135135 27.5675676,29.4594595 C25.6756757,30.4054054 24.1891892,31.3513514 22.972973,32.1621622 C21.7567568,33.1081081 20.9459459,34.1891892 20.4054054,35.4054054 C19.8648649,36.6216216 20.1351351,37.7027027 21.0810811,38.6486486 C22.027027,39.5945946 23.2432432,40.2702703 25,40.5405405 C26.6216216,40.8108108 28.2432432,40.9459459 29.8648649,40.9459459 C31.4864865,40.8108108 32.972973,40.6756757 34.4594595,40.2702703 C35.9459459,39.8648649 37.4324324,39.4594595 39.0540541,38.7837838 C40.6756757,38.2432432 43.5135135,37.2972973 47.2972973,36.2162162 C47.4324324,37.972973 46.6216216,39.1891892 45,40 C43.3783784,40.6756757 41.7567568,41.4864865 40.1351351,42.2972973 C38.5135135,43.1081081 36.6216216,43.7837838 34.4594595,44.4594595 C32.4324324,45.1351351 29.8648649,45.5405405 26.8918919,45.6756757 C24.5945946,45.5405405 22.7027027,45.4054054 21.3513514,45.1351351 C20,44.8648649 18.6486486,44.4594595 17.2972973,43.6486486 C15.9459459,42.8378378 15,41.8918919 14.4594595,40.8108108 C13.7837838,39.7297297 13.5135135,38.3783784 13.3783784,37.027027 C13.5135135,35.8108108 13.7837838,34.4594595 14.4594595,33.1081081 C15.1351351,31.7567568 16.2162162,30.4054054 17.8378378,29.0540541 C19.3243243,27.7027027 21.3513514,26.6216216 23.6486486,25.6756757 C25.9459459,24.8648649 27.972973,23.9189189 29.7297297,22.972973 C31.4864865,22.027027 32.7027027,21.0810811 33.6486486,20.2702703 C34.5945946,19.4594595 34.8648649,18.5135135 34.5945946,17.5675676 C34.3243243,16.6216216 33.5135135,15.6756757 32.2972973,14.7297297 C31.0810811,13.7837838 30.2702703,12.7027027 30,11.2162162 C29.7297297,9.86486486 29.5945946,8.64864865 29.8648649,7.56756757 C30,6.48648649 30.2702703,5.67567568 30.5405405,4.86486486 C30.8108108,4.05405405 31.3513514,3.37837838 32.1621622,2.83783784 C32.972973,2.16216216 33.9189189,1.75675676 35.1351351,1.35135135 C36.2162162,0.945945946 37.972973,0.675675676 40.2702703,0.540540541 L43.3783784,0.810810811 C46.3513514,1.62162162 48.2432432,2.56756757 49.1891892,3.78378378 C50.1351351,5 50.6756757,6.48648649 50.9459459,8.37837838 C50.2702703,10.1351351 49.7297297,11.3513514 49.0540541,12.1621622 Z' }),
						_react2.default.createElement('path', { d: 'M43.3783784,39.0540541 C43.5135135,38.6486486 44.1891892,38.2432432 45.4054054,37.8378378 C46.4864865,37.5675676 48.1081081,36.7567568 50,35.5405405 C50.1351351,34.7297297 50.5405405,34.1891892 51.3513514,33.9189189 C52.027027,33.6486486 52.7027027,33.6486486 53.3783784,33.9189189 C54.0540541,34.1891892 55,33.9189189 56.2162162,33.1081081 C57.5675676,32.2972973 59.0540541,31.0810811 60.8108108,29.4594595 C62.5675676,27.8378378 63.6486486,26.7567568 63.9189189,26.4864865 C64.1891892,26.0810811 64.5945946,25.8108108 65.1351351,25.6756757 C65.6756757,25.6756757 66.0810811,25.8108108 66.4864865,25.9459459 C66.8918919,26.0810811 67.2972973,26.4864865 67.7027027,27.027027 C68.1081081,27.5675676 68.3783784,28.1081081 68.5135135,28.7837838 C68.5135135,29.4594595 68.2432432,29.8648649 67.5675676,30.2702703 C66.8918919,30.6756757 65.9459459,30.9459459 64.8648649,31.3513514 C63.7837838,31.7567568 62.8378378,32.1621622 62.027027,32.5675676 C61.2162162,32.972973 60.4054054,33.6486486 59.8648649,34.1891892 C59.1891892,34.8648649 58.7837838,35.4054054 58.6486486,35.8108108 C58.5135135,36.2162162 58.5135135,36.6216216 58.7837838,37.027027 C59.0540541,37.4324324 59.7297297,37.4324324 60.6756757,37.1621622 C61.6216216,36.8918919 62.2972973,36.8918919 62.8378378,37.027027 C63.3783784,37.1621622 63.6486486,37.5675676 63.7837838,38.1081081 C63.9189189,38.6486486 63.7837838,39.3243243 63.5135135,39.8648649 C63.2432432,40.5405405 63.3783784,40.9459459 63.6486486,41.3513514 C64.0540541,41.7567568 65,41.6216216 66.4864865,41.2162162 C68.1081081,40.8108108 69.4594595,40 70.6756757,38.7837838 C71.8918919,37.5675676 72.8378378,37.027027 73.3783784,36.8918919 C73.9189189,36.7567568 74.3243243,36.8918919 74.5945946,37.1621622 C74.8648649,37.4324324 75.1351351,38.1081081 75.2702703,39.1891892 C73.1081081,40.8108108 71.3513514,41.8918919 70.1351351,42.5675676 C68.9189189,43.2432432 67.8378378,43.7837838 66.7567568,44.1891892 C65.8108108,44.5945946 64.7297297,45 63.6486486,45 L62.027027,44.8648649 L60.8108108,44.1891892 C60,43.5135135 59.5945946,42.972973 59.3243243,42.2972973 C59.1891892,41.7567568 58.9189189,41.2162162 58.9189189,40.9459459 C58.7837838,40.6756757 58.6486486,40.4054054 58.2432432,40.2702703 C57.972973,40.1351351 57.4324324,40.2702703 56.8918919,40.6756757 C56.3513514,41.0810811 55.4054054,41.6216216 54.1891892,42.2972973 C52.972973,42.972973 52.027027,43.2432432 51.3513514,43.2432432 C50.6756757,43.2432432 50.1351351,43.1081081 49.5945946,42.8378378 C49.0540541,42.5675676 48.7837838,42.1621622 48.5135135,41.6216216 C48.3783784,41.2162162 48.3783784,40.6756757 48.6486486,40.1351351 C48.9189189,39.5945946 49.4594595,39.1891892 50,38.9189189 C50.5405405,38.6486486 50.8108108,38.3783784 50.6756757,37.972973 C50.5405405,37.7027027 49.8648649,37.7027027 49.0540541,38.2432432 C48.1081081,38.7837838 47.1621622,39.1891892 46.3513514,39.5945946 C45.4054054,39.8648649 44.7297297,40.1351351 44.3243243,40.1351351 C43.9189189,40.5405405 43.5135135,40.1351351 43.3783784,39.0540541 Z' }),
						_react2.default.createElement('path', { d: 'M74.0540541,36.4864865 C75.8108108,35.6756757 77.7027027,34.4594595 79.7297297,32.7027027 C81.7567568,30.9459459 84.4594595,29.1891892 87.7027027,27.2972973 C90.9459459,25.4054054 93.3783784,23.6486486 95,22.027027 C96.6216216,20.4054054 97.7027027,19.4594595 98.1081081,19.1891892 C98.6486486,18.9189189 98.9189189,18.9189189 99.1891892,18.9189189 C99.4594595,18.9189189 99.8648649,19.0540541 100.135135,19.3243243 C100.540541,19.5945946 100.540541,20.2702703 100.405405,21.3513514 C100.135135,22.4324324 99.1891892,23.9189189 97.5675676,25.8108108 C95.9459459,27.7027027 94.3243243,29.1891892 92.7027027,30.4054054 C91.2162162,31.4864865 89.0540541,33.5135135 86.4864865,36.3513514 C90.1351351,34.7297297 92.972973,33.5135135 95.1351351,32.4324324 C97.2972973,31.3513514 99.3243243,30.5405405 101.081081,30 C102.837838,29.4594595 104.324324,29.0540541 105.675676,28.9189189 C106.891892,28.7837838 107.837838,28.9189189 108.378378,29.5945946 C108.918919,30.2702703 109.054054,31.2162162 108.648649,32.5675676 C108.243243,33.9189189 107.432432,35.1351351 106.351351,36.3513514 C105.27027,37.4324324 104.459459,38.3783784 104.189189,38.9189189 C103.918919,39.5945946 104.459459,39.8648649 105.945946,39.8648649 C107.432432,39.8648649 108.648649,39.5945946 109.594595,39.3243243 C110.540541,38.9189189 111.351351,38.3783784 112.297297,37.7027027 C113.108108,36.8918919 113.783784,37.027027 114.189189,38.1081081 C114.054054,39.8648649 113.243243,41.2162162 111.756757,42.027027 C110.27027,42.972973 108.378378,43.5135135 106.216216,43.7837838 C103.918919,44.0540541 102.162162,44.0540541 100.945946,43.9189189 C99.7297297,43.7837838 98.9189189,43.1081081 98.3783784,42.1621622 C97.8378378,41.2162162 97.972973,40.1351351 98.7837838,39.1891892 C99.4594595,38.1081081 100.27027,37.1621622 100.945946,36.2162162 C101.756757,35.2702703 102.567568,34.4594595 103.378378,33.7837838 C104.189189,33.1081081 104.324324,32.7027027 103.918919,32.5675676 C103.378378,32.4324324 102.567568,32.5675676 101.351351,32.972973 C100.135135,33.3783784 98.2432432,34.1891892 95.6756757,35.2702703 C93.1081081,36.3513514 90.6756757,37.5675676 88.3783784,39.0540541 C86.0810811,40.4054054 83.3783784,42.2972973 80.1351351,44.8648649 C76.8918919,47.4324324 74.4594595,49.4594595 72.5675676,51.2162162 C70.6756757,52.972973 68.5135135,55.1351351 65.8108108,57.7027027 C63.1081081,60.2702703 60.6756757,62.2972973 58.5135135,63.6486486 C56.3513514,65.1351351 55,66.0810811 54.3243243,66.6216216 C53.7837838,67.027027 53.1081081,67.2972973 52.4324324,67.2972973 L52.1621622,67.2972973 C51.3513514,67.2972973 50.9459459,66.8918919 50.6756757,66.0810811 L50.6756757,65.8108108 C50.6756757,65.1351351 51.3513514,64.1891892 52.8378378,63.1081081 C54.4594595,61.8918919 56.3513514,60.2702703 58.7837838,58.1081081 C61.0810811,55.9459459 64.3243243,53.1081081 68.2432432,49.8648649 C72.1621622,46.4864865 75.1351351,44.0540541 77.2972973,42.1621622 C79.3243243,40.4054054 81.0810811,38.7837838 82.4324324,37.4324324 C83.7837838,36.0810811 86.0810811,33.9189189 89.0540541,30.9459459 C85.6756757,32.4324324 82.972973,34.0540541 80.6756757,35.6756757 C78.3783784,37.2972973 76.4864865,38.6486486 74.8648649,39.7297297 C73.2432432,40.8108108 72.1621622,40.6756757 71.7567568,39.1891892 C71.6216216,38.1081081 72.4324324,37.1621622 74.0540541,36.4864865 Z' }),
						_react2.default.createElement('path', { d: 'M112.162162,33.9189189 C112.567568,32.972973 113.378378,31.8918919 114.459459,30.8108108 C115.540541,29.7297297 116.486486,28.7837838 117.567568,28.1081081 C118.648649,27.2972973 119.72973,26.7567568 120.810811,26.4864865 L122.027027,26.4864865 C123.108108,26.4864865 124.054054,26.7567568 124.864865,27.4324324 C125.675676,27.972973 126.081081,29.0540541 125.945946,30.4054054 C125.810811,31.8918919 125.135135,33.1081081 123.783784,34.1891892 C122.432432,35.2702703 121.081081,35.9459459 119.459459,36.4864865 C117.837838,36.8918919 116.891892,37.2972973 116.891892,37.7027027 C116.756757,38.1081081 117.027027,38.5135135 117.702703,38.9189189 C118.378378,39.3243243 119.864865,39.5945946 122.162162,39.7297297 C124.459459,39.8648649 126.351351,39.7297297 127.837838,39.3243243 C129.324324,38.9189189 130.405405,38.5135135 131.351351,38.1081081 C132.297297,37.7027027 132.972973,37.4324324 133.513514,37.2972973 C134.054054,37.1621622 134.459459,37.4324324 134.72973,38.1081081 C133.783784,39.4594595 132.837838,40.4054054 131.756757,40.9459459 C130.675676,41.6216216 129.324324,42.1621622 127.567568,42.5675676 C125.945946,43.1081081 123.918919,43.3783784 121.486486,43.5135135 L120,43.5135135 C117.432432,43.2432432 115.675676,42.972973 114.72973,42.4324324 C113.783784,42.027027 113.108108,41.4864865 112.567568,40.8108108 C112.027027,40.2702703 111.756757,39.3243243 111.486486,38.1081081 C111.486486,36.2162162 111.756757,34.8648649 112.162162,33.9189189 Z M116.216216,34.5945946 C118.378378,33.9189189 119.864865,33.2432432 120.540541,32.5675676 C121.216216,31.8918919 121.621622,31.3513514 121.486486,30.8108108 C121.351351,30.2702703 120.810811,30.2702703 119.72973,30.8108108 C118.648649,31.3513514 117.837838,31.8918919 117.432432,32.5675676 C116.891892,33.2432432 116.486486,33.9189189 116.216216,34.5945946 Z' }),
						_react2.default.createElement('path', { d: 'M157.567568,25.8108108 C158.513514,24.3243243 159.459459,23.2432432 160.135135,22.4324324 C160.810811,21.6216216 161.891892,20.6756757 162.972973,19.4594595 C164.189189,18.2432432 165.405405,17.027027 166.756757,15.6756757 C168.108108,14.4594595 169.324324,13.5135135 170.405405,12.8378378 C171.621622,12.1621622 172.432432,11.8918919 172.972973,11.7567568 C173.783784,11.8918919 174.324324,12.1621622 174.594595,12.4324324 C174.864865,12.7027027 175.135135,13.2432432 175.27027,13.9189189 C174.864865,15.1351351 174.189189,16.3513514 173.108108,17.5675676 C172.027027,18.9189189 170.810811,20.1351351 169.459459,21.4864865 C168.243243,22.8378378 167.162162,23.7837838 166.216216,24.3243243 C165.27027,24.8648649 164.459459,25.4054054 163.513514,25.8108108 C162.567568,26.2162162 161.621622,27.027027 160.540541,28.1081081 C159.459459,29.3243243 158.378378,30.5405405 157.162162,31.8918919 C155.945946,33.2432432 155.135135,34.3243243 154.594595,35.2702703 C154.054054,36.2162162 153.513514,36.8918919 152.972973,37.5675676 C152.432432,38.2432432 152.162162,38.7837838 152.162162,39.1891892 C152.162162,39.5945946 152.432432,40 153.108108,40.1351351 C153.783784,40.2702703 154.459459,40 155.135135,39.4594595 C155.945946,38.7837838 157.027027,38.3783784 158.378378,38.1081081 C159.72973,37.8378378 160.810811,37.5675676 161.621622,37.027027 C162.297297,36.6216216 162.837838,36.6216216 162.972973,37.1621622 C163.108108,37.7027027 163.243243,38.2432432 163.378378,38.6486486 C163.513514,39.0540541 162.972973,39.4594595 161.891892,40 C160.810811,40.5405405 159.864865,40.9459459 158.918919,41.2162162 C157.972973,41.4864865 157.162162,41.7567568 156.486486,42.027027 C155.810811,42.2972973 154.72973,42.5675676 153.378378,42.8378378 C152.027027,43.1081081 150.945946,43.2432432 149.864865,42.972973 C148.918919,42.8378378 148.243243,42.2972973 148.108108,41.6216216 C147.972973,40.9459459 147.702703,40 147.567568,38.9189189 C146.756757,39.4594595 145.945946,40.1351351 145,40.8108108 C144.054054,41.4864865 143.108108,42.027027 142.297297,42.4324324 C141.486486,42.8378378 140.540541,43.3783784 139.594595,43.9189189 C138.648649,44.4594595 137.837838,44.8648649 137.297297,45.2702703 C136.756757,45.5405405 135.540541,45.8108108 133.783784,45.8108108 C132.567568,45.6756757 131.621622,45.1351351 131.081081,44.3243243 C130.675676,43.6486486 130.540541,42.972973 130.540541,42.2972973 C130.810811,41.0810811 131.351351,40 132.027027,39.0540541 C132.837838,38.1081081 133.648649,37.027027 134.594595,35.9459459 C135.540541,34.8648649 136.486486,33.7837838 137.432432,32.972973 C138.378378,32.027027 139.324324,31.2162162 140.27027,30.4054054 C141.216216,29.5945946 142.297297,28.7837838 143.513514,28.1081081 C144.72973,27.4324324 145.810811,27.027027 147.027027,26.7567568 C148.243243,26.4864865 149.054054,26.3513514 149.864865,26.4864865 C150.540541,26.6216216 151.216216,26.8918919 151.756757,27.4324324 C152.297297,27.972973 152.567568,28.5135135 152.567568,29.0540541 C152.567568,29.5945946 152.702703,30.2702703 152.837838,30.8108108 C152.972973,31.4864865 153.378378,31.4864865 153.918919,30.9459459 C154.594595,30.4054054 155.135135,29.7297297 155.540541,29.0540541 C155.945946,28.3783784 156.621622,27.2972973 157.567568,25.8108108 Z M136.216216,41.7567568 C136.486486,42.027027 137.567568,41.8918919 139.189189,41.0810811 C140.810811,40.2702703 142.432432,39.3243243 143.918919,38.3783784 C145.405405,37.4324324 146.486486,36.4864865 147.162162,35.5405405 C147.837838,34.5945946 148.243243,33.6486486 148.378378,32.5675676 C148.513514,31.6216216 148.513514,30.8108108 148.108108,30.5405405 C147.702703,30.1351351 147.162162,30.2702703 146.351351,30.6756757 C145.540541,31.0810811 144.459459,31.7567568 143.378378,32.8378378 C142.162162,33.9189189 141.081081,35 140,35.9459459 C139.054054,37.027027 137.972973,38.1081081 137.162162,39.4594595 C136.216216,40.5405405 135.945946,41.3513514 136.216216,41.7567568 Z' }),
						_react2.default.createElement('path', { d: 'M166.216216,33.2432432 C167.567568,31.4864865 169.054054,30.2702703 170.675676,29.5945946 C172.432432,28.7837838 173.783784,28.1081081 174.72973,27.1621622 C175.810811,26.3513514 176.756757,26.0810811 177.702703,26.3513514 C178.648649,26.6216216 179.054054,27.1621622 179.054054,28.1081081 C179.054054,29.0540541 178.513514,29.8648649 177.432432,30.4054054 C176.351351,31.0810811 175.540541,31.7567568 175.135135,32.4324324 C174.594595,33.1081081 174.189189,33.9189189 173.918919,34.8648649 C173.648649,35.8108108 173.648649,36.6216216 173.918919,37.5675676 C174.189189,38.5135135 174.72973,39.0540541 175.675676,39.3243243 C176.486486,39.5945946 177.837838,39.7297297 179.72973,39.7297297 C181.486486,39.7297297 183.108108,39.4594595 184.459459,39.1891892 C185.810811,38.7837838 187.027027,38.3783784 188.108108,37.7027027 C189.189189,37.027027 190,36.8918919 190.675676,37.027027 L190.945946,38.2432432 C190.540541,39.0540541 189.864865,39.5945946 188.918919,40.1351351 C188.108108,40.6756757 187.162162,41.0810811 186.351351,41.4864865 C185.540541,41.8918919 184.324324,42.1621622 182.702703,42.5675676 C181.081081,42.972973 179.324324,43.2432432 177.297297,43.5135135 L175,43.6486486 C173.243243,43.3783784 171.891892,43.1081081 171.081081,42.5675676 C170.27027,42.027027 169.594595,41.4864865 169.054054,40.6756757 C168.513514,39.8648649 168.243243,39.0540541 168.243243,38.2432432 C168.243243,37.4324324 168.243243,36.6216216 168.513514,35.8108108 C168.783784,35 168.513514,35 167.837838,35.8108108 C167.162162,36.6216216 166.081081,37.4324324 164.864865,38.2432432 C163.648649,38.9189189 162.567568,39.5945946 161.621622,40 C160.810811,40.4054054 160.135135,39.7297297 159.864865,37.972973 C162.837838,36.4864865 165,35 166.216216,33.2432432 Z M192.162162,12.2972973 L191.216216,12.027027 C190.27027,10.9459459 189.594595,10.1351351 189.054054,9.59459459 C189.459459,8.64864865 190.405405,7.7027027 191.756757,6.89189189 L192.702703,6.89189189 C193.513514,7.2972973 194.054054,7.83783784 194.054054,8.37837838 C194.054054,9.05405405 194.594595,9.59459459 195.405405,10.1351351 L195,11.0810811 C194.054054,11.7567568 193.108108,12.1621622 192.162162,12.2972973 Z' }),
						_react2.default.createElement('path', { d: 'M204.189189,27.5675676 C204.324324,27.8378378 204.324324,28.2432432 204.054054,28.6486486 C203.783784,29.0540541 203.513514,29.4594595 203.108108,29.7297297 C202.702703,30.1351351 202.432432,30.5405405 202.297297,31.0810811 C202.162162,31.6216216 201.891892,31.8918919 201.351351,32.027027 C200.810811,32.1621622 200.135135,32.027027 199.324324,31.7567568 C198.648649,31.4864865 197.972973,31.4864865 197.432432,31.4864865 C196.891892,31.6216216 196.351351,32.027027 195.675676,32.7027027 C195,33.5135135 194.459459,34.1891892 193.918919,34.8648649 C193.378378,35.5405405 192.972973,36.2162162 192.837838,36.8918919 C192.567568,37.5675676 192.702703,38.2432432 192.972973,38.7837838 C193.243243,39.3243243 193.783784,39.7297297 194.459459,39.8648649 C195.135135,40 195.945946,40.1351351 197.162162,40 C198.378378,39.8648649 199.594595,39.5945946 200.810811,39.1891892 C202.027027,38.7837838 203.243243,38.3783784 204.459459,37.972973 C205.675676,37.5675676 206.486486,37.1621622 207.027027,36.8918919 C207.567568,36.6216216 208.108108,36.8918919 208.513514,37.7027027 C208.378378,38.5135135 208.108108,39.0540541 207.567568,39.3243243 C207.027027,39.5945946 206.351351,40 205.405405,40.4054054 C204.459459,40.8108108 203.513514,41.2162162 202.567568,41.4864865 C201.621622,41.7567568 200.405405,42.1621622 199.189189,42.4324324 C197.972973,42.7027027 196.621622,42.972973 195.135135,43.1081081 L194.054054,43.1081081 C193.378378,42.972973 192.702703,42.972973 192.027027,42.8378378 C191.351351,42.7027027 190.810811,42.4324324 190.135135,41.8918919 C189.459459,41.3513514 188.918919,40.6756757 188.513514,39.5945946 L188.378378,38.6486486 C188.513514,37.7027027 188.783784,36.6216216 189.324324,35.5405405 C189.864865,34.4594595 190.540541,33.5135135 191.351351,32.4324324 C192.162162,31.4864865 193.108108,30.5405405 194.189189,29.8648649 C195.27027,29.1891892 196.216216,28.6486486 197.027027,28.2432432 C197.837838,27.972973 198.378378,27.5675676 198.648649,27.2972973 C198.918919,27.027027 199.459459,26.7567568 200.135135,26.4864865 C200.810811,26.2162162 201.486486,26.0810811 202.162162,26.0810811 C202.702703,26.0810811 203.108108,26.2162162 203.378378,26.4864865 C203.783784,26.8918919 204.054054,27.1621622 204.189189,27.5675676 Z' }),
						_react2.default.createElement('path', { d: 'M211.216216,33.2432432 C212.567568,31.4864865 214.054054,30.2702703 215.675676,29.5945946 C217.432432,28.7837838 218.783784,28.1081081 219.72973,27.1621622 C220.810811,26.3513514 221.756757,26.0810811 222.702703,26.3513514 C223.648649,26.6216216 224.054054,27.1621622 224.054054,28.1081081 C224.054054,29.0540541 223.513514,29.8648649 222.432432,30.4054054 C221.351351,31.0810811 220.540541,31.7567568 220.135135,32.4324324 C219.594595,33.1081081 219.189189,33.9189189 218.918919,34.8648649 C218.648649,35.8108108 218.648649,36.6216216 218.918919,37.5675676 C219.189189,38.5135135 219.72973,39.0540541 220.675676,39.3243243 C221.486486,39.5945946 222.837838,39.7297297 224.72973,39.7297297 C226.486486,39.7297297 228.108108,39.4594595 229.459459,39.1891892 C230.810811,38.7837838 232.027027,38.3783784 233.108108,37.7027027 C234.189189,37.027027 235,36.8918919 235.675676,37.027027 L235.945946,38.2432432 C235.540541,39.0540541 234.864865,39.5945946 233.918919,40.1351351 C233.108108,40.6756757 232.162162,41.0810811 231.351351,41.4864865 C230.540541,41.8918919 229.324324,42.1621622 227.702703,42.5675676 C226.081081,42.972973 224.324324,43.2432432 222.297297,43.5135135 L220,43.6486486 C218.243243,43.3783784 216.891892,43.1081081 216.081081,42.5675676 C215.27027,42.027027 214.594595,41.4864865 214.054054,40.6756757 C213.513514,39.8648649 213.243243,39.0540541 213.243243,38.2432432 C213.243243,37.4324324 213.243243,36.6216216 213.513514,35.8108108 C213.783784,35 213.513514,35 212.837838,35.8108108 C212.162162,36.6216216 211.081081,37.4324324 209.864865,38.2432432 C208.648649,38.9189189 207.567568,39.5945946 206.621622,40 C205.810811,40.4054054 205.135135,39.7297297 204.864865,37.972973 C207.837838,36.4864865 209.864865,35 211.216216,33.2432432 Z M237.027027,12.2972973 L236.081081,12.027027 C235.135135,10.9459459 234.459459,10.1351351 233.918919,9.59459459 C234.324324,8.64864865 235.27027,7.7027027 236.621622,6.89189189 L237.567568,6.89189189 C238.378378,7.2972973 238.918919,7.83783784 238.918919,8.37837838 C238.918919,9.05405405 239.459459,9.59459459 240.27027,10.1351351 L239.864865,11.0810811 C238.918919,11.7567568 238.108108,12.1621622 237.027027,12.2972973 Z' }),
						_react2.default.createElement('path', { d: 'M238.378378,38.1081081 C238.918919,38.9189189 239.594595,39.4594595 240.540541,39.4594595 C241.351351,39.4594595 242.162162,39.3243243 242.972973,38.7837838 C243.783784,38.2432432 244.594595,37.8378378 245.540541,37.4324324 C246.486486,37.027027 247.567568,36.4864865 248.513514,35.8108108 C249.459459,35.1351351 250,34.3243243 250,33.3783784 C250,32.4324324 249.594595,31.6216216 248.918919,31.0810811 C248.108108,30.5405405 247.837838,29.8648649 247.972973,28.9189189 C248.108108,28.1081081 248.513514,27.4324324 249.189189,27.1621622 C249.864865,26.8918919 250.945946,26.6216216 252.432432,26.6216216 C254.054054,26.8918919 255,27.7027027 255.405405,29.0540541 C255.810811,30.2702703 255.675676,31.4864865 255.27027,32.5675676 C254.864865,33.6486486 255.405405,34.5945946 256.756757,35.5405405 C258.108108,36.4864865 259.459459,36.7567568 260.540541,36.3513514 C261.621622,36.0810811 262.297297,36.3513514 262.432432,37.4324324 C262.297297,38.5135135 262.027027,39.1891892 261.621622,39.3243243 C261.216216,39.5945946 260.405405,39.7297297 259.189189,39.8648649 C257.972973,40 256.486486,39.5945946 254.72973,38.7837838 C252.972973,37.8378378 251.756757,37.7027027 250.945946,38.2432432 C250.135135,38.7837838 249.054054,39.5945946 247.567568,40.4054054 C246.081081,41.3513514 244.594595,42.027027 243.243243,42.5675676 C241.756757,43.1081081 240.135135,43.3783784 238.378378,43.3783784 C236.621622,42.8378378 235.405405,41.8918919 234.72973,40.8108108 C234.054054,39.5945946 233.648649,38.3783784 233.648649,36.8918919 C233.783784,35.9459459 234.594595,34.8648649 235.810811,33.6486486 C237.162162,32.4324324 238.378378,31.4864865 239.594595,30.6756757 C240.810811,29.8648649 242.027027,29.3243243 243.243243,28.9189189 C244.459459,28.5135135 245.27027,28.6486486 245.810811,29.0540541 C246.351351,29.5945946 246.621622,30.1351351 246.756757,30.8108108 C246.891892,31.4864865 246.891892,32.027027 246.486486,32.4324324 C246.216216,32.8378378 245.675676,33.1081081 245.135135,33.2432432 C244.594595,33.3783784 243.783784,33.5135135 242.702703,33.7837838 C241.621622,34.0540541 240.540541,34.5945946 239.324324,35.5405405 C238.108108,36.3513514 237.837838,37.1621622 238.378378,38.1081081 Z M261.351351,9.32432432 C260.540541,10.1351351 259.864865,10.9459459 259.324324,11.3513514 C258.783784,11.8918919 258.108108,12.1621622 257.702703,12.2972973 C257.162162,12.4324324 256.756757,12.7027027 256.486486,12.972973 C256.216216,13.2432432 255.945946,13.3783784 255.540541,13.6486486 C255.135135,13.9189189 254.72973,13.9189189 254.189189,13.9189189 C253.648649,13.7837838 253.243243,13.7837838 253.108108,13.6486486 C252.972973,13.5135135 252.837838,13.3783784 252.837838,12.8378378 C252.972973,12.2972973 253.108108,12.027027 253.378378,11.7567568 C253.648649,11.4864865 254.054054,11.3513514 254.594595,11.2162162 C255.135135,11.0810811 255.810811,10.9459459 256.621622,10.5405405 C257.432432,10.1351351 258.243243,9.59459459 259.054054,8.78378378 C259.864865,7.97297297 260.540541,7.43243243 261.081081,6.89189189 C261.756757,6.48648649 262.027027,6.08108108 262.297297,5.67567568 C262.432432,5.27027027 262.837838,5 263.513514,5 C264.054054,5.13513514 264.459459,5.27027027 264.594595,5.40540541 C264.72973,5.54054054 264.864865,5.67567568 264.864865,5.94594595 C264.864865,6.08108108 264.72973,6.08108108 264.594595,6.21621622 C264.459459,6.35135135 264.324324,6.48648649 264.189189,6.89189189 C264.054054,7.16216216 263.783784,7.56756757 263.243243,7.7027027 C262.837838,7.83783784 262.162162,8.37837838 261.351351,9.32432432 Z' }),
						_react2.default.createElement('path', { d: 'M259.72973 36.3513514C260.405405 36.0810811 261.486486 35.2702703 262.972973 33.9189189 264.459459 32.7027027 266.081081 31.4864865 268.108108 30.5405405 270.135135 29.5945946 271.621622 28.7837838 272.702703 28.2432432 273.783784 27.7027027 275 27.4324324 276.351351 27.4324324 277.567568 27.8378378 278.243243 28.5135135 278.513514 29.5945946 278.783784 30.5405405 278.648649 31.6216216 278.243243 32.7027027 277.837838 33.7837838 276.351351 35.6756757 273.783784 38.3783784 277.837838 35.9459459 280.675676 34.3243243 282.162162 33.5135135 283.648649 32.5675676 285 32.027027 285.945946 31.8918919 286.891892 31.6216216 287.702703 32.027027 288.378378 32.7027027 289.054054 33.5135135 289.054054 34.5945946 288.378378 36.2162162 287.702703 37.7027027 287.432432 38.9189189 287.702703 39.5945946 287.972973 40.4054054 289.594595 40.2702703 292.837838 39.3243243 295.945946 38.3783784 298.378378 37.5675676 300 36.8918919 299.864865 38.2432432 299.594595 39.3243243 298.918919 39.8648649 298.243243 40.4054054 296.351351 41.2162162 293.108108 42.2972973 289.864865 43.3783784 287.432432 43.6486486 285.810811 43.2432432 284.189189 42.8378378 283.243243 42.1621622 282.837838 41.2162162 282.432432 40.2702703 282.297297 39.3243243 282.702703 38.2432432 282.972973 37.1621622 282.027027 37.4324324 279.864865 39.0540541 277.702703 40.6756757 275.810811 41.8918919 274.189189 42.7027027 272.567568 43.6486486 271.351351 44.1891892 270.540541 44.5945946 269.459459 44.5945946 268.648649 44.4594595 267.972973 44.0540541 267.297297 43.6486486 267.027027 42.972973 266.891892 42.027027 266.756757 41.0810811 267.297297 40.1351351 268.243243 39.3243243 269.189189 38.5135135 270.27027 37.7027027 271.216216 36.7567568 272.162162 35.8108108 272.702703 35 272.972973 34.0540541 273.243243 33.1081081 272.702703 32.8378378 271.351351 33.2432432 270 33.5135135 268.243243 34.5945946 266.081081 36.0810811 263.783784 37.7027027 262.297297 38.6486486 261.621622 39.0540541 260.945946 39.4594595 259.864865 39.7297297 258.648649 39.8648649 258.513514 37.7027027 259.054054 36.6216216 259.72973 36.3513514zM140.540541 50.2702703L137.432432 50.5405405C133.783784 51.8918919 130.810811 53.2432432 128.513514 54.7297297 126.081081 56.2162162 123.513514 57.8378378 120.675676 59.7297297 117.837838 61.6216216 114.864865 63.9189189 111.891892 66.4864865 108.918919 69.0540541 105.540541 72.027027 102.027027 75.5405405 98.3783784 79.0540541 95.1351351 82.1621622 92.2972973 85 89.4594595 87.7027027 86.7567568 90.1351351 84.5945946 92.027027 82.2972973 93.9189189 80.2702703 95.4054054 78.3783784 96.4864865 76.4864865 97.5675676 75.1351351 98.1081081 74.1891892 98.1081081 73.2432432 98.1081081 72.7027027 97.5675676 72.4324324 96.6216216 72.1621622 95.5405405 72.1621622 94.7297297 72.5675676 93.9189189 72.972973 93.1081081 73.5135135 91.7567568 74.4594595 90 75.2702703 88.2432432 76.6216216 86.0810811 78.5135135 83.5135135 80.2702703 80.9459459 82.1621622 78.3783784 84.1891892 75.5405405 86.2162162 72.7027027 87.972973 70.1351351 89.4594595 67.7027027 90.9459459 65.2702703 91.7567568 63.3783784 91.7567568 61.8918919 91.7567568 60.4054054 91.4864865 59.3243243 90.8108108 58.7837838 90.1351351 58.2432432 89.4594595 57.972973 88.6486486 57.972973 87.8378378 57.972973 86.6216216 58.2432432 85 58.6486486 83.3783784 59.1891892 81.0810811 60.1351351 78.1081081 61.7567568 75.1351351 63.3783784 72.5675676 65 70.5405405 66.6216216 68.9189189 67.7027027 67.5675676 68.9189189 66.2162162 70.4054054 68.3783784 70 80.4054054 65.4054054 81.7567568 65 83.1081081 64.5945946 83.7837838 64.7297297 84.0540541 65.2702703 84.3243243 65.8108108 83.7837838 67.1621622 82.5675676 69.0540541 81.3513514 70.9459459 80 72.8378378 78.5135135 74.7297297 77.027027 76.4864865 75.5405405 78.6486486 73.9189189 81.2162162 72.2972973 83.6486486 70.8108108 86.2162162 69.4594595 88.9189189 67.972973 91.4864865 67.4324324 94.0540541 67.5675676 96.4864865 67.7027027 98.9189189 68.2432432 100.540541 69.1891892 101.486486 70.1351351 102.432432 71.2162162 102.972973 72.7027027 103.243243 75.2702703 102.972973 77.7027027 102.162162 79.8648649 100.810811 82.027027 99.4594595 84.7297297 97.2972973 88.1081081 94.5945946 91.4864865 91.7567568 94.5945946 89.0540541 97.2972973 86.2162162 100.135135 83.5135135 102.972973 80.6756757 105.810811 78.1081081 108.783784 75.4054054 111.486486 72.972973 114.189189 70.5405405 116.891892 68.2432432 119.459459 66.0810811 121.891892 64.3243243 124.324324 62.5675676 126.621622 61.0810811 128.918919 59.7297297 131.081081 58.5135135 133.108108 57.4324324 134.864865 56.6216216 136.621622 55.8108108 137.972973 55.5405405 138.783784 55.9459459 139.594595 56.3513514 140.135135 57.027027 140.27027 58.1081081 140.405405 59.1891892 140 60.4054054 139.054054 61.7567568 138.108108 63.1081081 137.027027 64.0540541 135.945946 64.5945946 134.864865 65.1351351 134.054054 65.8108108 133.648649 66.7567568 133.243243 67.7027027 133.108108 68.3783784 133.513514 68.7837838 133.918919 69.1891892 134.72973 69.3243243 136.081081 68.9189189 137.432432 68.6486486 139.054054 67.7027027 140.945946 66.3513514 142.837838 64.8648649 144.189189 62.7027027 145.135135 59.8648649L145.27027 55.2702703C144.054054 52.4324324 142.567568 50.9459459 140.540541 50.2702703zM107.162162 93.9189189C107.702703 94.8648649 108.513514 95.2702703 109.324324 95.2702703 110.135135 95.2702703 111.081081 95 111.756757 94.5945946 112.567568 94.0540541 113.513514 93.6486486 114.459459 93.1081081 115.540541 92.7027027 116.486486 92.027027 117.567568 91.3513514 118.513514 90.6756757 119.054054 89.8648649 119.054054 88.7837838 119.054054 87.7027027 118.648649 86.8918919 117.837838 86.3513514 117.027027 85.8108108 116.756757 85 116.891892 84.1891892 117.027027 83.2432432 117.432432 82.7027027 118.108108 82.2972973 118.783784 82.027027 119.864865 81.7567568 121.486486 81.7567568 123.108108 82.027027 124.189189 82.972973 124.594595 84.1891892 125 85.5405405 125 86.7567568 124.459459 87.8378378 124.054054 88.9189189 124.594595 90 126.081081 90.9459459 127.567568 91.8918919 128.918919 92.1621622 130 91.8918919 131.216216 91.6216216 131.756757 91.8918919 132.027027 92.972973 131.891892 94.0540541 131.486486 94.7297297 131.081081 95 130.675676 95.2702703 129.864865 95.4054054 128.513514 95.6756757 127.162162 95.8108108 125.675676 95.4054054 123.918919 94.4594595 122.162162 93.5135135 120.810811 93.2432432 120 93.9189189 119.189189 94.4594595 118.108108 95.2702703 116.486486 96.2162162 115 97.1621622 113.378378 97.972973 111.891892 98.5135135 110.405405 99.0540541 108.648649 99.3243243 106.756757 99.3243243 105 98.7837838 103.783784 97.8378378 102.972973 96.6216216 102.297297 95.4054054 101.891892 94.0540541 101.891892 92.5675676 102.027027 91.4864865 102.837838 90.4054054 104.189189 89.1891892 105.540541 87.972973 106.891892 86.8918919 108.108108 86.0810811 109.324324 85.2702703 110.540541 84.5945946 111.891892 84.1891892 113.108108 83.7837838 114.054054 83.9189189 114.594595 84.3243243 115.135135 84.8648649 115.540541 85.4054054 115.675676 86.2162162 115.810811 86.8918919 115.810811 87.5675676 115.405405 87.972973 115.135135 88.3783784 114.594595 88.6486486 114.054054 88.9189189 113.378378 89.0540541 112.567568 89.3243243 111.486486 89.4594595 110.405405 89.7297297 109.324324 90.2702703 107.972973 91.2162162 106.891892 92.1621622 106.621622 93.1081081 107.162162 93.9189189z' }),
						_react2.default.createElement('path', { d: 'M127.567568,93.6486486 C130,92.2972973 132.567568,90.2702703 135.135135,87.4324324 C137.702703,84.5945946 139.72973,82.972973 141.216216,82.4324324 C142.702703,81.8918919 144.189189,81.6216216 145.945946,81.6216216 C146.621622,81.6216216 147.162162,81.7567568 147.702703,82.027027 C148.243243,82.2972973 148.513514,82.7027027 148.648649,83.3783784 C148.783784,84.0540541 148.783784,84.5945946 148.648649,85.4054054 C148.513514,86.0810811 148.108108,87.027027 147.297297,88.1081081 C146.621622,89.1891892 145.675676,90 144.72973,90.8108108 C143.648649,91.4864865 142.972973,92.1621622 142.567568,92.8378378 C142.162162,93.3783784 142.162162,94.0540541 142.432432,94.5945946 C142.702703,95.1351351 144.054054,95.2702703 146.216216,94.7297297 C148.513514,94.3243243 150.135135,93.7837838 151.216216,93.5135135 C152.297297,93.1081081 153.378378,92.7027027 154.594595,92.1621622 L155.27027,94.5945946 C152.567568,95.8108108 150.135135,96.8918919 148.108108,97.8378378 C145.945946,98.7837838 143.783784,99.3243243 141.486486,99.5945946 C140,99.5945946 138.783784,99.5945946 137.972973,99.4594595 C137.162162,99.3243243 136.351351,99.0540541 135.675676,98.3783784 C135,97.8378378 134.594595,97.1621622 134.459459,96.3513514 C134.324324,95.5405405 134.459459,94.7297297 134.864865,93.9189189 C135.27027,93.1081081 135.945946,92.4324324 136.891892,91.7567568 C137.837838,91.0810811 138.783784,90.5405405 139.72973,90 C140.675676,89.5945946 141.621622,88.9189189 142.297297,88.2432432 C142.972973,87.4324324 143.243243,86.8918919 142.837838,86.4864865 C142.432432,86.0810811 141.891892,85.9459459 141.216216,86.0810811 C140.540541,86.2162162 138.918919,87.7027027 136.216216,90.2702703 C133.648649,92.8378378 130.945946,94.7297297 128.378378,95.8108108 L127.567568,93.6486486 Z' }),
						_react2.default.createElement('path', { d: 'M155.27027,88.9189189 C157.162162,87.027027 159.054054,85.6756757 160.675676,84.7297297 C162.297297,83.7837838 163.648649,83.1081081 164.594595,82.7027027 C165.540541,82.2972973 166.891892,82.027027 168.513514,81.7567568 C170.675676,81.8918919 172.162162,82.1621622 172.972973,82.5675676 C173.783784,83.1081081 174.189189,83.6486486 174.459459,84.3243243 C174.72973,85 174.72973,85.6756757 174.72973,86.4864865 C174.72973,87.2972973 175,87.5675676 175.810811,87.4324324 C176.621622,87.2972973 177.027027,87.5675676 177.027027,88.5135135 C177.027027,89.4594595 176.756757,90.4054054 175.945946,91.3513514 C175.135135,92.2972973 174.594595,92.972973 174.189189,93.3783784 C173.783784,93.7837838 173.648649,94.1891892 173.783784,94.7297297 C173.918919,95.2702703 174.459459,95.5405405 175.27027,95.8108108 C176.081081,96.0810811 177.162162,95.9459459 178.378378,95.6756757 C179.594595,95.4054054 180.675676,94.8648649 181.486486,94.3243243 C182.432432,93.7837838 183.243243,93.3783784 183.918919,93.3783784 C184.594595,93.3783784 185.135135,93.6486486 185.27027,94.1891892 C185.27027,95.2702703 184.864865,96.2162162 184.054054,96.8918919 C183.243243,97.5675676 182.162162,98.1081081 180.675676,98.6486486 C179.189189,99.0540541 178.108108,99.3243243 177.162162,99.3243243 C176.216216,99.3243243 175.675676,99.3243243 175.540541,99.3243243 C173.513514,99.3243243 171.891892,99.0540541 170.810811,98.3783784 C169.594595,97.7027027 168.648649,96.8918919 168.108108,95.8108108 C166.621622,96.2162162 165.27027,96.7567568 164.054054,97.4324324 C162.837838,98.1081081 161.756757,98.6486486 160.540541,98.9189189 C159.459459,99.1891892 158.108108,99.4594595 156.756757,99.4594595 C155.810811,99.4594595 154.864865,99.0540541 153.783784,98.1081081 C152.837838,97.2972973 152.297297,95.5405405 152.297297,93.2432432 C152.432432,92.1621622 153.378378,90.8108108 155.27027,88.9189189 Z M160.540541,89.7297297 C159.189189,90.8108108 158.243243,91.8918919 157.972973,92.8378378 C157.567568,93.7837838 157.702703,94.4594595 158.243243,94.8648649 C158.783784,95.4054054 159.72973,95.4054054 161.081081,95 C162.432432,94.5945946 163.648649,94.0540541 165.135135,93.2432432 C166.486486,92.5675676 167.702703,91.7567568 168.918919,90.9459459 C170,90.1351351 170.675676,89.4594595 170.810811,88.7837838 C170.945946,88.1081081 170.945946,87.4324324 170.675676,86.6216216 C170.405405,85.9459459 169.594595,85.5405405 168.513514,85.6756757 C167.297297,85.8108108 166.081081,86.2162162 164.72973,86.8918919 C163.378378,87.5675676 161.891892,88.5135135 160.540541,89.7297297 Z M181.351351,67.027027 C180.540541,67.972973 179.864865,68.6486486 179.189189,69.1891892 C178.513514,69.7297297 177.972973,70 177.432432,70.2702703 C176.891892,70.5405405 176.486486,70.6756757 176.216216,70.9459459 C175.945946,71.2162162 175.675676,71.3513514 175.27027,71.6216216 C174.864865,71.8918919 174.324324,71.8918919 173.783784,71.8918919 C173.243243,71.7567568 172.837838,71.6216216 172.702703,71.6216216 C172.567568,71.4864865 172.432432,71.2162162 172.432432,70.8108108 C172.567568,70.2702703 172.702703,69.8648649 172.972973,69.5945946 C173.243243,69.3243243 173.648649,69.0540541 174.189189,69.0540541 C174.72973,68.9189189 175.405405,68.6486486 176.351351,68.2432432 C177.297297,67.8378378 178.108108,67.1621622 178.918919,66.3513514 C179.72973,65.5405405 180.405405,64.8648649 181.081081,64.4594595 C181.756757,64.0540541 182.162162,63.5135135 182.297297,63.1081081 C182.432432,62.7027027 182.972973,62.4324324 183.648649,62.4324324 C184.324324,62.5675676 184.594595,62.7027027 184.72973,62.8378378 C184.864865,62.972973 185,63.1081081 185.135135,63.3783784 C185.135135,63.5135135 185,63.5135135 184.864865,63.6486486 C184.72973,63.7837838 184.594595,64.0540541 184.324324,64.3243243 C184.189189,64.5945946 183.918919,65 183.378378,65.2702703 C182.702703,65.5405405 182.162162,66.0810811 181.351351,67.027027 Z' }),
						_react2.default.createElement('path', { d: 'M156.351351,123.783784 C160.405405,119.324324 163.513514,116.351351 165.540541,114.72973 C167.702703,113.108108 170,111.486486 172.297297,109.864865 C174.594595,108.243243 177.297297,106.621622 180.27027,105 C183.243243,103.378378 185.675676,102.027027 187.837838,100.810811 C190,99.7297297 192.297297,98.6486486 194.72973,97.7027027 C192.432432,97.5675676 190.540541,97.5675676 189.054054,97.5675676 C187.567568,97.5675676 186.486486,97.027027 185.675676,96.0810811 C185,95.1351351 184.594595,94.0540541 184.594595,92.972973 C184.594595,91.7567568 185.405405,90.5405405 187.027027,89.1891892 C188.513514,87.8378378 190.135135,86.7567568 191.756757,85.9459459 C193.378378,85.1351351 195.405405,84.0540541 197.972973,82.8378378 L199.189189,82.8378378 C200.675676,83.5135135 201.756757,84.4594595 202.297297,85.5405405 C202.837838,86.6216216 203.108108,87.7027027 203.108108,88.6486486 C203.108108,89.5945946 202.837838,90.5405405 202.297297,91.4864865 C201.891892,92.2972973 201.756757,92.972973 202.162162,93.3783784 C202.567568,93.7837838 203.513514,93.7837838 205.27027,93.3783784 C207.027027,92.972973 208.783784,92.2972973 210.540541,91.3513514 C212.297297,90.4054054 214.324324,90.4054054 216.486486,91.3513514 C213.243243,93.5135135 210.945946,94.8648649 209.459459,95.4054054 C207.972973,95.9459459 206.081081,96.4864865 203.918919,97.2972973 C201.756757,98.1081081 200,98.9189189 198.648649,99.7297297 C197.297297,100.540541 195.675676,101.891892 193.783784,103.783784 C191.891892,105.675676 189.72973,108.243243 187.297297,111.486486 C185,114.72973 182.567568,117.837838 180.27027,120.540541 C177.972973,123.378378 176.081081,125.675676 174.594595,127.432432 C173.108108,129.189189 171.216216,131.081081 169.054054,133.243243 C166.756757,135.27027 165,136.621622 163.783784,137.162162 C162.567568,137.702703 161.351351,138.108108 160.135135,138.243243 L158.918919,138.243243 C156.756757,137.567568 155.27027,136.756757 154.459459,135.675676 C153.648649,134.594595 153.243243,133.108108 152.972973,131.216216 C153.378378,128.783784 154.459459,126.486486 156.351351,123.783784 Z M157.702703,129.459459 C157.027027,130.945946 156.756757,132.162162 156.891892,133.378378 C157.162162,134.594595 157.837838,135 158.918919,134.72973 C160.135135,134.459459 161.216216,134.054054 162.432432,133.378378 C163.648649,132.702703 165.27027,131.351351 167.432432,129.324324 C169.594595,127.297297 171.621622,125.135135 173.648649,122.567568 C175.675676,120 178.108108,116.891892 180.945946,113.243243 C183.783784,109.594595 186.621622,105.945946 189.459459,102.432432 C187.162162,103.783784 184.72973,105.135135 182.162162,106.756757 C179.594595,108.243243 177.027027,110 174.459459,111.891892 C171.891892,113.783784 169.189189,116.081081 166.621622,118.648649 C164.054054,121.351351 162.027027,123.378378 160.675676,125 C159.324324,126.621622 158.513514,128.108108 157.702703,129.459459 Z M190.810811,94.3243243 C191.621622,95 192.837838,95.1351351 194.189189,94.8648649 C195.540541,94.5945946 196.621622,93.9189189 197.432432,92.8378378 C198.243243,91.7567568 198.513514,90.5405405 198.378378,88.7837838 C198.108108,87.1621622 197.432432,86.4864865 196.351351,86.8918919 C195.135135,87.2972973 194.054054,87.8378378 193.108108,88.7837838 C192.027027,89.5945946 191.216216,90.6756757 190.540541,91.7567568 C189.864865,92.7027027 189.864865,93.6486486 190.810811,94.3243243 Z' }),
						_react2.default.createElement('path', { d: 'M214.864865,88.9189189 C216.216216,87.1621622 217.837838,85.8108108 219.594595,85.1351351 C221.351351,84.3243243 222.837838,83.5135135 223.783784,82.7027027 C224.864865,81.8918919 225.945946,81.4864865 226.891892,81.7567568 C227.837838,82.027027 228.378378,82.7027027 228.378378,83.6486486 C228.378378,84.5945946 227.837838,85.4054054 226.756757,86.0810811 C225.675676,86.7567568 224.864865,87.4324324 224.324324,88.2432432 C223.783784,89.0540541 223.378378,89.8648649 222.972973,90.8108108 C222.702703,91.7567568 222.567568,92.7027027 222.972973,93.5135135 C223.243243,94.4594595 223.918919,95 224.72973,95.2702703 C225.675676,95.5405405 227.027027,95.6756757 228.918919,95.6756757 C230.810811,95.6756757 232.432432,95.4054054 233.918919,95.1351351 C235.405405,94.7297297 236.621622,94.3243243 237.702703,93.6486486 C238.783784,92.972973 239.72973,92.8378378 240.405405,92.972973 L240.675676,94.3243243 C240.135135,95.1351351 239.459459,95.8108108 238.648649,96.3513514 C237.702703,96.8918919 236.891892,97.2972973 235.945946,97.7027027 C235,98.1081081 233.783784,98.3783784 232.162162,98.7837838 C230.540541,99.1891892 228.648649,99.4594595 226.486486,99.7297297 L224.189189,99.8648649 C222.297297,99.5945946 220.945946,99.3243243 220.135135,98.7837838 C219.324324,98.2432432 218.648649,97.5675676 218.108108,96.7567568 C217.567568,95.9459459 217.297297,95 217.297297,94.1891892 C217.297297,93.3783784 217.297297,92.4324324 217.567568,91.6216216 C217.837838,90.8108108 217.567568,90.8108108 216.756757,91.7567568 C215.945946,92.7027027 215,93.5135135 213.648649,94.1891892 C212.297297,95 211.216216,95.5405405 210.27027,95.9459459 C209.324324,96.3513514 208.783784,95.6756757 208.378378,93.7837838 C211.351351,92.2972973 213.513514,90.6756757 214.864865,88.9189189 Z M241.756757,67.1621622 L240.810811,66.8918919 C239.864865,65.8108108 239.054054,64.8648649 238.513514,64.4594595 C239.054054,63.3783784 239.864865,62.5675676 241.216216,61.7567568 L242.297297,61.7567568 C243.243243,62.1621622 243.648649,62.7027027 243.648649,63.3783784 C243.648649,64.0540541 244.189189,64.7297297 245,65.2702703 L244.594595,66.2162162 C243.918919,66.4864865 242.837838,66.8918919 241.756757,67.1621622 Z' }),
						_react2.default.createElement('path', { d: 'M237.702703,92.1621622 C238.378378,91.8918919 239.594595,90.9459459 241.081081,89.7297297 C242.567568,88.3783784 244.324324,87.2972973 246.486486,86.2162162 C248.513514,85.1351351 250.135135,84.3243243 251.351351,83.7837838 C252.567568,83.2432432 253.783784,82.972973 255.135135,82.8378378 C256.351351,83.2432432 257.027027,84.0540541 257.297297,85 C257.567568,86.0810811 257.432432,87.1621622 257.027027,88.2432432 C256.621622,89.4594595 255,91.3513514 252.432432,94.1891892 C256.621622,91.7567568 259.594595,90 261.216216,89.0540541 C262.837838,88.1081081 264.054054,87.5675676 265.135135,87.2972973 C266.081081,87.027027 266.891892,87.4324324 267.702703,88.2432432 C268.378378,89.0540541 268.378378,90.2702703 267.702703,91.8918919 C267.027027,93.5135135 266.756757,94.5945946 267.027027,95.4054054 C267.297297,96.2162162 269.054054,96.0810811 272.297297,95.1351351 C275.540541,94.1891892 278.108108,93.3783784 279.72973,92.5675676 C279.594595,94.0540541 279.189189,95 278.648649,95.6756757 C277.972973,96.3513514 275.945946,97.1621622 272.567568,98.2432432 C269.189189,99.3243243 266.621622,99.5945946 265,99.1891892 C263.378378,98.7837838 262.297297,97.972973 261.891892,97.027027 C261.486486,96.0810811 261.351351,95 261.756757,93.9189189 C262.027027,92.8378378 261.081081,93.1081081 258.783784,94.7297297 C256.486486,96.3513514 254.594595,97.5675676 252.837838,98.5135135 C251.081081,99.4594595 249.864865,100.135135 249.054054,100.405405 C247.972973,100.405405 247.027027,100.27027 246.351351,99.8648649 C245.675676,99.4594595 245.405405,98.7837838 245.27027,97.8378378 C245.135135,96.8918919 245.675676,95.9459459 246.756757,95.1351351 C247.837838,94.3243243 248.783784,93.3783784 249.864865,92.4324324 C250.810811,91.4864865 251.486486,90.5405405 251.621622,89.5945946 C251.891892,88.6486486 251.216216,88.3783784 249.864865,88.6486486 C248.513514,89.0540541 246.621622,90 244.324324,91.6216216 C242.027027,93.2432432 240.405405,94.3243243 239.72973,94.7297297 C238.918919,95.1351351 237.972973,95.4054054 236.621622,95.5405405 C236.486486,93.5135135 237.027027,92.4324324 237.702703,92.1621622 Z' }),
						_react2.default.createElement('path', { d: 'M275.540541 89.5945946C276.081081 88.5135135 276.756757 87.4324324 277.837838 86.3513514 278.918919 85.2702703 280 84.3243243 281.081081 83.5135135 282.162162 82.7027027 283.243243 82.1621622 284.459459 81.8918919L285.675676 81.8918919C286.756757 81.8918919 287.837838 82.2972973 288.648649 82.8378378 289.459459 83.3783784 289.864865 84.4594595 289.72973 85.9459459 289.594595 87.4324324 288.918919 88.7837838 287.567568 89.8648649 286.216216 90.9459459 284.72973 91.7567568 282.972973 92.1621622 281.216216 92.7027027 280.405405 93.1081081 280.27027 93.5135135 280.135135 93.9189189 280.405405 94.3243243 281.081081 94.7297297 281.756757 95.1351351 283.243243 95.5405405 285.675676 95.6756757 288.108108 95.8108108 290 95.6756757 291.486486 95.2702703 292.972973 94.8648649 294.189189 94.4594595 295.135135 94.0540541 296.081081 93.6486486 296.756757 93.3783784 297.297297 93.1081081 297.837838 92.972973 298.243243 93.2432432 298.648649 93.9189189 297.702703 95.2702703 296.621622 96.3513514 295.540541 96.8918919 294.459459 97.5675676 292.972973 98.1081081 291.216216 98.6486486 289.459459 99.1891892 287.432432 99.4594595 284.864865 99.5945946L283.378378 99.5945946C280.675676 99.3243243 278.918919 98.9189189 277.972973 98.5135135 277.027027 98.1081081 276.351351 97.5675676 275.810811 96.8918919 275.27027 96.2162162 274.864865 95.2702703 274.72973 94.0540541 274.864865 92.027027 275 90.5405405 275.540541 89.5945946zM279.72973 90.2702703C282.027027 89.5945946 283.513514 88.7837838 284.189189 88.1081081 285 87.4324324 285.27027 86.8918919 285.135135 86.2162162 285 85.6756757 284.459459 85.6756757 283.243243 86.2162162 282.162162 86.7567568 281.351351 87.4324324 280.945946 87.972973 280.540541 88.9189189 280.135135 89.5945946 279.72973 90.2702703zM29.7297297 94.5945946C29.4594595 94.8648649 29.1891892 95 29.0540541 95.1351351 28.7837838 95.4054054 28.7837838 95.8108108 29.1891892 95.9459459 29.8648649 96.2162162 29.8648649 96.6216216 29.7297297 97.1621622 29.7297297 97.2972973 29.7297297 97.5675676 29.7297297 97.7027027 30 99.3243243 29.3243243 100.540541 28.1081081 101.621622 27.972973 101.756757 27.5675676 102.027027 27.5675676 102.162162 27.5675676 103.378378 26.4864865 103.918919 25.8108108 104.72973 25.4054054 105.27027 25.2702703 105.810811 25.6756757 106.351351 25.8108108 106.621622 25.9459459 106.756757 26.0810811 107.027027 26.2162162 107.432432 26.2162162 107.837838 25.8108108 107.972973 25.4054054 108.108108 25.2702703 107.837838 25 107.567568 24.3243243 106.621622 22.972973 106.621622 22.4324324 107.702703 22.2972973 108.108108 22.1621622 108.378378 22.7027027 108.648649 23.1081081 108.783784 23.3783784 109.189189 23.1081081 109.594595 22.8378378 110 22.5675676 109.594595 22.2972973 109.594595 22.1621622 109.594595 22.027027 109.459459 22.027027 109.594595 22.027027 109.72973 22.027027 109.864865 22.027027 109.864865 22.027027 110 22.1621622 110 22.2972973 110.135135 22.5675676 110.27027 22.8378378 110.540541 22.7027027 110.810811 22.7027027 110.945946 22.5675676 110.945946 22.4324324 110.945946 22.027027 110.945946 21.8918919 110.675676 21.7567568 110.405405 21.4864865 109.864865 21.3513514 109.324324 21.2162162 108.783784 21.0810811 108.243243 20.6756757 107.837838 20.1351351 107.972973 19.5945946 108.108108 19.3243243 108.378378 19.3243243 108.918919 19.3243243 109.324324 19.3243243 109.72973 18.7837838 109.864865 18.2432432 110 18.1081081 109.594595 17.972973 109.189189 17.5675676 108.513514 15.4054054 107.972973 14.7297297 108.243243 14.3243243 108.378378 14.5945946 108.918919 14.4594595 109.189189 14.3243243 109.459459 14.3243243 110 13.7837838 109.864865 13.2432432 109.864865 13.2432432 109.459459 13.2432432 109.054054 13.2432432 108.513514 13.3783784 107.972973 12.7027027 107.702703 11.8918919 107.297297 10.9459459 106.891892 10 107.567568 9.72972973 107.837838 9.45945946 108.108108 9.05405405 107.837838 8.64864865 107.567568 8.64864865 107.162162 8.78378378 106.756757 9.05405405 105.945946 8.78378378 105.540541 8.10810811 105.27027 7.83783784 105.135135 7.7027027 105 7.43243243 104.864865 7.02702703 104.459459 6.62162162 104.459459 6.35135135 104.864865 6.08108108 105.135135 5.81081081 105.27027 5.54054054 105.540541 5.27027027 105.675676 4.86486486 105.810811 4.59459459 105.405405 4.32432432 105.135135 4.59459459 104.864865 4.72972973 104.594595 5 104.324324 5.27027027 104.189189 5.67567568 104.054054 6.21621622 103.783784 6.35135135 103.378378 6.21621622 102.837838 6.08108108 102.297297 5.81081081 101.756757 5.54054054 101.216216 5.40540541 100.810811 5.27027027 100.810811 5 101.081081 4.59459459 101.351351 4.18918919 101.351351 4.05405405 100.945946 3.78378378 100.540541 4.18918919 100.27027 4.32432432 100.135135 5.27027027 99.3243243 5.27027027 97.972973 4.32432432 97.1621622 3.91891892 96.7567568 4.18918919 96.4864865 4.59459459 96.2162162 5.94594595 95.2702703 5.94594595 94.5945946 4.45945946 93.6486486 3.51351351 93.1081081 2.7027027 92.8378378 1.62162162 92.8378378 1.21621622 92.8378378.675675676 92.7027027.540540541 92.2972973.405405405 92.027027.540540541 91.7567568.675675676 91.6216216 1.08108108 91.3513514 1.48648649 91.2162162 1.89189189 91.3513514 2.02702703 91.3513514 2.2972973 91.4864865 2.43243243 91.6216216 3.37837838 92.5675676 4.59459459 92.7027027 5.81081081 92.972973 6.75675676 93.1081081 7.43243243 92.972973 7.97297297 92.1621622 8.37837838 91.4864865 8.91891892 91.0810811 9.72972973 91.0810811 10.1351351 91.0810811 10.2702703 90.9459459 10.2702703 90.5405405 10.2702703 90.5405405 10.2702703 90.4054054 10.2702703 90.4054054 11.3513514 89.1891892 10 88.5135135 9.45945946 87.7027027 7.56756757 85.2702703 5.81081081 82.8378378 4.32432432 80.1351351 3.91891892 79.4594595 3.51351351 78.9189189 2.83783784 78.5135135 2.16216216 78.1081081 1.75675676 77.4324324 1.35135135 76.7567568 1.21621622 76.3513514 1.21621622 75.9459459 1.62162162 75.6756757 2.02702703 75.4054054 2.43243243 75.4054054 2.83783784 75.6756757 3.24324324 75.9459459 3.64864865 76.3513514 3.91891892 76.7567568 4.59459459 77.8378378 5.40540541 78.7837838 6.75675676 79.3243243 8.24324324 79.8648649 9.05405405 81.0810811 8.78378378 82.7027027 7.97297297 85.1351351 9.59459459 86.4864865 10.8108108 88.2432432 11.2162162 88.7837838 11.7567568 88.7837838 12.1621622 88.1081081 12.4324324 87.7027027 12.7027027 87.4324324 12.972973 87.027027 13.3783784 86.4864865 13.3783784 86.0810811 13.1081081 85.4054054 12.972973 85.1351351 12.8378378 84.5945946 13.3783784 84.4594595 13.9189189 84.3243243 13.7837838 84.7297297 13.7837838 85.1351351 13.7837838 85.2702703 13.7837838 85.4054054 13.9189189 85.5405405 14.0540541 85.5405405 14.1891892 85.4054054 14.3243243 85.4054054 15.5405405 84.1891892 16.4864865 82.8378378 16.0810811 80.9459459 15.9459459 80.5405405 16.0810811 80.1351351 16.2162162 79.7297297 16.3513514 79.3243243 16.6216216 79.1891892 16.8918919 79.1891892 17.2972973 79.1891892 17.4324324 79.4594595 17.4324324 79.8648649 17.5675676 80.2702703 17.4324324 80.6756757 17.2972973 80.9459459 17.027027 81.4864865 16.8918919 82.1621622 16.7567568 82.8378378 16.6216216 83.5135135 16.6216216 84.3243243 17.2972973 84.7297297 17.972973 85.2702703 18.7837838 85.6756757 19.5945946 85.1351351 20 84.8648649 20.1351351 85.1351351 20.4054054 85.4054054 20.9459459 86.3513514 21.3513514 86.6216216 22.4324324 86.3513514 22.5675676 86.3513514 22.7027027 86.3513514 22.8378378 86.2162162 23.9189189 85.8108108 24.5945946 85.8108108 25.2702703 87.027027 25.6756757 87.8378378 26.3513514 88.9189189 27.4324324 89.1891892 27.5675676 89.1891892 27.7027027 89.3243243 27.7027027 89.4594595 28.1081081 90.5405405 28.7837838 90.9459459 29.8648649 90.1351351 30 90 30.2702703 90 30.4054054 90.2702703 30.5405405 90.5405405 30.4054054 90.6756757 30.1351351 90.8108108 29.1891892 91.4864865 29.0540541 91.7567568 30 92.5675676 30.8108108 93.1081081 30.8108108 94.1891892 29.7297297 94.5945946zM42.4324324 78.2432432C43.3783784 79.3243243 43.1081081 81.0810811 42.027027 81.8918919 41.0810811 82.5675676 39.8648649 82.2972973 38.9189189 81.2162162 37.972973 80.1351351 38.1081081 78.9189189 39.3243243 77.8378378 40.4054054 77.1621622 41.6216216 77.2972973 42.4324324 78.2432432zM17.8378378 71.2162162C18.5135135 71.8918919 18.5135135 73.3783784 17.972973 73.7837838 17.1621622 74.4594595 15.4054054 74.5945946 14.8648649 73.9189189 14.0540541 73.1081081 14.0540541 71.4864865 14.8648649 70.9459459 15.5405405 70.2702703 17.1621622 70.4054054 17.8378378 71.2162162zM28.9189189 83.2432432C29.7297297 82.5675676 30.2702703 82.7027027 30.8108108 83.3783784 31.4864865 84.1891892 31.3513514 85.4054054 30.5405405 86.0810811 29.8648649 86.4864865 28.9189189 86.4864865 28.3783784 85.9459459 27.8378378 85.1351351 28.1081081 83.9189189 28.9189189 83.2432432zM34.0540541 74.1891892C34.4594595 74.8648649 34.4594595 75.4054054 33.9189189 75.9459459 33.5135135 76.2162162 33.1081081 76.4864865 32.7027027 75.9459459 32.2972973 75.4054054 32.1621622 74.3243243 32.7027027 74.0540541 33.1081081 73.7837838 33.6486486 73.6486486 34.0540541 74.1891892z' })
					)
				)
			);
		};
	
		return Logo;
	}(_react.Component);
	
	Logo.defaultProps = {
		fill: '#525470',
		style: {}
	};
	exports.default = Logo;
	module.exports = exports['default'];

/***/ }),

/***/ 273:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(50);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _reactTypist = __webpack_require__(668);
	
	var _reactTypist2 = _interopRequireDefault(_reactTypist);
	
	var _Logo = __webpack_require__(68);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	var _MapButton = __webpack_require__(274);
	
	var _MapButton2 = _interopRequireDefault(_MapButton);
	
	var _MapModule = __webpack_require__(380);
	
	var _MapModule2 = _interopRequireDefault(_MapModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Map = function (_Component) {
		_inherits(Map, _Component);
	
		function Map() {
			var _temp, _this, _ret;
	
			_classCallCheck(this, Map);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = { isOnMap: false, mapWrapperBottom: '0px' }, _this._updateDimensions = function () {
				var maxW = 1000;
				var mapWrapper = _this.refs.mapWrapper;
				if (mapWrapper) {
					var mapW = mapWrapper.offsetWidth > maxW ? maxW : mapWrapper.offsetWidth;
					var mapH = mapW / (1920 / 2406);
					var wH = window.outerHeight;
	
					if (mapW >= maxW) {
						_this.setState({ mapWrapperBottom: '-' + (mapH - wH) / 2 + 'px' });
					}
				}
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		Map.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
			this.setState({ isOnMap: nextProps.isOnMap });
		};
	
		Map.prototype.componentDidMount = function componentDidMount() {
			this._updateDimensions();
			window.addEventListener("resize", this._updateDimensions);
		};
	
		Map.prototype.componentWillUnmount = function componentWillUnmount() {
			window.removeEventListener("resize", this._updateDimensions);
		};
	
		Map.prototype.render = function render() {
			var isOnMap = this.state.isOnMap;
			var _props = this.props,
			    bgImage = _props.bgImage,
			    bgPageImage = _props.bgPageImage,
			    places = _props.places;
	
			return _react2.default.createElement(
				'div',
				{ className: _MapModule2.default.mapContainer },
				_react2.default.createElement(_gatsbyImage2.default, { sizes: bgImage.sizes,
					className: _MapModule2.default.bgImageWrapper,
					outerWrapperClassName: _MapModule2.default.bgOuterImageWrapper }),
				_react2.default.createElement(
					'div',
					{ ref: 'mapWrapper', className: _MapModule2.default.interactiveMapWrapper, style: { bottom: this.state.mapWrapperBottom } },
					_react2.default.createElement(_gatsbyImage2.default, { sizes: bgPageImage.sizes,
						className: _MapModule2.default.bgPageImageWrapper,
						outerWrapperClassName: _MapModule2.default.bgPageOuterImageWrapper }),
					_react2.default.createElement(
						'div',
						{ className: _MapModule2.default.interactiveMapRoads },
						_react2.default.createElement(
							'svg',
							{ width: '100%', viewBox: '0 0 1920 2406', xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink' },
							_react2.default.createElement(
								'g',
								{ fill: 'none', fillRule: 'evenodd', transform: 'translate(410 720)', className: _MapModule2.default.showupPath, style: { opacity: isOnMap ? '1' : '0' } },
								_react2.default.createElement('path', { d: 'M393.768057,441.381478 C393.768057,441.381478 638.730057,734.400478 344.259057,774.325478 C49.7880573,814.252478 188.519057,865.506478 49.7880573,814.252478 C-88.9439427,762.998478 92.6680573,608.961478 223.832057,602.387478 C354.996057,595.814478 561.832057,625.101478 425.623057,245.578478 C289.414057,-133.944522 727.265057,-18.3525215 612.388057,231.374478 C497.511057,481.102478 606.791057,485.712478 606.791057,485.712478 C606.791057,485.712478 645.259057,172.299478 781.280057,384.696478 C917.301057,597.093478 333.556057,792.286478 218.788057,863.066478 C104.019057,933.845478 443.016057,993.815478 443.016057,993.815478 C443.016057,993.815478 640.590636,1036.64023 781.280057,844.533186 C895.66002,688.350895 721.309011,611.149454 763.164179,699.768779 C834.92787,851.712972 1160.76877,690.32127 1122.02757,485.712478', stroke: '#3D1F03', className: _MapModule2.default.path, strokeLinejoin: 'round', strokeMiterlimit: '10', strokeDasharray: '11.983 11.983', strokeWidth: '3', opacity: '.6' })
							),
							_react2.default.createElement(
								'g',
								{ fill: 'none', fillRule: 'evenodd' },
								places.map(function (place, index) {
									return place.enabled ? _react2.default.createElement(_MapButton2.default, { key: index, data: place, index: index, isOnMap: isOnMap }) : "";
								})
							)
						)
					)
				),
				_react2.default.createElement(
					'div',
					{ className: _MapModule2.default.copyWrapper },
					_react2.default.createElement(_Logo2.default, { containerClassName: _MapModule2.default.logoContainer, style: { marginBottom: isOnMap ? '-35px' : '10px' } }),
					isOnMap && _react2.default.createElement(
						_reactTypist2.default,
						{ className: _MapModule2.default.typist,
							startDelay: 800,
							cursor: { blink: true, hideWhenDone: false } },
						'Un recorrido sonoro por la obra de Jos\xE9 Eustasio Rivera'
					)
				)
			);
		};
	
		return Map;
	}(_react.Component);
	
	exports.default = Map;
	module.exports = exports['default'];

/***/ }),

/***/ 380:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"mapContainer":"src-components-Map----Map-module---mapContainer---r3Pxs","bgOuterImageWrapper":"src-components-Map----Map-module---bgOuterImageWrapper---u3odR","bgImageWrapper":"src-components-Map----Map-module---bgImageWrapper---3YDfh","bgPageOuterImageWrapper":"src-components-Map----Map-module---bgPageOuterImageWrapper---3fUy0","interactiveMapWrapper":"src-components-Map----Map-module---interactiveMapWrapper---25kRi","interactiveMapRoads":"src-components-Map----Map-module---interactiveMapRoads---2andG","showupPath":"src-components-Map----Map-module---showupPath---125FT","path":"src-components-Map----Map-module---path---6sYIQ","dash":"src-components-Map----Map-module---dash---3BJn5","controlButton":"src-components-Map----Map-module---controlButton---14IsK","controlText":"src-components-Map----Map-module---controlText---2LJhF","controlButtonArrow":"src-components-Map----Map-module---controlButtonArrow---3cYYn","controlButtonArrowHover":"src-components-Map----Map-module---controlButtonArrowHover---2viX7","copyWrapper":"src-components-Map----Map-module---copyWrapper---2cgc1","logoContainer":"src-components-Map----Map-module---logoContainer---1zX8X","typist":"src-components-Map----Map-module---typist---2eDW_","blinker":"src-components-Map----Map-module---blinker---y_qaP"};

/***/ }),

/***/ 274:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(26);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _SiteConfig = __webpack_require__(16);
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	var _MapButtonModule = __webpack_require__(381);
	
	var _MapButtonModule2 = _interopRequireDefault(_MapButtonModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SHADOW_IMAGE = "data:image/png;base64,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";
	
	var MapButton = function (_Component) {
		_inherits(MapButton, _Component);
	
		function MapButton() {
			var _temp, _this, _ret;
	
			_classCallCheck(this, MapButton);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.mapButtonOnClick = function () {
				var data = _this.props.data;
	
				var pathPrefix = _SiteConfig2.default.pathPrefix === "/" ? "" : _SiteConfig2.default.pathPrefix;
				(0, _gatsbyLink.push)('' + pathPrefix + data.href);
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		MapButton.prototype.render = function render() {
			var _props = this.props,
			    data = _props.data,
			    index = _props.index,
			    isOnMap = _props.isOnMap;
	
			return _react2.default.createElement(
				_react.Fragment,
				null,
				_react2.default.createElement(
					'defs',
					null,
					_react2.default.createElement('path', { id: 'map-button-a-' + index, d: 'M131.380952,59.286142 C131.380952,89.5301335 103.451331,114.047619 69.0004284,114.047619 C34.5478125,114.047619 6.61904762,89.5301335 6.61904762,59.286142 C6.61904762,29.0412951 34.5478125,4.52380952 69.0004284,4.52380952 C103.451331,4.52380952 131.380952,29.0412951 131.380952,59.286142' })
				),
				_react2.default.createElement(
					'g',
					{ fill: 'none', transform: 'translate(' + data.position.x + ' ' + data.position.y + ')', className: _MapButtonModule2.default.mapButton, style: { opacity: isOnMap ? '1' : '0', transition: 'opacity ' + index / 5 + 's ease-in' } },
					_react2.default.createElement(
						'g',
						{ transform: 'translate(18 47)', onClick: this.mapButtonOnClick },
						_react2.default.createElement('image', { width: '150.476', height: '135.238', x: '8.524', y: '.714', xlinkHref: SHADOW_IMAGE, opacity: '0.4' }),
						_react2.default.createElement(
							'mask',
							{ id: 'map-button-b-' + index, fill: '#fff' },
							_react2.default.createElement('use', { xlinkHref: '#map-button-a-' + index })
						),
						_react2.default.createElement('use', { fill: '#5E2D13', xlinkHref: '#map-button-a-' + index }),
						_react2.default.createElement('image', { xlinkHref: data.image.childImageSharp.resolutions.src, height: '140', width: '140', x: '-5', y: '-10', mask: 'url(#map-button-b-' + index + ')' }),
						_react2.default.createElement('path', { fill: '#5E2D13', d: 'M5.34752278,52.3336148 C1.65655416,80.2344941 23.5525368,98.6017611 42.2169968,104.804805 C22.6969576,92.3858971 8.60129044,76.545828 5.34752278,52.3336148 M91.5642378,8.14995791 C91.6583515,8.60719526 91.6472289,8.74222984 91.6985637,8.77214257 C92.3137251,9.1336592 92.9314533,9.49090258 93.5611596,9.82677974 C103.666405,15.2221804 112.481438,22.1832986 119.182334,31.5382892 C130.670196,47.5783463 133.818727,64.7303021 125.601745,83.2402955 C123.266013,88.5006616 119.940377,93.1277327 116.331544,97.4992636 C129.94552,84.3419384 134.138714,68.1762479 130.280052,50.030335 C125.760027,28.7692257 112.613197,14.9709136 91.5642378,8.14995791 M69.2609994,110.455746 C82.2384246,110.363444 93.2283393,107.987519 103.283962,101.940876 C124.769266,89.021143 132.669684,62.1090929 121.284492,39.842916 C112.559296,22.7789891 98.2249218,12.5984073 80.1234328,7.25855875 C74.5424898,5.61250429 68.8426212,4.92622095 63.0956958,5.90393969 C48.6731974,8.35763768 35.6795162,13.9496077 24.3131467,23.3507494 C9.5937623,35.5243733 5.29961035,51.5242619 12.6233682,69.0984144 C17.3230647,80.3746566 25.0617785,89.3963341 34.6280094,96.8129802 C45.1935568,105.003084 56.7849437,110.756583 69.2609994,110.455746 M67.1297517,1.80931514 C72.0424874,1.47258333 78.0306861,1.73325136 83.9358937,3.09043436 C96.3400808,5.94154425 107.692761,11.2378056 116.816658,20.0218906 C127.605511,30.4084429 133.930808,43.3333035 135.015683,58.5340951 C135.919174,71.2051248 133.385804,82.9984298 125.880663,93.407203 C116.954406,105.784233 104.298678,111.941981 89.5724494,114.288848 C82.1682671,115.469119 74.7580957,115.068288 67.338513,113.905965 C58.7296752,112.557329 50.1353822,111.247151 42.0321917,107.844793 C28.4139377,102.128899 16.8071505,93.8533299 8.56450054,81.3728869 C-3.31778325,63.3791016 -1.2190475,41.0650644 13.7706999,25.549762 C15.1250818,24.1481372 16.1320985,22.7542043 16.7156035,20.6944996 C17.975016,16.2494688 21.5367922,13.3983589 25.4322443,11.2292592 C38.0357813,4.20746093 51.5539325,0.919625271 67.1297517,1.80931514' })
					),
					_react2.default.createElement(
						'text',
						{ className: _MapButtonModule2.default.titleText, fill: '#68300F', fontSize: '35' },
						_react2.default.createElement(
							'tspan',
							{ x: '85', y: '44', textAnchor: 'middle' },
							data.title
						)
					)
				)
			);
		};
	
		return MapButton;
	}(_react.Component);
	
	exports.default = MapButton;
	module.exports = exports['default'];

/***/ }),

/***/ 381:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"titleText":"src-components-MapButton----MapButton-module---titleText---1-vPF","mapButton":"src-components-MapButton----MapButton-module---mapButton---9gLJ5"};

/***/ }),

/***/ 55:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(39);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _SiteConfig = __webpack_require__(16);
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SEO = function (_Component) {
	  _inherits(SEO, _Component);
	
	  function SEO() {
	    _classCallCheck(this, SEO);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  SEO.prototype.render = function render() {
	    var _props = this.props,
	        postNode = _props.postNode,
	        postPath = _props.postPath,
	        postSEO = _props.postSEO,
	        postTitle = _props.postTitle;
	
	    var title = void 0;
	    var description = void 0;
	    var image = void 0;
	    var type = void 0;
	    var postURL = void 0;
	    if (postSEO) {
	      var postMeta = postNode.frontmatter;
	      title = postMeta.title;
	
	      description = postMeta.description ? postMeta.description : postNode.excerpt;
	      image = postMeta.cover !== undefined ? postMeta.cover : _SiteConfig2.default.pathPrefix + _SiteConfig2.default.siteCover;
	      postURL = _SiteConfig2.default.siteUrl + postPath;
	      type = postMeta.type !== undefined ? postMeta.type : 'article';
	    } else {
	      title = postTitle ? postTitle : _SiteConfig2.default.metaTitle;
	      description = _SiteConfig2.default.metaDescription;
	      image = _SiteConfig2.default.pathPrefix + _SiteConfig2.default.siteCover;
	      type = 'Capítulo';
	    }
	
	    image = _SiteConfig2.default.siteUrl + image;
	    var blogURL = _SiteConfig2.default.siteUrl + _SiteConfig2.default.pathPrefix;
	    var schemaOrgJSONLD = [{
	      "@context": "http://schema.org",
	      "@type": "WebSite",
	      url: blogURL,
	      name: title,
	      alternateName: _SiteConfig2.default.siteTitleAlt ? _SiteConfig2.default.siteTitleAlt : ""
	    }];
	    if (postSEO) {
	      schemaOrgJSONLD.push([{
	        "@context": "http://schema.org",
	        "@type": "BreadcrumbList",
	        itemListElement: [{
	          "@type": "ListItem",
	          position: 1,
	          item: {
	            "@id": postURL,
	            name: title,
	            image: image
	          }
	        }]
	      }, {
	        "@context": "http://schema.org",
	        "@type": type,
	        url: blogURL,
	        name: title,
	        alternateName: _SiteConfig2.default.siteTitleAlt ? _SiteConfig2.default.siteTitleAlt : "",
	        headline: title,
	        image: {
	          "@type": "ImageObject",
	          url: image
	        },
	        description: description
	      }]);
	    }
	    return _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement('meta', { name: 'keywords', content: _SiteConfig2.default.metaKeywords }),
	      _react2.default.createElement('meta', { name: 'description', content: description }),
	      _react2.default.createElement('meta', { name: 'image', content: image }),
	      _react2.default.createElement(
	        'script',
	        { type: 'application/ld+json' },
	        JSON.stringify(schemaOrgJSONLD)
	      ),
	      _react2.default.createElement('meta', { property: 'og:url', content: postSEO ? postURL : blogURL }),
	      postSEO ? _react2.default.createElement('meta', { property: 'og:type', content: 'article' }) : null,
	      _react2.default.createElement('meta', { property: 'og:title', content: title }),
	      _react2.default.createElement('meta', { property: 'og:description', content: description }),
	      _react2.default.createElement('meta', { property: 'og:image', content: image }),
	      _react2.default.createElement('meta', {
	        property: 'fb:app_id',
	        content: _SiteConfig2.default.siteFBAppID ? _SiteConfig2.default.siteFBAppID : ""
	      }),
	      _react2.default.createElement('meta', { name: 'twitter:card', content: 'summary_large_image' }),
	      _react2.default.createElement('meta', { name: 'twitter:creator', content: _SiteConfig2.default.siteCreator }),
	      _react2.default.createElement('meta', { name: 'twitter:title', content: title }),
	      _react2.default.createElement('meta', { name: 'twitter:description', content: description }),
	      _react2.default.createElement('meta', { name: 'twitter:image', content: image }),
	      _react2.default.createElement(
	        'title',
	        null,
	        title
	      )
	    );
	  };
	
	  return SEO;
	}(_react.Component);
	
	exports.default = SEO;
	module.exports = exports['default'];

/***/ }),

/***/ 278:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _videoReact = __webpack_require__(713);
	
	var _backgroundCover = __webpack_require__(291);
	
	var _backgroundCover2 = _interopRequireDefault(_backgroundCover);
	
	__webpack_require__(388);
	
	var _VideoCoverModule = __webpack_require__(385);
	
	var _VideoCoverModule2 = _interopRequireDefault(_VideoCoverModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var VideoCover = function (_Component) {
		_inherits(VideoCover, _Component);
	
		function VideoCover() {
			_classCallCheck(this, VideoCover);
	
			return _possibleConstructorReturn(this, _Component.apply(this, arguments));
		}
	
		VideoCover.prototype.componentDidMount = function componentDidMount() {
			// this.player.playbackRate = 0.1;
	
			var video = this.player.video.video;
			var videoContainer = this.player.manager.rootElement;
			video.addEventListener('loadedmetadata', function () {
				(0, _backgroundCover2.default)(video, videoContainer);
			});
		};
	
		VideoCover.prototype.render = function render() {
			var _this2 = this;
	
			return _react2.default.createElement(
				_videoReact.Player,
				_extends({}, this.props, {
					ref: function ref(el) {
						return _this2.player = el;
					},
					fluid: false,
					width: '100%',
					height: '100%',
					autoPlay: true,
					playsInline: true,
					loop: true,
					muted: true,
					className: _VideoCoverModule2.default.player }),
				_react2.default.createElement(_videoReact.ControlBar, { disableCompletely: true })
			);
		};
	
		return VideoCover;
	}(_react.Component);
	
	exports.default = VideoCover;
	module.exports = exports['default'];

/***/ }),

/***/ 385:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"player":"src-components-VideoCover----VideoCover-module---player---3eMzR","bigPlayButton":"src-components-VideoCover----VideoCover-module---bigPlayButton---sNGdQ"};

/***/ }),

/***/ 282:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyPluginPageTransitions = __webpack_require__(85);
	
	var _gatsbyPluginPageTransitions2 = _interopRequireDefault(_gatsbyPluginPageTransitions);
	
	var _HomePage = __webpack_require__(272);
	
	var _HomePage2 = _interopRequireDefault(_HomePage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IndexPage = function (_Component) {
	  _inherits(IndexPage, _Component);
	
	  function IndexPage() {
	    _classCallCheck(this, IndexPage);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  IndexPage.prototype.render = function render() {
	    return _react2.default.createElement(
	      _gatsbyPluginPageTransitions2.default,
	      null,
	      _react2.default.createElement(_HomePage2.default, this.props)
	    );
	  };
	
	  return IndexPage;
	}(_react.Component);
	
	exports.default = IndexPage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-126d125a8440128da8e7.js